import React, { useState, useRef, useContext, useEffect, useCallback, useMemo } from 'react';
import {
  CircularProgress, Container, Typography, Box, Grid, CardContent, Button, TextField, Select,
  MenuItem, InputLabel, FormControl, Slider, Accordion, AccordionSummary,
  AccordionDetails, Divider, Paper, Avatar, List, ListItem, ListItemAvatar,
  ListItemText, ListItemIcon, LinearProgress, Dialog, DialogTitle, DialogContent,
  DialogActions, IconButton, Tooltip, Collapse, Badge, Chip, Snackbar, Alert,
  Menu, Checkbox, Skeleton, Fade, Zoom, useMediaQuery, alpha, useTheme, InputAdornment,
  Card, CardHeader, CardActions
} from '@mui/material';
import {
  ExpandMore, CreditScore, BarChart, Logout, RocketLaunch, CheckCircle,
  PlayCircle, Pause, Replay, Share, FileDownload, Help, Lightbulb,
  TrendingUp, Paid, Insights, Science, Engineering, LocalShipping,
  Compare, Visibility, Delete, MoreVert, FolderSpecial, Settings, Tune, Functions,
  CompareArrows, Analytics, Psychology, Search, ArrowBack, BubbleChart, Timeline, ArrowForward as ArrowForwardIcon
} from '@mui/icons-material';
import { Close } from '@mui/icons-material';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@mui/material';

import { styled } from '@mui/material/styles';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { UIContext } from '../contexts/UIContext';
import { ScenarioContext } from '../contexts/ScenarioContext';
import axios from 'axios';
import { debounce } from 'lodash';
import ScenarioSaveDialog from './scenarios/ScenarioSaveDialog';
import TuningDialog from './analysis/TuningDialog';
import HolographicCard from './ui/HolographicCard';
import AnimatedCounter from './ui/AnimatedCounter';
import DynamicGradientText from './ui/DynamicGradientText';
import PackageSelector from './PackageSelector';

import { currencies, getCurrencySymbol } from '../data/currencies'; 

import defaultParameters from '../data/parameters';
import { categories } from '../data/categories';
import { sliderLabels } from '../data/sliderLabels';
import { factorTooltips } from '../data/factorTooltips';
import { getNumericImpact } from '../data/new_Sliderlables';
import { matrixScores } from '../data/new_matrixScores';
import { maxImpactPercents } from '../data/maxImpactPercents';
//import { labelInsights } from '../data/labelInsights';

import { labelInsights } from '../data/labelInsights';
import { useSnackbar } from 'notistack';
import GuidelineScenarioCard from './GuidelineScenarioCard';
import defaultGuidelineScenarios from '../data/defaultGuidelineScenarios';
import ScenarioCard from './scenarios/ScenarioCard';

import { OpenInNew } from '@mui/icons-material';

import { ExpandLess } from '@mui/icons-material';

// Add these imports near the top with other imports
import { dimensionsData } from '../data/ValueDimensions';
import {
  AppBar,
  Toolbar
} from '@mui/material';
import {
  ZoomIn as ZoomInIcon,
  ZoomOut as ZoomOutIcon,
  Close as CloseIcon
} from '@mui/icons-material';


import { 
  EnhancedRadar,
  DimensionTooltip,
  AnimatedNumber
} from './MaturityComparisonDashboard';

import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';

import { Radar } from 'react-chartjs-2';

import QuantumPurchaseModal from './QuantumPurchaseModal';

import { 
   CreditCard // Make sure CreditCard is imported
} from '@mui/icons-material'


import AccountTreeIcon from '@mui/icons-material/AccountTree';
import SettingsIcon from '@mui/icons-material/Settings';
import GroupWorkIcon from '@mui/icons-material/GroupWork';
import DatasetIcon from '@mui/icons-material/Dataset';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import WarningIcon from '@mui/icons-material/Warning';
import { Info as InfoIcon } from '@mui/icons-material';

import { SliderThumb } from '@mui/material';

// Add import at the top of ROIAnalyzer.js
/* 
import {
  useCurrency,
  CREDIT_PACKAGES,
  BASE_CURRENCY,
  BASE_CURRENCY_SYMBOL
} from '../utils/currencyUtils';
// Keep these imports from currencyUtils:
 */
import { CREDIT_PACKAGES } from '../utils/currencyUtils';
// Add this import instead:
import { useCurrency } from '../hooks/useCurrency';

import { MasterTemplateDialog, masterTemplateScenarios } from './masterTemplateScenarios';


import {
  Assessment as AssessmentIcon,
  CheckCircle as CheckCircleIcon,
  Timeline as TimelineIcon,
  Engineering as EngineeringIcon,
  Delete as DeleteIcon,
  FlashOn as FlashOnIcon,
  Build as BuildIcon,
  Science as ScienceIcon,
  Lightbulb as LightbulbIcon,
  Copyright as CopyrightIcon,
  Gavel as GavelIcon,
  Checklist as ChecklistIcon,
  Description as DescriptionIcon,
  School as SchoolIcon,
  Public as PublicIcon,
  Category as CategoryIcon,
  AttachMoney as AttachMoneyIcon,
  People as PeopleIcon,
  Recycling as RecyclingIcon,
  WaterDrop as WaterDropIcon,
  Diversity3 as Diversity3Icon,
  Inventory as InventoryIcon,
  Schedule as ScheduleIcon,
  Autorenew as AutorenewIcon,
  Radar as RadarIcon
} from '@mui/icons-material';

import AdvancedCapabilitiesMatrix from './AdvancedCapabilitiesMatrix';

//bubble chart
import { Build } from '@mui/icons-material';

// Replace the problematic Chart.js import with this:
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip as ChartTooltip, // Alias this import
  Legend,
  LinearScale
} from 'chart.js';

// Register with the aliased Tooltip
ChartJS.register(
  RadialLinearScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
  ChartTooltip, // Use the aliased name here
  Legend
);

process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DEBUG && console.log('dimensionsData:', dimensionsData); // Should show your object
process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DEBUG && console.log('sustainabilityPressure:', dimensionsData?.sustainabilityPressure); // Safe access
  
// Constants
const VALUE_MAP = {
  0: 0, 1: 0.1, 2: 0.2, 3: 0.3, 4: 0.4, 5: 0.5,
  6: 0.65, 7: 0.8, 8: 0.9, 9: 0.95, 10: 1.0
};


// Watermark component
const Watermark = ({ text = "eEvolve.ai", opacity = 0.1, fontSize = 48 }) => (
  <Box
    sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%) rotate(-45deg)',
      opacity: opacity,
      pointerEvents: 'none',
      zIndex: 1000,
      userSelect: 'none'
    }}
  >
    <Typography
      variant="h4"
      sx={{
        fontSize: fontSize,
        fontWeight: 'bold',
        color: 'text.secondary',
        whiteSpace: 'nowrap'
      }}
    >
      {text}
    </Typography>
  </Box>
);

// Styled Components
const AnimatedCard = styled(motion.div)(({ theme }) => ({
  transition: 'all 0.3s ease',
  '&:hover': {
    transform: 'translateY(-5px)',
    boxShadow: theme.shadows[10]
  }
}));

//mock bubble chart data
const mockScenarios = [
    { _id: '1', name: 'Digital Transformation', totalImpact: 5000000, implementationComplexity: 8.5, roiRatio: 3.2, timeline: '12 months' },
    { _id: '2', name: 'Process Automation', totalImpact: 2500000, implementationComplexity: 4.2, roiRatio: 5.1, timeline: '6 months' },
    { _id: '3', name: 'Customer Portal', totalImpact: 1800000, implementationComplexity: 6.8, roiRatio: 2.8, timeline: '9 months' },
    { _id: '4', name: 'AI Implementation', totalImpact: 7500000, implementationComplexity: 9.2, roiRatio: 4.5, timeline: '18 months' },
    { _id: '5', name: 'Mobile App', totalImpact: 1200000, implementationComplexity: 5.5, roiRatio: 3.8, timeline: '8 months' },
    { _id: '6', name: 'Cloud Migration', totalImpact: 3200000, implementationComplexity: 7.3, roiRatio: 2.9, timeline: '10 months' },
    { _id: '7', name: 'Data Analytics', totalImpact: 2100000, implementationComplexity: 6.1, roiRatio: 4.2, timeline: '7 months' },
    { _id: '8', name: 'Security Upgrade', totalImpact: 900000, implementationComplexity: 3.8, roiRatio: 2.1, timeline: '4 months' }
  ];

  // Use processedScenarios if available, otherwise use mock data
//  const scenariosToUse = processedScenarios && processedScenarios.length > 0 ? processedScenarios : mockScenarios;


const GlowingButton = styled(Button)(({ theme }) => ({
  position: 'relative',
  overflow: 'hidden',
  '&:after': {
    content: '""',
    position: 'absolute',
    top: '-50%',
    left: '-50%',
    width: '200%',
    height: '200%',
    background: `linear-gradient(45deg, transparent, ${theme.palette.primary.light}, transparent)`,
    transform: 'rotate(45deg)',
    transition: 'all 0.5s ease',
    opacity: 0
  },
  '&:hover:after': {
    opacity: 0.6,
    animation: 'shine 1.5s infinite'
  },
  '@keyframes shine': {
    '0%': { left: '-50%' },
    '100%': { left: '150%' }
  }
}));


const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  '& .MuiTooltip-tooltip': {
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    fontSize: '0.875rem',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '8px',
    padding: '8px 12px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    maxWidth: '300px',
    // Ensure full background coverage
    background: theme.palette.background.paper, // Use background instead of backgroundColor
    position: 'relative'
  },
  '& .MuiTooltip-arrow': {
    '&::before': {
      backgroundColor: theme.palette.background.paper,
      border: `1px solid ${theme.palette.divider}`,
      // Remove the default color property if it's causing issues
      color: theme.palette.background.paper
    }
  }
}));



// Custom track component
const CustomTrack = styled('span')(({ theme, values }) => {
  const [current, target] = values;
  const isImprovement = current <= target;
  
  return {
    position: 'absolute',
    height: 8,
    // Current to target range (red for negative, green for positive)
    left: `${Math.min(current, target) * 10}%`,
    width: `${Math.abs(target - current) * 10}%`,
    backgroundColor: isImprovement ? theme.palette.success.main : theme.palette.error.main,
    borderRadius: '4px',
    
    // Remaining track portions
    '&:before': {
      content: '""',
      position: 'absolute',
      height: '100%',
      right: '100%',
      width: `${Math.min(current, target) * 10}%`,
      backgroundColor: theme.palette.grey[400],
      borderRadius: '4px 0 0 4px',
    },
    
    '&:after': {
      content: '""',
      position: 'absolute',
      height: '100%',
      left: '100%',
      width: `${(10 - Math.max(current, target)) * 10}%`,
      backgroundColor: theme.palette.grey[400],
      borderRadius: '0 4px 4px 0',
    }
  };
});

// Create a stable ResetDialog component with proper state management
// Create a stable ResetDialog component outside of the main component to prevent re-renders
const StableResetDialog = React.memo(({ open, onClose, onConfirm }) => {
  const [currentValue, setCurrentValue] = useState(0);
  const [targetValue, setTargetValue] = useState(5);
  const sampleFactor = 'operational_efficiency';

  // Reset values when dialog opens
  useEffect(() => {
    if (open) {
      setCurrentValue(0);
      setTargetValue(5);
    }
  }, [open]);

  const handleConfirm = useCallback(() => {
    onConfirm({ current: currentValue, target: targetValue });
    onClose();
  }, [currentValue, targetValue, onConfirm, onClose]);

  const handleCurrentChange = useCallback((event) => {
    setCurrentValue(parseInt(event.target.value));
  }, []);

  const handleTargetChange = useCallback((event) => {
    setTargetValue(parseInt(event.target.value));
  }, []);

  // Only render if open
  if (!open) return null;

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="sm" 
      fullWidth
      disableRestoreFocus
      PaperProps={{
        sx: {
          // Fixed positioning to prevent re-layout
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }
      }}
    >
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Replay /> Reset Configuration
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Set default values for all sliders. All factors will be reset to these values.
        </Typography>
        
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <InputLabel>Current Level</InputLabel>
              <Select
                value={currentValue}
                onChange={handleCurrentChange}
                label="Current Level"
                MenuProps={{
                  transitionDuration: 0,
                  disablePortal: true,
                  // Keep menu in DOM to prevent re-renders
                  keepMounted: true,
                }}
              >
                {Array.from({ length: 11 }, (_, i) => {
                  const label = sliderLabels[sampleFactor]?.[i] || '';
                  return (
                    <MenuItem key={`current-${i}`} value={i}>
                      Level {i} {label && `- ${label}`}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <InputLabel>Target Level</InputLabel>
              <Select
                value={targetValue}
                onChange={handleTargetChange}
                label="Target Level"
                MenuProps={{
                  transitionDuration: 0,
                  disablePortal: true,
                  keepMounted: true,
                }}
              >
                {Array.from({ length: 11 }, (_, i) => {
                  const label = sliderLabels[sampleFactor]?.[i] || '';
                  return (
                    <MenuItem key={`target-${i}`} value={i}>
                      Level {i} {label && `- ${label}`}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        
        <Box sx={{ mt: 2, p: 2, bgcolor: 'grey.50', borderRadius: 1 }}>
          <Typography variant="caption" color="text.secondary">
            💡 Tip: Level 0 = No implementation, Level 10 = Full optimization
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button 
          onClick={handleConfirm}
          variant="contained"
          startIcon={<CheckCircle />}
        >
          Apply Reset
        </Button>
      </DialogActions>
    </Dialog>
  );
}, (prevProps, nextProps) => {
  // Only re-render if open state changes
  return prevProps.open === nextProps.open;
});

StableResetDialog.displayName = 'StableResetDialog';


// Custom thumb component with color coding

const CustomThumb = React.forwardRef((props, ref) => {
  const safeProps = props || {};
  const { 'data-index': dataIndex, ...other } = safeProps;
  const isTarget = dataIndex === 1;
  
  // Enhanced colors with glow effects
  const thumbColors = {
    current: {
      main: '#FF4444',
      hover: '#FF0000',
      glow: 'rgba(255, 68, 68, 0.4)',
      shadow: '0 0 20px rgba(255, 68, 68, 0.6)'
    },
    target: {
      main: '#00C851',
      hover: '#00E676', 
      glow: 'rgba(0, 200, 81, 0.4)',
      shadow: '0 0 20px rgba(0, 200, 81, 0.6)'
    }
  };
  
  const colors = isTarget ? thumbColors.target : thumbColors.current;

  return (
<SliderThumb
  {...other}
  ref={ref}
  sx={{
    width: 22,
    height: 22,
    backgroundColor: colors.main,
    border: `3px solid white`,
    boxShadow: `
      ${colors.shadow}, 
      0 2px 8px rgba(0,0,0,0.3),
      inset 0 0 12px ${colors.glow},
      0 0 8px ${colors.glow}
    `,
    borderRadius: '50%',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    position: 'relative',
    '&:hover': {
      backgroundColor: colors.hover,
      transform: 'scale(1.3)',
      boxShadow: `
        ${colors.shadow}, 
        0 4px 16px rgba(0,0,0,0.4),
        inset 0 0 16px ${colors.glow},
        0 0 12px ${colors.glow}
      `,
    },
    '&.Mui-active': {
      transform: 'scale(1.4)',
      boxShadow: `
        inset 0 0 20px ${colors.glow},
        0 0 20px ${colors.glow},
        ${colors.shadow}
      `,
    },
    '&.Mui-focusVisible': {
      boxShadow: `
        inset 0 0 16px ${colors.glow},
        0 0 16px ${colors.glow},
        ${colors.shadow}
      `,
    },
    // Add pseudo-element for enhanced center glow
    '&::before': {
      content: '""',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '8px',
      height: '8px',
      backgroundColor: colors.glow,
      borderRadius: '50%',
      filter: 'blur(4px)',
      opacity: 0.8,
      transition: 'all 0.3s ease',
    },
    '&:hover::before': {
      width: '10px',
      height: '10px',
      filter: 'blur(6px)',
      opacity: 1,
    },
    '&.Mui-active::before': {
      width: '12px',
      height: '12px',
      filter: 'blur(8px)',
      opacity: 1,
    },
    // Tooltip styles
    '& .MuiSlider-valueLabel': {
      backgroundColor: 'white',
      color: '#1976d2 !important',
      borderRadius: '6px',
      padding: '6px 10px',
      fontSize: '0.75rem',
      fontWeight: '600',
      minWidth: '20px',
      height: 'auto',
      border: '1px solid #e0e0e0',
      '&:before': {
        display: 'none',
      },
      '& > *': {
        backgroundColor: 'transparent !important',
        color: '#2e7d32 !important',
      }
    },
    '&:nth-of-type(2) .MuiSlider-valueLabel': {
      color: 'inherit !important',
    }
  }}
/>

  );
});


// Now 

//_______________________________________________________________________
// Create this new component near the top of your file with other styled components
// Replace the DualColorSlider styled component with this fixed version
const DualColorSlider = styled(Slider)(({ theme }) => ({
  color: theme.palette.primary.main,
  height: 5,
  '& .MuiSlider-track': {
    border: 'none',
    background: 'transparent',
  },
  '& .MuiSlider-rail': {
    opacity: 1,
    backgroundColor: theme.palette.grey[300],
  },
  '& .MuiSlider-thumb': {
    height: 24,
    width: 24,
    backgroundColor: '#fff',
    border: `2px solid currentColor`,
    '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
      boxShadow: 'inherit',
    },
    '&:before': {
      display: 'none',
    },
  },
  '& .MuiSlider-valueLabel': {
    lineHeight: 1.2,
    fontSize: 12,
    background: 'unset',
    padding: 0,
    width: 32,
    height: 32,
    borderRadius: '50% 50% 50% 0',
    backgroundColor: theme.palette.primary.main, // Fixed: Use theme color directly
    transformOrigin: 'bottom left',
    transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
    '&:before': { display: 'none' },
    '&.MuiSlider-valueLabelOpen': {
      transform: 'translate(50%, -100%) rotate(-45deg) scale(1)',
    },
    '& > *': {
      transform: 'rotate(45deg)',
    },
  },
}));
//_______________________________________________________________________

//********************************************
// Create the new component (can be defined above the ROIAnalyzer component)
// Enhanced FactorSlider component with real-time visualization
// Enhanced FactorSlider  component with integrated maturity dashboard visualization

const FactorSlider = ({
  factor,
  factorData, // This should be exactly {current: number, target: number}
  onSliderChange,
  activeFactor,
  setActiveFactor,
  getFactorImpact,
  sliderLabels,
  theme,
  factorTooltips,
  currency,
  industry
}) => {
  const [expanded, setExpanded] = useState(true);
  const [isDragging, setIsDragging] = useState(false);
  const [viewMode, setViewMode] = useState('insights');
  const key = factor.key;
  const tooltip = factorTooltips[key] || '';
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  // ✅ SIMPLE DIRECT LOGGING
  useEffect(() => {
    console.log(`🎯 FactorSlider "${key}" received:`, {
      factorData: factorData,
      factorKey: key,
      factorLabel: factor.label,
      current: factorData?.current,
      target: factorData?.target,
      isValid: factorData && typeof factorData.current === 'number' && typeof factorData.target === 'number'
    });
  }, [key, factor.label, factorData]);

  // ✅ Use factorData directly with safety checks
  const currentValue = factorData && typeof factorData.current === 'number' ? factorData.current : 0;
  const targetValue = factorData && typeof factorData.target === 'number' ? factorData.target : 0;

  // Calculate impact
  const impact = useMemo(() => {
    try {
      const currentImpact = getFactorImpact(key, currentValue);
      const targetImpact = getFactorImpact(key, targetValue);
      return targetImpact - currentImpact;
    } catch (error) {
      console.error(`Error calculating impact for ${key}:`, error);
      return 0;
    }
  }, [key, currentValue, targetValue, getFactorImpact]);


  // ✅ Use factorValues as the source of truth when available
//  const effectiveCurrentValue = factorValues?.current !== undefined ? factorValues.current : currentValue;
//  const effectiveTargetValue = factorValues?.target !== undefined ? factorValues.target : targetValue;


  // Debug logging to verify values are received correctly
  useEffect(() => {
    process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DEBUG && console.log(`Factor ${factor.key} received values:`, { currentValue, targetValue });
  }, [factor.key, currentValue, targetValue]);


  // Get insights for current and target positions
  const currentInsights = useMemo(() => {
    return labelInsights[key]?.[sliderLabels[key]?.[currentValue]] || null;
  }, [key, currentValue, sliderLabels]);

  const targetInsights = useMemo(() => {
    return labelInsights[key]?.[sliderLabels[key]?.[targetValue]] || null;
  }, [key, targetValue, sliderLabels]);


   // Simplified slider handlers
  const handleSliderChange = (_, newValues) => {
    setIsDragging(true);
    onSliderChange(newValues);
  };

  const handleSliderChangeCommitted = () => {
    setIsDragging(false);
  };

  // Insight Card Component
  const InsightCard = ({ title, insights, value, color }) => {
    if (!insights) return null;

    return (
      <Paper 
        elevation={1} 
        sx={{ 
          p: 2, 
          mb: 2, 
          borderLeft: `4px solid ${color}`,
          backgroundColor: `${color}08`
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
          <Typography variant="subtitle2" fontWeight="bold" sx={{ color }}>
            {title}
          </Typography>
          <Chip 
            label={`Level ${value}`} 
            size="small" 
            sx={{ 
              backgroundColor: color,
              color: 'white',
              fontWeight: 'bold'
            }} 
          />
        </Box>
        
        <Typography variant="body2" gutterBottom sx={{ fontStyle: 'italic' }}>
          "{sliderLabels[key]?.[value]}"
        </Typography>

        <Box sx={{ mb: 1 }}>
          <Typography variant="caption" fontWeight="bold" color="text.secondary">
            Intent:
          </Typography>
          <Typography variant="body2" sx={{ ml: 1 }}>
            {insights.intent}
          </Typography>
        </Box>

        <Box sx={{ mb: 1 }}>
          <Typography variant="caption" fontWeight="bold" color="text.secondary">
            Keywords:
          </Typography>
          <Typography variant="body2" sx={{ ml: 1 }}>
            {insights.keywords}
          </Typography>
        </Box>

        <Box>
          <Typography variant="caption" fontWeight="bold" color="text.secondary">
            Industry Context:
          </Typography>
          <Typography variant="body2" sx={{ ml: 1 }}>
            {insights[industry] || insights.automotive || 'Context not available'}
          </Typography>
        </Box>
      </Paper>
    );
  };


  // Generate dynamic dimensions with realistic distributions based on factor type
  const dimensions = useMemo(() => {
    const baseDimensions = {
      'operational_efficiency': [
        { name: 'Process Standardization', icon: <AccountTreeIcon /> },
        { name: 'Workflow Automation', icon: <SettingsIcon /> },
        { name: 'Resource Utilization', icon: <GroupWorkIcon /> },
        { name: 'Error Reduction', icon: <WarningIcon /> },
        { name: 'Throughput Time', icon: <TimelineIcon /> }
      ],
      'cost_reduction': [
        { name: 'Material Costs', icon: <EngineeringIcon /> },
        { name: 'Labor Efficiency', icon: <EngineeringIcon /> },
        { name: 'Overhead Costs', icon: <AssessmentIcon /> },
        { name: 'Waste Reduction', icon: <DeleteIcon /> },
        { name: 'Energy Efficiency', icon: <FlashOnIcon /> }
      ],
      'time_to_market': [
        { name: 'Development Cycle', icon: <TimelineIcon /> },
        { name: 'Approval Processes', icon: <CheckCircleIcon /> },
        { name: 'Prototyping Speed', icon: <BuildIcon /> },
        { name: 'Testing Efficiency', icon: <ScienceIcon /> },
        { name: 'Launch Coordination', icon: <TimelineIcon /> }
      ],
      'innovation_capacity': [
        { name: 'R&D Investment', icon: <ScienceIcon /> },
        { name: 'Idea Generation', icon: <LightbulbIcon /> },
        { name: 'Prototyping', icon: <BuildIcon /> },
        { name: 'Cross-functional Collaboration', icon: <GroupWorkIcon /> },
        { name: 'Time-to-Patent', icon: <CopyrightIcon /> }
      ],
      'compliance_risk': [
        { name: 'Regulatory Tracking', icon: <GavelIcon /> },
        { name: 'Audit Preparedness', icon: <ChecklistIcon /> },
        { name: 'Documentation', icon: <DescriptionIcon /> },
        { name: 'Training Coverage', icon: <SchoolIcon /> },
        { name: 'Incident Response', icon: <WarningIcon /> }
      ],
      'revenue_growth': [
        { name: 'Market Expansion', icon: <PublicIcon /> },
        { name: 'Product Portfolio', icon: <CategoryIcon /> },
        { name: 'Pricing Strategy', icon: <AttachMoneyIcon /> },
        { name: 'Customer Retention', icon: <PeopleIcon /> },
        { name: 'Upsell Potential', icon: <TrendingUpIcon /> }
      ],
      'sustainability': [
        { name: 'Carbon Footprint', icon: <RecyclingIcon /> },
        { name: 'Energy Efficiency', icon: <FlashOnIcon /> },
        { name: 'Material Circularity', icon: <RecyclingIcon /> },
        { name: 'Water Usage', icon: <WaterDropIcon /> },
        { name: 'Social Responsibility', icon: <Diversity3Icon /> }
      ],
      'supply_chain_resilience': [
        { name: 'Supplier Diversity', icon: <AccountTreeIcon /> },
        { name: 'Inventory Optimization', icon: <InventoryIcon /> },
        { name: 'Lead Time Reduction', icon: <ScheduleIcon /> },
        { name: 'Risk Monitoring', icon: <WarningIcon /> },
        { name: 'Disruption Recovery', icon: <AutorenewIcon /> }
      ]
    };

    const selectedDimensions = baseDimensions[key] || [
      { name: 'Process Maturity', icon: <AccountTreeIcon /> },
      { name: 'Technology Adoption', icon: <SettingsIcon /> },
      { name: 'Organizational Alignment', icon: <GroupWorkIcon /> },
      { name: 'Data Quality', icon: <DatasetIcon /> },
      { name: 'ROI Realization', icon: <TrendingUpIcon /> }
    ];

    return selectedDimensions.map(dim => ({
      ...dim,
      description: `${dim.name} for ${factor.label}`,
      unit: '% maturity',
      category: dim.name.split(' ')[0]
    }));
  }, [key, factor.label]);

  // Generate dynamic values with realistic variation
  const generateValues = useCallback((baseValue) => {
    return dimensions.map((_, i) => {
      const position = i / (dimensions.length - 1);
      const variation = 0.3 * Math.sin(position * Math.PI * 2);
      const value = Math.min(100, Math.max(0, (baseValue * 10) + (variation * 20)));
      return Math.round(value * 10) / 10;
    });
  }, [dimensions]);

  // Radar chart data with smooth transitions
  const radarData = useMemo(() => ({
    labels: dimensions.map(d => d.name),
    datasets: [
      {
        label: 'Current Maturity',
        data: generateValues(currentValue),
        backgroundColor: 'rgba(99, 102, 241, 0.2)',
        borderColor: 'rgba(99, 102, 241, 1)',
        borderWidth: 2,
        pointBackgroundColor: 'rgba(99, 102, 241, 1)',
        pointRadius: 4,
        pointHoverRadius: 6
      },
      {
        label: 'Target Maturity',
        data: generateValues(targetValue),
        backgroundColor: 'rgba(16, 185, 129, 0.2)',
        borderColor: 'rgba(16, 185, 129, 1)',
        borderWidth: 2,
        pointBackgroundColor: 'rgba(16, 185, 129, 1)',
        pointRadius: 4,
        pointHoverRadius: 6
      }
    ]
  }), [currentValue, targetValue, dimensions, generateValues]);

  // Enhanced radar options with smooth animations
  const radarOptions = useMemo(() => ({
    responsive: true,
    animation: {
      duration: isDragging ? 0 : 300,
      easing: 'easeOutQuad'
    },
    scales: {
      r: {
        angleLines: { display: true, color: 'rgba(0, 0, 0, 0.05)' },
        suggestedMin: 0,
        suggestedMax: 100,
        ticks: { 
          stepSize: 20,
          backdropColor: 'transparent',
          color: theme.palette.text.secondary
        },
        pointLabels: {
          font: { size: 10 },
          color: theme.palette.text.primary,
          callback: (value) => value.length > 15 ? `${value.substring(0, 15)}...` : value
        }
      }
    },
    plugins: {
      legend: { 
        position: 'top',
        labels: {
          boxWidth: 12,
          padding: 20,
          font: { weight: 'bold' }
        }
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            const dim = dimensions[context.dataIndex];
            return [
              `${dim.name}: ${context.raw}%`,
              `Description: ${dim.description}`,
              `Unit: ${dim.unit}`
            ];
          }
        }
      }
    },
    elements: {
      line: {
        tension: 0.1
      }
    }
  }), [dimensions, theme, isDragging]);

  // Calculate improvement potential for each dimension
  const improvementPotential = useMemo(() => {
    return dimensions.map((_, i) => {
      const current = generateValues(currentValue)[i];
      const target = generateValues(targetValue)[i];
      return Math.round(target - current);
    });
  }, [dimensions, currentValue, targetValue, generateValues]);

  // Implementation recommendations based on factor type
  const recommendations = useMemo(() => {
    const baseRecommendations = {
      'operational_efficiency': [
        "Process standardization workshops",
        "Workflow automation tools implementation",
        "Lean Six Sigma training",
        "Performance dashboard deployment",
        "Cross-functional process mapping"
      ],
      'cost_reduction': [
        "Spend analysis and vendor consolidation",
        "Labor efficiency benchmarking",
        "Energy consumption monitoring",
        "Waste reduction initiatives",
        "Total cost of ownership modeling"
      ],
      'time_to_market': [
        "Concurrent engineering practices",
        "Digital prototyping acceleration",
        "Stage-gate process optimization",
        "Cross-functional team co-location",
        "Rapid testing methodologies"
      ],
      'innovation_capacity': [
        "Idea management platform",
        "R&D tax credit optimization",
        "Open innovation partnerships",
        "Rapid prototyping lab setup",
        "Innovation metrics dashboard"
      ],
      'compliance_risk': [
        "Regulatory change monitoring system",
        "Automated documentation workflows",
        "Compliance training program",
        "Audit preparation toolkit",
        "Incident response simulation"
      ],
      'revenue_growth': [
        "Market segmentation analysis",
        "Product portfolio rationalization",
        "Pricing strategy optimization",
        "Customer success program",
        "Upsell/cross-sell enablement"
      ],
      'sustainability': [
        "Carbon footprint baseline",
        "Energy efficiency audit",
        "Circular material flows mapping",
        "Water recycling initiatives",
        "Sustainability reporting framework"
      ],
      'supply_chain_resilience': [
        "Supplier risk assessment",
        "Inventory optimization modeling",
        "Lead time reduction initiatives",
        "Dual sourcing strategy",
        "Disruption response planning"
      ]
    };

    return baseRecommendations[key] || [
      "Process Optimization Roadmap (3-6 month plan)",
      "Technology Integration (recommended tools)",
      "Change Management Strategy",
      "Performance Metrics Framework",
      "Continuous Improvement Program"
    ];
  }, [key]);

  // View mode toggle buttons
const renderViewModeToggle = () => (
    <Box sx={{ 
      display: 'flex', 
      gap: 1, 
      mb: 2,
      flexWrap: 'wrap'
    }}>
      <Button
        size="small"
        variant={viewMode === 'insights' ? 'contained' : 'outlined'}
        onClick={() => setViewMode('insights')}
        startIcon={<InfoIcon />}
        sx={{ borderRadius: '20px' }}
      >
        Position Insights
      </Button>
      <Button
        size="small"
        variant={viewMode === 'maturity' ? 'contained' : 'outlined'}
        onClick={() => setViewMode('maturity')}
        startIcon={<AssessmentIcon />}
        sx={{ borderRadius: '20px' }}
      >
        Maturity Dimensions
      </Button>
      <Button
        size="small"
        variant={viewMode === 'improvement' ? 'contained' : 'outlined'}
        onClick={() => setViewMode('improvement')}
        startIcon={<TrendingUpIcon />}
        sx={{ borderRadius: '20px' }}
      >
        Improvement Potential
      </Button>
      <Button
        size="small"
        variant={viewMode === 'recommendations' ? 'contained' : 'outlined'}
        onClick={() => setViewMode('recommendations')}
        startIcon={<CheckCircleIcon />}
        sx={{ borderRadius: '20px' }}
      >
        Recommendations
      </Button>
      <Button
        size="small"
        variant={viewMode === 'visualization' ? 'contained' : 'outlined'}
        onClick={() => setViewMode('visualization')}
        startIcon={<RadarIcon />}
        sx={{ borderRadius: '20px' }}
      >
        Performance Dimensions
      </Button>
    </Box>
  );



// Fixed PerformanceDimensionsRadar component
// Advanced PerformanceDimensionsRadar component with error handling and enhanced features
// Advanced PerformanceDimensionsRadar component with error handling and enhanced features
const PerformanceDimensionsRadar = React.memo(({ factorKey, currentLevel, targetLevel }) => {
  const theme = useTheme();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [chartError, setChartError] = useState(null);

  // Safe dimensions data access with fallbacks
  const safeDimensionsData = useMemo(() => {
    return dimensionsData || {};
  }, []);

  // Performance dimensions labels with fallbacks
  const performanceDimensions = useMemo(() => [
    'Operational Efficiency',
    'Cost Reduction',
    'Time to Market',
    'Innovation Capacity',
    'Compliance Risk',
    'Revenue Growth',
    'Sustainability',
    'Supply Chain Resilience'
  ], []);

  // Safe level orders with error handling
  const levelOrders = useMemo(() => {
    try {
      const orders = {};
      Object.keys(safeDimensionsData).forEach(factor => {
        if (safeDimensionsData[factor] && typeof safeDimensionsData[factor] === 'object') {
          const factorLevels = Object.keys(safeDimensionsData[factor]);
          orders[factor] = factorLevels;
        }
      });
      return orders;
    } catch (error) {
      console.error('Error processing level orders:', error);
      return {};
    }
  }, [safeDimensionsData]);

  // Enhanced dimension value getter with comprehensive error handling
  const getDimensionValues = useCallback((level) => {
    try {
      // Validate inputs
      const safeLevel = Math.max(0, Math.min(10, parseInt(level) || 0));
      const defaultValues = Array(8).fill(safeLevel * 10);
      
      if (!safeDimensionsData || !safeDimensionsData[factorKey]) {
        return defaultValues;
      }
      
      const factorData = safeDimensionsData[factorKey];
      const orderedLevels = levelOrders[factorKey] || Object.keys(factorData).sort();
      
      if (!orderedLevels.length) {
        return defaultValues;
      }
      
      const levelIndex = Math.min(Math.max(safeLevel - 1, 0), orderedLevels.length - 1);
      const levelKey = orderedLevels[levelIndex];
      
      if (!levelKey || !factorData[levelKey]) {
        return defaultValues;
      }
      
      const levelData = factorData[levelKey];
      
      // Safe property access with fallbacks
      return [
        levelData.OperationalEfficiency || safeLevel * 10,
        levelData.CostReduction || safeLevel * 10,
        levelData.TimeToMarket || safeLevel * 10,
        levelData.InnovationCapacity || safeLevel * 10,
        levelData.ComplianceRisk || safeLevel * 10,
        levelData.RevenueGrowth || safeLevel * 10,
        levelData.Sustainability || safeLevel * 10,
        levelData.SupplyChainResilience || safeLevel * 10
      ].map(val => Math.min(100, Math.max(0, Number(val) || 50)));
      
    } catch (error) {
      console.error(`Error getting dimension values for ${factorKey}:`, error);
      return Array(8).fill(50); // Return safe default values
    }
  }, [factorKey, levelOrders, safeDimensionsData]);

  // Enhanced PLM capabilities getter
  const getPLMCapabilities = useCallback((level) => {
    try {
      const safeLevel = Math.max(0, Math.min(10, parseInt(level) || 0));
      
      if (!safeDimensionsData || !safeDimensionsData[factorKey]) {
        return ['Basic PLM Features'];
      }
      
      const factorData = safeDimensionsData[factorKey];
      const orderedLevels = levelOrders[factorKey] || Object.keys(factorData).sort();
      
      if (!orderedLevels.length) {
        return ['Standard PLM Capabilities'];
      }
      
      const levelIndex = Math.min(Math.max(safeLevel - 1, 0), orderedLevels.length - 1);
      const levelKey = orderedLevels[levelIndex];
      
      if (!levelKey || !factorData[levelKey]) {
        return ['Core PLM Functions'];
      }
      
      const capabilities = factorData[levelKey].PLMCapabilities;
      return Array.isArray(capabilities) ? capabilities : ['Advanced PLM Tools'];
      
    } catch (error) {
      console.error(`Error getting PLM capabilities for ${factorKey}:`, error);
      return ['Essential PLM Features'];
    }
  }, [factorKey, levelOrders, safeDimensionsData]);

  // Ultra-safe radar data creation
  const radarData = useMemo(() => {
    try {
      setChartError(null);
      
      const safeCurrentLevel = Math.max(0, Math.min(10, parseInt(currentLevel) || 0));
      const safeTargetLevel = Math.max(0, Math.min(10, parseInt(targetLevel) || 5));
      
      const currentValues = getDimensionValues(safeCurrentLevel);
      const targetValues = getDimensionValues(safeTargetLevel);
      
      // Validate data arrays
      if (!Array.isArray(currentValues) || !Array.isArray(targetValues) || 
          currentValues.length !== 8 || targetValues.length !== 8) {
        throw new Error('Invalid dimension data structure');
      }
      
      return {
        labels: performanceDimensions,
        datasets: [
          {
            label: 'Current Performance',
            data: currentValues,
            backgroundColor: 'rgba(59, 130, 246, 0.3)',
            borderColor: 'rgba(59, 130, 246, 1)',
            borderWidth: 3,
            pointBackgroundColor: 'rgba(59, 130, 246, 1)',
            pointRadius: 5,
            pointHoverRadius: 8,
            pointBorderColor: '#fff',
            pointBorderWidth: 2,
            tension: 0.1
          },
          {
            label: 'Target Performance',
            data: targetValues,
            backgroundColor: 'rgba(16, 185, 129, 0.3)',
            borderColor: 'rgba(16, 185, 129, 1)',
            borderWidth: 3,
            pointBackgroundColor: 'rgba(16, 185, 129, 1)',
            pointRadius: 5,
            pointHoverRadius: 8,
            pointBorderColor: '#fff',
            pointBorderWidth: 2,
            tension: 0.1
          }
        ]
      };
    } catch (error) {
      console.error('Error creating radar data:', error);
      setChartError(error.message);
      
      // Fallback data
      return {
        labels: performanceDimensions,
        datasets: [
          {
            label: 'Current Performance',
            data: [50, 50, 50, 50, 50, 50, 50, 50],
            backgroundColor: 'rgba(200, 200, 200, 0.2)',
            borderColor: 'rgba(100, 100, 100, 1)',
            borderWidth: 2,
          },
          {
            label: 'Target Performance',
            data: [50, 50, 50, 50, 50, 50, 50, 50],
            backgroundColor: 'rgba(200, 200, 200, 0.2)',
            borderColor: 'rgba(100, 100, 100, 1)',
            borderWidth: 2,
          }
        ]
      };
    }
  }, [currentLevel, targetLevel, getDimensionValues, performanceDimensions]);

  // Enhanced performance metrics with error handling
  const performanceMetrics = useMemo(() => {
    try {
      const safeCurrentLevel = Math.max(0, Math.min(10, parseInt(currentLevel) || 0));
      const safeTargetLevel = Math.max(0, Math.min(10, parseInt(targetLevel) || 5));
      
      const currentValues = getDimensionValues(safeCurrentLevel);
      const targetValues = getDimensionValues(safeTargetLevel);
      
      if (!Array.isArray(currentValues) || !Array.isArray(targetValues)) {
        return { avgCurrent: 50, avgTarget: 50, avgImprovement: 0, isValid: false };
      }
      
      const avgCurrent = Math.round(currentValues.reduce((a, b) => a + b, 0) / currentValues.length);
      const avgTarget = Math.round(targetValues.reduce((a, b) => a + b, 0) / targetValues.length);
      const avgImprovement = avgTarget - avgCurrent;
      
      return { avgCurrent, avgTarget, avgImprovement, isValid: true };
    } catch (error) {
      console.error('Error calculating performance metrics:', error);
      return { avgCurrent: 50, avgTarget: 50, avgImprovement: 0, isValid: false };
    }
  }, [currentLevel, targetLevel, getDimensionValues]);


  // Safe PLM capabilities
  const currentPLMCapabilities = useMemo(() => 
    getPLMCapabilities(currentLevel), [currentLevel, getPLMCapabilities]);
  
  const targetPLMCapabilities = useMemo(() => 
    getPLMCapabilities(targetLevel), [targetLevel, getPLMCapabilities]);

  // Advanced radar options with enhanced styling
  const radarOptions = useMemo(() => ({
    responsive: true,
    maintainAspectRatio: false,
    animation: {
      duration: 0
    },
    interaction: {
      mode: 'index',
      intersect: false
    },
    scales: {
      r: {
        angleLines: { 
          display: true, 
          color: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)',
          lineWidth: 1
        },
        grid: {
          color: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.15)' : 'rgba(0, 0, 0, 0.15)',
          lineWidth: 1,
          circular: true
        },
        min: 0,
        max: 100,
        ticks: { 
          stepSize: 20,
          backdropColor: 'transparent',
          color: theme.palette.text.secondary,
          font: {
            size: 10,
            family: theme.typography.fontFamily,
            weight: '500'
          },
          callback: function(value) {
            return value + '%';
          },
          z: 10
        },
        pointLabels: {
          font: { 
            size: 11,
            family: theme.typography.fontFamily,
            weight: '600'
          },
          color: theme.palette.text.primary,
          padding: 14,
          backdropColor: theme.palette.background.default,
          backdropPadding: 4,
          callback: function(value) {
            if (!value) return '';
            if (value.length > 15) {
              return value.substring(0, 14) + '...';
            }
            return value;
          }
        },
        startAngle: 45,
        suggestedMin: 0,
        suggestedMax: 100
      }
    },
    plugins: {
      legend: { 
        position: 'top',
        labels: {
          boxWidth: 14,
          padding: 20,
          font: { 
            weight: '600',
            size: 12,
            family: theme.typography.fontFamily
          },
          color: theme.palette.text.primary,
          usePointStyle: true,
          pointStyle: 'circle'
        }
      },
      tooltip: {
        enabled: true,
        backgroundColor: theme.palette.background.paper,
        titleColor: theme.palette.text.primary,
        bodyColor: theme.palette.text.secondary,
        borderColor: theme.palette.divider,
        borderWidth: 1,
        padding: 12,
        boxPadding: 6,
        usePointStyle: true,
        cornerRadius: 8,
        callbacks: {
          title: (context) => {
            return context[0]?.label || 'Dimension';
          },
          label: (context) => {
            const datasetLabel = context.dataset?.label || 'Dataset';
            const value = context.parsed.r || 0;
            return `${datasetLabel}: ${Math.round(value)}%`;
          },
          afterLabel: (context) => {
            const index = context.dataIndex;
            const dimension = performanceDimensions[index];
            return `• ${dimension}`;
          }
        }
      }
    },
    elements: {
      line: {
        tension: 0.2,
        borderCapStyle: 'round',
        borderJoinStyle: 'round'
      },
      point: {
        hoverRadius: 10,
        hoverBorderWidth: 3,
        hitRadius: 15
      }
    }
  }), [theme, performanceDimensions]);

  // Error boundary component for chart rendering
  const ChartErrorBoundary = ({ children }) => {
    const [hasError, setHasError] = useState(false);
    
    useEffect(() => {
      setHasError(false);
    }, [radarData]);
    
    if (hasError || chartError) {
      return (
        <Box sx={{ 
          height: 300, 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          justifyContent: 'center',
          color: 'text.secondary'
        }}>
          <WarningIcon sx={{ fontSize: 48, mb: 2, color: 'warning.main' }} />
          <Typography variant="h6" gutterBottom>
            Chart Unavailable
          </Typography>
          <Typography variant="body2" align="center">
            {chartError || 'Unable to display performance dimensions'}
          </Typography>
          <Button 
            variant="outlined" 
            size="small" 
            onClick={() => setHasError(false)}
            sx={{ mt: 2 }}
          >
            Retry
          </Button>
        </Box>
      );
    }
    
    return children;
  };

  // Dialog handlers
  const handleZoomClick = useCallback(() => {
    setIsDialogOpen(true);
  }, []);

  const handleCloseDialog = useCallback(() => {
    setIsDialogOpen(false);
  }, []);

  // Full screen dialog component
  const FullScreenDialog = () => (
    <Dialog
      fullScreen
      open={isDialogOpen}
      onClose={handleCloseDialog}
      sx={{ 
        '& .MuiDialog-paper': { 
          bgcolor: 'background.default',
          overflow: 'hidden'
        } 
      }}
    >
      <Watermark opacity={0.08} fontSize={72} />
      
      <AppBar position="relative" color="transparent" elevation={1}>
        <Toolbar>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            Performance Dimensions - {factorKey}
          </Typography>
          <IconButton
            edge="end"
            color="inherit"
            onClick={handleCloseDialog}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      
      <DialogContent sx={{ 
        p: 3, 
        display: 'flex', 
        flexDirection: 'column',
        height: 'calc(100vh - 64px)'
      }}>
        <Box sx={{ 
          height: '60%', 
          width: '100%', 
          mb: 3,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          <Box sx={{ width: '100%', height: '100%', maxWidth: '800px' }}>
            <ChartErrorBoundary>
              <Radar 
                data={radarData} 
                options={{ 
                  ...radarOptions, 
                  maintainAspectRatio: true,
                  scales: {
                    r: {
                      ...radarOptions.scales.r,
                      pointLabels: {
                        ...radarOptions.scales.r.pointLabels,
                        font: {
                          size: 14,
                          family: theme.typography.fontFamily,
                          weight: '600'
                        }
                      }
                    }
                  }
                }}
                redraw={false}
              />
            </ChartErrorBoundary>
          </Box>
        </Box>
        
        <Box sx={{ 
          display: 'flex', 
          flexWrap: 'wrap', 
          gap: 2, 
          overflow: 'auto',
          height: '40%'
        }}>
          <Paper sx={{ p: 2, flex: 1, minWidth: 300, maxHeight: '100%', overflow: 'auto' }}>
            <Typography variant="h6" gutterBottom>
              PLM Capabilities (Current Level {currentLevel})
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
              {currentPLMCapabilities.map((capability, index) => (
                <Chip
                  key={index}
                  label={capability}
                  size="small"
                  color="primary"
                  variant="outlined"
                  sx={{ mb: 1 }}
                />
              ))}
              {currentPLMCapabilities.length === 0 && (
                <Typography variant="body2" color="text.secondary">
                  No specific capabilities defined for current level.
                </Typography>
              )}
            </Box>
          </Paper>
          
          <Paper sx={{ p: 2, flex: 1, minWidth: 300, maxHeight: '100%', overflow: 'auto' }}>
            <Typography variant="h6" gutterBottom>
              PLM Capabilities (Target Level {targetLevel})
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
              {targetPLMCapabilities.map((capability, index) => (
                <Chip
                  key={index}
                  label={capability}
                  size="small"
                  color="success"
                  variant="outlined"
                  sx={{ mb: 1 }}
                />
              ))}
              {targetPLMCapabilities.length === 0 && (
                <Typography variant="body2" color="text.secondary">
                  No specific capabilities defined for target level.
                </Typography>
              )}
            </Box>
          </Paper>
        </Box>
      </DialogContent>
    </Dialog>
  );

  return (
    <>
      <Paper 
        elevation={2} 
        sx={{ 
          p: 3, 
          position: 'relative',
          borderRadius: 3,
          bgcolor: 'background.default',
          transition: 'all 0.3s ease-in-out',
          overflow: 'hidden',
          border: `1px solid ${theme.palette.divider}`,
          '&:hover': {
            boxShadow: theme.shadows[6],
            transform: 'translateY(-2px)'
          }
        }}
      >
        <Watermark opacity={0.03} fontSize={42} />
        
        {/* Header Section */}
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'flex-start', 
          mb: 3, 
          position: 'relative', 
          zIndex: 1,
          flexWrap: 'wrap',
          gap: 2
        }}>
          <Box>
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold' }}>
              Performance Dimensions
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Factor: {factorKey.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}
            </Typography>
          </Box>
          
          <Box sx={{ textAlign: 'right' }}>
            <Box sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: 1, 
              mb: 1,
              flexWrap: 'wrap',
              justifyContent: 'flex-end'
            }}>
              <Chip 
                label={`Current: L${currentLevel}`} 
                size="small" 
                color="primary" 
                variant="outlined"
              />
              <Chip 
                label={`Target: L${targetLevel}`} 
                size="small" 
                color="success" 
                variant="outlined"
              />
            </Box>
            <Typography variant="body2" color="text.secondary">
              <strong>Performance:</strong> {performanceMetrics.avgCurrent}% → {performanceMetrics.avgTarget}%
              {performanceMetrics.avgImprovement > 0 && (
                <Box component="span" sx={{ color: 'success.main', ml: 1, fontWeight: 'bold' }}>
                  ↗ +{performanceMetrics.avgImprovement}%
                </Box>
              )}
            </Typography>
          </Box>
          
          <Tooltip title="Full screen detailed view">
            <IconButton 
              onClick={handleZoomClick}
              sx={{ 
                bgcolor: 'primary.main', 
                color: 'white',
                '&:hover': { bgcolor: 'primary.dark' }
              }}
            >
              <ZoomInIcon />
            </IconButton>
          </Tooltip>
        </Box>
        
        {/* Radar Chart Section */}
        <ChartErrorBoundary>
          <Box sx={{ 
            height: 350, 
            width: '100%', 
            position: 'relative', 
            zIndex: 1,
            mb: 2
          }}>
            <Radar 
              data={radarData} 
              options={radarOptions}
              redraw={false}
            />
          </Box>
        </ChartErrorBoundary>
        
        {/* Capabilities Preview */}
        <Box sx={{ 
          mt: 3, 
          p: 2, 
          bgcolor: 'action.hover', 
          borderRadius: 2,
          position: 'relative',
          zIndex: 1
        }}>
          <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold' }}>
            🚀 Key Capabilities Enhancement
          </Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, alignItems: 'center' }}>
            {currentPLMCapabilities.slice(0, 3).map((capability, index) => (
              <Chip
                key={index}
                label={capability}
                size="small"
                color="default"
                variant="outlined"
              />
            ))}
            {currentPLMCapabilities.length > 3 && (
              <Tooltip title={`+${currentPLMCapabilities.length - 3} more capabilities`}>
                <Chip
                  label={`+${currentPLMCapabilities.length - 3}`}
                  size="small"
                  color="primary"
                  onClick={handleZoomClick}
                  sx={{ cursor: 'pointer' }}
                />
              </Tooltip>
            )}
            <Box sx={{ ml: 'auto', display: 'flex', alignItems: 'center', gap: 1 }}>
              <ArrowForwardIcon color="action" />
              {targetPLMCapabilities.slice(0, 2).map((capability, index) => (
                <Chip
                  key={index}
                  label={capability}
                  size="small"
                  color="success"
                  variant="filled"
                />
              ))}
            </Box>
          </Box>
        </Box>
      </Paper>
      
      <FullScreenDialog />
    </>
  );
}, (prevProps, nextProps) => {
  // Deep comparison for memoization
  return prevProps.currentLevel === nextProps.currentLevel && 
         prevProps.targetLevel === nextProps.targetLevel &&
         prevProps.factorKey === nextProps.factorKey;
});

PerformanceDimensionsRadar.displayName = 'PerformanceDimensionsRadar';


    // Render the appropriate view based on mode
  const renderViewContent = () => {
    switch(viewMode) {
      case 'insights':
        return (
          <Box>
            <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold', display: 'flex', alignItems: 'center' }}>
              <InfoIcon sx={{ mr: 1, color: 'primary.main' }} />
              Slider Position Analysis
            </Typography>
            
            <InsightCard 
              title="Current Position" 
              insights={currentInsights}
              value={currentValue}
              color={theme.palette.error.main}
            />
            
            <InsightCard 
              title="Target Position" 
              insights={targetInsights}
              value={targetValue}
              color={theme.palette.success.main}
            />

            {/* Improvement Analysis */}
            {(currentInsights || targetInsights) && (
              <Paper 
                elevation={1} 
                sx={{ 
                  p: 2, 
                  mt: 2,
                  backgroundColor: 'primary.50',
                  border: `1px solid ${theme.palette.primary.light}`
                }}
              >
                <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
                  Improvement Analysis
                </Typography>
                <Typography variant="body2">
                  Moving from <strong>"{sliderLabels[key]?.[currentValue]}"</strong> to{" "}
                  <strong>"{sliderLabels[key]?.[targetValue]}"</strong> represents a{" "}
                  <strong>{targetValue - currentValue}-level improvement</strong> in {factor.label.toLowerCase()}.
                </Typography>
                {impact > 0 && (
                  <Typography variant="body2" sx={{ mt: 1, fontWeight: 'bold', color: 'success.main' }}>
                    Estimated impact: {getCurrencySymbol(currency)}{Math.abs(impact).toLocaleString()}
                  </Typography>
                )}
              </Paper>
            )}
          </Box>
        );
      case 'maturity':
        return (
          <Box sx={{ 
            height: 300,
            transition: 'all 0.3s ease',
            transform: isDragging ? 'scale(1.01)' : 'scale(1)'
          }}>
            <Radar 
              data={radarData} 
              options={radarOptions} 
              redraw={isDragging}
            />
          </Box>
        );
      case 'improvement':
        return (
          <Paper elevation={0} sx={{ 
            p: 2, 
            borderRadius: 2, 
            bgcolor: 'background.paper',
            border: `1px solid ${theme.palette.divider}`
          }}>
            <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold' }}>
              <TrendingUp sx={{ verticalAlign: 'middle', mr: 1 }} />
              Improvement Potential Breakdown
            </Typography>
            <List dense>
              {dimensions.map((dim, i) => (
                <ListItem key={i} sx={{ py: 0.5 }}>
                  <ListItemIcon sx={{ minWidth: 36 }}>
                    {dim.icon}
                  </ListItemIcon>
                  <ListItemText 
                    primary={dim.name} 
                    secondary={`${improvementPotential[i]}% improvement possible`}
                  />
                  <LinearProgress 
                    variant="determinate" 
                    value={Math.min(100, Math.max(0, improvementPotential[i]))} 
                    sx={{ 
                      width: 80,
                      height: 8,
                      borderRadius: 4,
                      bgcolor: 'rgba(25, 118, 210, 0.1)',
                      '& .MuiLinearProgress-bar': {
                        bgcolor: improvementPotential[i] > 0 ? 'success.main' : 'error.main'
                      }
                    }}
                  />
                </ListItem>
              ))}
            </List>
          </Paper>
        );
      case 'recommendations':
        return (
          <Paper elevation={0} sx={{ 
            p: 2, 
            borderRadius: 2, 
            bgcolor: 'background.paper',
            border: `1px solid ${theme.palette.divider}`
          }}>
            <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold' }}>
              <Lightbulb sx={{ verticalAlign: 'middle', mr: 1 }} />
              Implementation Recommendations
            </Typography>
            <List dense>
              {recommendations.map((rec, i) => (
                <ListItem key={i} sx={{ py: 0.5 }}>
                  <ListItemIcon sx={{ minWidth: 36 }}>
                    <CheckCircle color="success" />
                  </ListItemIcon>
                  <ListItemText primary={rec} />
                </ListItem>
              ))}
            </List>
          </Paper>
        );
      case 'visualization':
        return (
          <PerformanceDimensionsRadar 
            factorKey={key}
            currentLevel={currentValue}
            targetLevel={targetValue}
          />
        );
      default:
        return null;
    }
  };

  return (
    <Accordion
      expanded={expanded}
      onChange={() => setExpanded(!expanded)}
      sx={{
        mb: 2,
        borderRadius: 2,
        bgcolor: activeFactor === key ? 'action.hover' : 'background.paper',
        transition: 'all 0.3s ease',
        overflow: 'hidden',
        '&:hover': {
          boxShadow: theme.shadows[4],
          transform: 'translateY(-2px)'
        }
      }}
      onMouseEnter={() => setActiveFactor(key)}
      onMouseLeave={() => setActiveFactor(null)}
    >
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Box sx={{ 
          width: '100%', 
          display: 'flex', 
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: isMobile ? 'flex-start' : 'center',
          gap: isMobile ? 1 : 0
        }}>
          {/* Slider section */}
          <Box sx={{ 
            width: '100%', 
            mr: isMobile ? 0 : 2,
            mb: isMobile ? 1 : 0,
            position: 'relative',
            pt: 2
          }}>
            <DualColorSlider
              value={[currentValue, targetValue]}
              onChange={handleSliderChange}
              onChangeCommitted={handleSliderChangeCommitted}
              valueLabelDisplay="auto"
              valueLabelFormat={(value, index) => {
                const label = sliderLabels[key]?.[value] || `Level ${value}`;
                return `${index === 0 ? 'Current: ' : 'Target: '}${label}`;
              }}
              min={0}
              max={10}
              step={1}
              components={{
                Track: ({ className, ...props }) => (
                  <div className={className} style={{ position: 'relative' }}>
                    <CustomTrack values={[currentValue, targetValue]} />
                  </div>
                ),
                Thumb: CustomThumb
              }}
              sx={{
                '& .MuiSlider-track': {
                  display: 'none'
                },
                '& .MuiSlider-valueLabel': {
                  backgroundColor: (props) => {
                    const index = props?.index ?? 0;
                    return index === 0 ? theme.palette.error.main : theme.palette.success.main;
                  },
                }
              }}
            />
            
            {/* Current/Target indicators */}
            <Box sx={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              mt: 0.5,
              fontSize: '0.75rem' 
            }}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Box sx={{ 
                  width: 12, 
                  height: 12, 
                  bgcolor: 'error.main', 
                  borderRadius: '50%',
                  mr: 0.5 
                }} />
                <Typography variant="caption" color="text.secondary">
                  Current: {currentValue}
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Box sx={{ 
                  width: 12, 
                  height: 12, 
                  bgcolor: 'success.main', 
                  borderRadius: '50%',
                  mr: 0.5 
                }} />
                <Typography variant="caption" color="text.secondary">
                  Target: {targetValue}
                </Typography>
              </Box>
            </Box>
          </Box>

          {/* Factor info */}
          <Box sx={{ 
            flexGrow: 1,
            width: isMobile ? '100%' : 'auto',
            mb: isMobile ? 1 : 0
          }}>
            <Tooltip 
              title={
                <Box sx={{ color: '#1976d2', fontWeight: 500 }}>
                  {tooltip}
                </Box>
              } 
              arrow
              slotProps={{
                tooltip: {
                  sx: {
                    backgroundColor: '#ffffff',
                    color: '#1976d2',
                    fontSize: '0.875rem',
                    fontWeight: 500,
                    borderRadius: 8,
                    padding: '12px 16px',
                    boxShadow: '0px 8px 24px rgba(25, 118, 210, 0.3)',
                    border: '2px solid #1976d2',
                    '& .MuiTooltip-arrow': {
                      color: '#1976d2',
                    }
                  }
                }
              }}
            >
              <Typography variant="subtitle1" sx={{ 
                fontWeight: 'medium',
                display: 'flex',
                alignItems: 'center',
                mb: isMobile ? 0.5 : 0,
                cursor: 'help'
              }}>
                <Box component="span" sx={{ mr: 1 }}>{factor.emoji}</Box>
                {factor.label}
              </Typography>
            </Tooltip>

            <Box sx={{ 
              display: 'flex', 
              gap: 2, 
              mt: 0.5,
              flexDirection: isMobile ? 'column' : 'row',
              alignItems: isMobile ? 'flex-start' : 'center'
            }}>
              <Typography variant="body2" color="text.secondary">
                <Box component="span" sx={{ fontWeight: 'bold', color: 'error.main' }}>
                  Current: 
                </Box> {sliderLabels[key]?.[currentValue] || `Level ${currentValue}`}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                <Box component="span" sx={{ fontWeight: 'bold', color: 'success.main' }}>
                  Target: 
                </Box> {sliderLabels[key]?.[targetValue] || `Level ${targetValue}`}
              </Typography>
            </Box>
          </Box>

          {/* Impact display */}
          <motion.div
            initial={{ scale: 1 }}
            animate={{ scale: isDragging ? 1.05 : 1 }}
            transition={{ duration: 0.2 }}
            style={{ width: isMobile ? '100%' : 'auto' }}
          >
            <Box sx={{ 
              textAlign: isMobile ? 'left' : 'right',
              p: 1.5,
              borderRadius: 2,
              bgcolor: impact >= 0 ? 
                'rgba(76, 175, 80, 0.1)' : 'rgba(255, 68, 68, 0.1)',
              border: `1.5px solid ${
                impact >= 0 ? theme.palette.success.light : theme.palette.error.light
              }`,
              minWidth: isMobile ? 'auto' : 120,
              width: isMobile ? '100%' : 'auto'
            }}>
              <AnimatedCounter
                value={Math.abs(impact)}
                duration={500}
                prefix={`${impact >= 0 ? "+" : "-"}${getCurrencySymbol(currency)} `}
                sx={{
                  fontWeight: 'bold',
                  color: impact >= 0 ? "success.main" : "error.main",
                  fontSize: isMobile ? '1rem' : '1.1rem'
                }}
              />
            </Box>
          </motion.div>
        </Box>
      </AccordionSummary>
      
      <AccordionDetails>
        {renderViewModeToggle()}
        {renderViewContent()}
      </AccordionDetails>
    </Accordion>
  );
};

//**********************************************
// 1. First define the EmptyState component (before ROIAnalyzer)
const EmptyState = ({ onClick }) => (
  <Box sx={{ 
    textAlign: 'center', 
    p: 4,
    border: '1px dashed',
    borderColor: 'divider',
    borderRadius: 2
  }}>
    <Typography variant="h6" color="text.secondary" gutterBottom>
      No quantum scenarios saved yet
    </Typography>
    <Button
      variant="contained"
      onClick={onClick}
      startIcon={<Insights />}
    >
      Create First Scenario
    </Button>
  </Box>
);


const ROIAnalyzer = () => {
  // Contexts
//  const { user, isAuthenticated, credits, updateCredits, logout, refreshUser, token } = useContext(AuthContext);
const { user, isAuthenticated, credits, updateCredits, logout, refreshUser, token } = useContext(AuthContext);
//  const { user, isAuthenticated, logout, refreshUser, token, updateUser  } = useAuth();
  const { setActiveTab } = useContext(UIContext);
  const { scenario, setScenario } = useContext(ScenarioContext);
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const AdvancedReports = true;
  const { 
  scenarios: savedScenarios, 
  setScenarios: setSavedScenarios, // This maps context's setScenarios to setSavedScenarios
  loading: loadingScenarios,
  fetchScenarios // Use this instead of manual loading
} = useContext(ScenarioContext);

  // Initialize scenarios when component mounts
useEffect(() => {
  if (isAuthenticated) {
    fetchScenarios(); // Use the context-provided fetch function
  }
}, [isAuthenticated, fetchScenarios]);
  
 

  // State
  // Add this near the top of ROIAnalyzer.js
    const [sliderValues, setSliderValues] = useState(
    Object.fromEntries(
      categories.flatMap(cat => 
        cat.factors.map(factor => [
          factor.key, 
          { current: 0, target: 0 }
        ])
      )
    )
  );
  

 const [currentScenarioContext, setCurrentScenarioContext] = useState({
  scenario: null,
  isLoading: false,
  isLoaded: false,
  lastUpdated: null
});

  
  const [resetDialogOpen, setResetDialogOpen] = useState(false);
 // const [resetValues, setResetValues] = useState({ current: 0, target: 0 });
 //const [resetDialogOpen, setResetDialogOpen] = useState(false);

  
  const [activeTab, setLocalActiveTab] = useState('analyze');
  const [parameters, setParameters] = useState(defaultParameters);
  const [industry, setIndustry] = useState('automotive');
  const [tier, setTier] = useState('OEM');
  const [persona, setPersona] = useState('CFO');
  const [turnover, setTurnover] = useState(100000000);
  const [projectionYear, setProjectionYear] = useState(1);
const [categoryTotals, setCategoryTotals] = useState({});
const [impactDisplayPosition, setImpactDisplayPosition] = useState('config-matrix'); // 'config-matrix', 'docked', 'floating'
const [floatingPosition, setFloatingPosition] = useState({ x: window.innerWidth - 300, y: 200 });
const [isDragging, setIsDragging] = useState(false);
const dragOffset = useRef({ x: 0, y: 0 });
const [isImpactExpanded, setIsImpactExpanded] = useState(false);


  const [sortBy, setSortBy] = useState('newest');
  const [sortedScenarios, setSortedScenarios] = useState([]);

  const [scenarioName, setScenarioName] = useState('');
  const [isPlaying, setIsPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const [activeFactor, setActiveFactor] = useState(null);
  const [expandedCategory, setExpandedCategory] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [compareMode, setCompareMode] = useState(false);
  const [selectedScenarios, setSelectedScenarios] = useState([]);
  const [saveDialogOpen, setSaveDialogOpen] = useState(false);
  const [tuneDialogOpen, setTuneDialogOpen] = useState(false);
  const [activeTuningFactor, setActiveTuningFactor] = useState(null);
//  const [setLoadingScenarios] = useState(true);
  const [showPayment, setShowPayment] = useState(false);
  const [fineTune, setFineTune] = useState({});
  const [loading, setLoading] = useState(true);
  //const [credits, setCredits] = useState(null);
  const [apiError, setApiError] = useState(false);
 const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });
  const [expanded, setExpanded] = useState(false);
// Add to your ROIAnalyzer component
const [guidelineScenarios, setGuidelineScenarios] = useState([]);
const { triggerCreditPulse } = useContext(UIContext);

//const [currency, setCurrency] = useState('EUR'); // Default currency
//const [currency, setCurrency] = useState('INR'); // Default to INR
const {
  currencyRates,
  selectedCurrency,
  setSelectedCurrency,
  isLoading: isLoadingRates,
  convertPrice,
  BASE_CURRENCY,
  BASE_CURRENCY_SYMBOL,
  CURRENCIES: currencies,
  currencySymbol
} = useCurrency();

// Inside the ROIAnalyzer component, replace currency state with:


const [purchaseModalOpen, setPurchaseModalOpen] = useState(false);

// But you're missing payment process state:
//const [paymentInProgress, setPaymentInProgress] = useState(false);

// State for selected package
const [selectedPackage, setSelectedPackage] = useState(null);


const [scenarioNotification, setScenarioNotification] = useState({ open: false, message: '' });


// Add these state variables near your existing state declarations
const [comparisonMode, setComparisonMode] = useState(false);
const [comparisonView, setComparisonView] = useState('matrix');
const [showComparisonLauncher, setShowComparisonLauncher] = useState(false);
const [scenarioFilter, setScenarioFilter] = useState('all');
const [scenarioSearchTerm, setScenarioSearchTerm] = useState('');

//const [impactDisplayPosition, setImpactDisplayPosition] = useState('config-matrix'); // 'config-matrix', 'docked', 'floating'
//const [floatingPosition, setFloatingPosition] = useState({ x: window.innerWidth - 300, y: 200 });
//const [isDragging, setIsDragging] = useState(false);
//const dragOffset = useRef({ x: 0, y: 0 });


// Add this useEffect near your other useEffects to monitor slider value changes
useEffect(() => {
  console.group('📊 SLIDER VALUES MONITOR');
  console.log('🔄 Current sliderValues state:', sliderValues);
  
  // Check if we have any non-zero values
  const nonZeroFactors = Object.entries(sliderValues).filter(([key, values]) => 
    values.current > 0 || values.target > 0
  );
  
  console.log(`📈 Factors with non-zero values: ${nonZeroFactors.length} of ${Object.keys(sliderValues).length}`);
  
  if (nonZeroFactors.length > 0) {
    console.log('🎯 Non-zero factors:');
    nonZeroFactors.forEach(([key, values]) => {
      console.log(`   ${key}: Current=${values.current}, Target=${values.target}`);
    });
  } else {
    console.log('⚠️  All factors are at zero values');
  }
  
  console.groupEnd();
}, [sliderValues]);



 // Effects
  useEffect(() => {
    if (!user) navigate('/login');
  }, [user, navigate]);
  
  useEffect(() => {
  if (savedScenarios.length > 0) {
    const sorted = [...savedScenarios].sort((a, b) => {
      switch (sortBy) {
        case 'newest':
          return new Date(b.createdAt) - new Date(a.createdAt);
        case 'oldest':
          return new Date(a.createdAt) - new Date(b.createdAt);
        case 'impact':
          return (b.totalImpact || 0) - (a.totalImpact || 0);
        case 'name':
          return a.name.localeCompare(b.name);
        default:
          return 0;
      }
    });
    setSortedScenarios(sorted);
  } else {
    setSortedScenarios([]);
  }
}, [savedScenarios, sortBy]);


useEffect(() => {
  const initialize = async () => {
    if (!user || !token) {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const [{ data: creditData }, { data: scenarioData }, { data: userScenarios }] = await Promise.all([
        axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/users/${user._id}/credits`, {
          headers: { Authorization: `Bearer ${token}` },
        }).catch(() => ({ data: { credits: 0 } })), // Fallback if credits API fails
        // axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/scenario/user/${user._id}`, {
         // headers: { Authorization: `Bearer ${token}` },        
        // }).catch(() => ({ data: null })), // Fallback if scenario API fails
        axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/scenarios/user/${user._id}`, {
          headers: { Authorization: `Bearer ${token}` }
        }).catch(() => ({ data: null })) // Fallback if scenario API fails
      ]);

      // Update credits through AuthContext
      if (creditData?.credits !== undefined) {
        // If you have an updateCredits function in AuthContext, use it:
        // updateCredits(creditData.credits);
        // Otherwise, the credits should be part of the user object from AuthContext
      }

      if (scenarioData?.config) {
        setScenario(scenarioData.config);
        enqueueSnackbar('Scenario loaded from your previous session.', { variant: 'info' });
      }
    } catch (err) {
      console.error('Initialization error:', err);
      enqueueSnackbar('Failed to load user data. Using default configuration.', { variant: 'error' });
    } finally {
      setLoading(false);
    }
  };

  initialize();
}, [user, token, enqueueSnackbar, setScenario]);

// In ROIAnalyzer.js, add this useEffect to handle URL parameters
useEffect(() => {
  // Check for tab parameter in URL
  const urlParams = new URLSearchParams(window.location.search);
  const tabParam = urlParams.get('tab');
  
  if (tabParam && ['analyze', 'scenarios', 'credits', 'insights'].includes(tabParam)) {
    setLocalActiveTab(tabParam);
    setActiveTab(tabParam);
  }
}, []);


useEffect(() => {
  console.group('📊 SLIDER VALUES MONITOR');
  console.log('🔄 Current sliderValues state:', sliderValues);
  
  // Check if we have any non-zero values
  const nonZeroFactors = Object.entries(sliderValues).filter(([key, values]) => 
    values && (values.current > 0 || values.target > 0)
  );
  
  console.log(`📈 Factors with non-zero values: ${nonZeroFactors.length} of ${Object.keys(sliderValues).length}`);
  
  if (nonZeroFactors.length > 0) {
    console.log('🎯 Non-zero factors:');
    nonZeroFactors.forEach(([key, values]) => {
      console.log(`   ${key}: Current=${values.current}, Target=${values.target}`);
    });
  } else {
    console.log('⚠️  All factors are at zero values');
  }
  
  console.groupEnd();
}, [sliderValues]);


useEffect(() => {
  // If user object has credits, use that as the source of truth
  if (user?.credits !== undefined) {
    // If you have a local credits state, set it here
    // Or better, use user.credits directly in your component
  }
}, [user?.credits]);

/* useEffect(() => {
  const loadScenarios = async () => {
    if (isAuthenticated && token) {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/scenarios/user/${user._id}`,
          {
            headers: { Authorization: `Bearer ${token}` }
          }
        );
        setSavedScenarios(data || []);
      } catch (error) {
        console.error('Failed to fetch scenarios:', error);
        setSavedScenarios([]);
      }
    }
  };

  loadScenarios();
}, [isAuthenticated, token, user?._id]); */


// Replace guideline scenarios loading with this optimized version
useEffect(() => {
  const fetchGuidelineScenarios = async () => {
    try {
      const { data } = await axios.get('/api/scenarios/guidelines');
      // Convert the object to an array of scenarios
      const scenariosArray = Object.values(data).flat();
      setGuidelineScenarios(scenariosArray);
    } catch (err) {
      console.error('Failed to load guideline scenarios:', err);
      setGuidelineScenarios([]); // Fallback to empty array
    }
  };
  fetchGuidelineScenarios();
}, []);


 
  const handleCloseNotification = useCallback(() => {
    setScenarioNotification({ open: false, message: '' });
  }, []);



  // Core Business Logic
  const getSliderValue = useCallback((value) => {
    if (value == null) return 0;
    const numericValue = Number(value);
    if (isNaN(numericValue)) return 0;
    const clampedValue = Math.min(10, Math.max(0, Math.round(numericValue)));
    return VALUE_MAP[clampedValue] ?? 0;
  }, []);
  

const handleSliderChange = (factorKey, newValues) => {
  setSliderValues(prev => ({
    ...prev,
    [factorKey]: {
      current: newValues[0],
      target: newValues[1]
    }
  }));
};

/* 
const getDollarImpact = useCallback((key, label) => {
  const matrixKey = `${industry}:${tier}`;
  const sliderVal = getNumericImpact(key, label) ?? 0;
  const score = matrixScores[key]?.[matrixKey] ?? 0;
  const maxImpact = parameters.maxImpactPercents[key] ?? 0.001;
  const baseImpact = sliderVal * (score / 100) * maxImpact * turnover;
  const multiplier = Math.pow(1 + (parameters.annualGrowthRate / 100), projectionYear - 1);
  return baseImpact * multiplier;
}, [industry, tier, turnover, projectionYear, parameters, sliderValues]); // Add sliderValues here

 */

/* // Add this debug version of getDollarImpact
const getDollarImpact = useCallback((key, label) => {
  const matrixKey = `${industry}:${tier}`;
  const sliderVal = getNumericImpact(key, label) ?? 0;
  const score = matrixScores[key]?.[matrixKey] ?? 0;
  const maxImpact = parameters.maxImpactPercents[key] ?? 0.001;
  const baseImpact = sliderVal * (score / 100) * maxImpact * turnover;
  const multiplier = Math.pow(1 + (parameters.annualGrowthRate / 100), projectionYear - 1);
  const finalImpact = baseImpact * multiplier;

  // Debug logging - log all calculation values
  console.group(`💰 Dollar Impact Calculation for ${key}`);
  process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DEBUG && console.log('🔑 Factor Key:', key);
  process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DEBUG && console.log('🏷️  Slider Label:', label);
  process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DEBUG && console.log('🏭 Industry:', industry);
  process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DEBUG && console.log('📊 Tier:', tier);
  process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DEBUG && console.log('🔗 Matrix Key:', matrixKey);
  process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DEBUG && console.log('🎚️  Slider Numeric Value:', sliderVal);
  process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DEBUG && console.log('⭐ Matrix Score:', score);
  process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DEBUG && console.log('📈 Max Impact %:', maxImpact);
  process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DEBUG && console.log('💵 Turnover:', turnover);
  process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DEBUG && console.log('🧮 Base Impact:', baseImpact, '(sliderVal * score/100 * maxImpact * turnover)');
  process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DEBUG && console.log('📅 Projection Year:', projectionYear);
  process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DEBUG && console.log('📊 Annual Growth Rate:', parameters.annualGrowthRate, '%');
  process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DEBUG && console.log('🚀 Multiplier:', multiplier, '(1 + growthRate)^(year-1)');
  process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DEBUG && console.log('💎 Final Impact:', finalImpact);
  console.groupEnd();

  return finalImpact;
}, [industry, tier, turnover, projectionYear, parameters]);
 */

// Also update getDollarImpact to include all dependencies
const getDollarImpact = useCallback((key, label) => {
  const matrixKey = `${industry}:${tier}`;
  const sliderVal = getNumericImpact(key, label) ?? 0;
  const score = matrixScores[key]?.[matrixKey] ?? 0;
  const maxImpact = parameters.maxImpactPercents[key] ?? 0.001;
  const baseImpact = sliderVal * (score / 100) * maxImpact * turnover;
  const multiplier = Math.pow(1 + (parameters.annualGrowthRate / 100), projectionYear - 1);
  const finalImpact = baseImpact * multiplier;

  return finalImpact;
}, [industry, tier, parameters, turnover, projectionYear]); // All dependencies included

// Add this debug useEffect to track slider changes and recalculations
useEffect(() => {
  process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DEBUG && console.group('🔄 Slider Values Changed');
  process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DEBUG && console.log('📊 Current Slider Values:', sliderValues);
  
  // Calculate and log impacts for each factor
  Object.entries(sliderValues).forEach(([key, values]) => {
    const currentValue = values?.current ?? 0;
    const targetValue = values?.target ?? 0;
    
    if (currentValue !== 0 || targetValue !== 0) {
      const currentLabel = sliderLabels[key]?.[currentValue] ?? `Level ${currentValue}`;
      const targetLabel = sliderLabels[key]?.[targetValue] ?? `Level ${targetValue}`;
      
      const currentImpact = getDollarImpact(key, currentLabel);
      const targetImpact = getDollarImpact(key, targetLabel);
      const factorDifference = targetImpact - currentImpact;
      
      process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DEBUG && console.group(`📈 Factor: ${key}`);
      process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DEBUG && console.log('🎯 Current Level:', currentValue, '-', currentLabel);
      process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DEBUG && console.log('🎯 Target Level:', targetValue, '-', targetLabel);
      process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DEBUG && console.log('💰 Current Impact:', currentImpact);
      process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DEBUG && console.log('💰 Target Impact:', targetImpact);
      process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DEBUG && console.log('📊 Difference:', factorDifference);
      console.groupEnd();
    }
  });

  // Log category totals
  console.group('📊 Category Totals');
  Object.entries(categoryTotals).forEach(([category, total]) => {
    process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DEBUG && console.log(`${category}: ${getCurrencySymbol(selectedCurrency)}${total.toLocaleString()}`);
  });
  process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DEBUG && console.log('💰 Total Impact:', totalImpact);
  console.groupEnd();

  console.groupEnd();
}, [sliderValues, categoryTotals]);

// Add this to debug initial values
useEffect(() => {
  process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DEBUG && console.log('🎯 Initial Parameters:');
  process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DEBUG && console.log('🏭 Industry:', industry);
  process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DEBUG && console.log('📊 Tier:', tier);
  process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DEBUG && console.log('👤 Persona:', persona);
  process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DEBUG && console.log('💵 Turnover:', turnover);
  process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DEBUG && console.log('📅 Projection Year:', projectionYear);
  process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DEBUG && console.log('⚙️ Parameters:', parameters);
  process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DEBUG && console.log('🏷️ Slider Labels available:', Object.keys(sliderLabels));
}, []);

// Add debug for matrix scores
useEffect(() => {
  process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DEBUG && console.log('📋 Matrix Scores by Industry-Tier:');
  Object.entries(matrixScores).forEach(([factor, industries]) => {
    const matrixKey = `${industry}:${tier}`;
    const score = industries[matrixKey] ?? 'N/A';
    process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DEBUG && console.log(`   ${factor}: ${score} (for ${matrixKey})`);
  });
}, [industry, tier]);

// Add debug for max impact percents
useEffect(() => {
  process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DEBUG && console.log('📈 Max Impact Percents:');
  Object.entries(maxImpactPercents).forEach(([factor, percent]) => {
    process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DEBUG && console.log(`   ${factor}: ${percent}%`);
  });
}, []);

// Add this to debug the getNumericImpact function
const debugGetNumericImpact = useCallback((key, label) => {
  const result = getNumericImpact(key, label);
  process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DEBUG && console.log(`🔢 getNumericImpact('${key}', '${label}') =`, result);
  return result;
}, []);

// Test the getNumericImpact function for a few values
useEffect(() => {
  if (Object.keys(sliderLabels).length > 0) {
    const testKey = Object.keys(sliderLabels)[0];
    const testLabels = Object.values(sliderLabels[testKey] || {});
    
    if (testLabels.length > 0) {
      console.group('🧪 Testing getNumericImpact function');
      testLabels.slice(0, 3).forEach(label => {
        debugGetNumericImpact(testKey, label);
      });
      console.groupEnd();
    }
  }
}, [sliderLabels]);




const addCredits = useCallback(async (amount) => {
  if (!token) {
    enqueueSnackbar('Authentication required', { variant: 'error' });
    return;
  }

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/api/users/${user._id}/credits`,
      { amount },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
   // setCredits(response.data.credits);
    if (refreshUser) await refreshUser();
    return response.data.credits;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to add credits');
  }
}, [user?._id, token, refreshUser, enqueueSnackbar]);

// Replace the current getFactorImpact with this properly memoized version
const getFactorImpact = useCallback((key, value) => {
  try {
    // Ensure value is a number
    const numericValue = typeof value === 'number' ? value : parseInt(value) || 0;
    
    // Get the label for this value
    const label = sliderLabels[key]?.[numericValue] ?? `Level ${numericValue}`;
    
    // Calculate impact
    const impact = getDollarImpact(key, label);
    
    process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DEBUG && console.log(`📊 Factor ${key} at level ${numericValue} (${label}): ${getCurrencySymbol(selectedCurrency)}${impact}`);
    
    return impact;
  } catch (error) {
    console.error(`Error calculating impact for ${key}:`, error);
    return 0;
  }
}, [sliderLabels, getDollarImpact]);



 /*  const categoryTotals = useMemo(() => {
    const totals = {};
    categories.forEach(cat => {
      totals[cat.name] = cat.factors.reduce((sum, f) => {
        const currentValue = sliderValues[f.key]?.current ?? 0;
        const targetValue = sliderValues[f.key]?.target ?? 0;
        return sum + (getFactorImpact(f.key, targetValue) - getFactorImpact(f.key, currentValue));
      }, 0);
    });
    return totals;
  }, [categories, sliderValues, getFactorImpact]); */
  
// Add this useEffect to recalculate impacts when dependencies change
useEffect(() => {
  const recalculateImpacts = () => {
    const newTotals = {};
    categories.forEach(cat => {
      newTotals[cat.name] = cat.factors.reduce((sum, f) => {
        const currentValue = sliderValues[f.key]?.current ?? 0;
        const targetValue = sliderValues[f.key]?.target ?? 0;
        const currentImpact = getFactorImpact(f.key, currentValue);
        const targetImpact = getFactorImpact(f.key, targetValue);
        return sum + (targetImpact - currentImpact);
      }, 0);
    });
    setCategoryTotals(newTotals);
  };

  // Debounce to prevent excessive recalculations
  const timeoutId = setTimeout(recalculateImpacts, 50);
  return () => clearTimeout(timeoutId);
}, [sliderValues, industry, tier, turnover, projectionYear, parameters, categories]);


// Add this debug useEffect
useEffect(() => {
  process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DEBUG && console.log('Slider values updated:', sliderValues);
  process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DEBUG && console.log('Current category totals:', categoryTotals);
  
  // Test one factor to see if calculation works
  if (Object.keys(sliderValues).length > 0) {
    const firstKey = Object.keys(sliderValues)[0];
    const testImpact = getFactorImpact(firstKey, sliderValues[firstKey]?.current || 0);
    process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DEBUG && console.log('Test impact for', firstKey, ':', testImpact);
  }
}, [sliderValues, categoryTotals, getFactorImpact]);

  
  useEffect(() => {
  const calculateTotals = () => {
    const totals = {};
    categories.forEach(cat => {
      totals[cat.name] = cat.factors.reduce((sum, f) => {
        const currentValue = sliderValues[f.key]?.current ?? 0;
        const targetValue = sliderValues[f.key]?.target ?? 0;
        return sum + (getFactorImpact(f.key, targetValue) - getFactorImpact(f.key, currentValue));
      }, 0);
    });
    return totals;
  };

  setCategoryTotals(calculateTotals());
}, [sliderValues, categories, getFactorImpact]);




const totalImpact = useMemo(() => (
  Object.values(categoryTotals).reduce((sum, total) => sum + total, 0)
), [categoryTotals]);
  
// Filter out categories with zero impact for reports
const nonZeroCategories = categories.filter(cat => categoryTotals[cat.name] > 0);

    // Core calculation engine (fully memoized)
/*   const { categoryTotals, totalImpact } = useMemo(() => {
    const totals = calculateCategoryTotals();
    return {
      categoryTotals: totals,
      totalImpact: Object.values(totals).reduce((sum, v) => sum + v, 0)
    };
  }, [sliderValues, industry, tier, turnover, projectionYear]);
 */



  // API Operations
const saveScenario = useCallback(async () => {
  if (!user || !token) {
    enqueueSnackbar('You must be logged in to save a scenario.', { variant: 'warning' });
    return;
  }

  try {
    await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/api/scenario/save`,
      {
        userId: user._id,
        config: scenario,
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    enqueueSnackbar('Scenario saved successfully!', { variant: 'success' });
  } catch (err) {
    console.error('Save scenario error:', err);
    enqueueSnackbar('Failed to save scenario.', { variant: 'error' });
  }
}, [user, token, scenario, enqueueSnackbar]);

const fetchSavedScenarios = useCallback(async () => {
  if (!user?._id || !token) return;
  
  try {
    const { data } = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/scenarios`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    setSavedScenarios(data || []);
  } catch (error) {
    enqueueSnackbar('Failed to load scenarios', { variant: 'error' });
  }
}, [user?._id, token, enqueueSnackbar, setSavedScenarios]);

const debugDatabaseStructure = (data) => {
  console.group('🏗️ DATABASE STRUCTURE ANALYSIS');
  console.log('📦 Full data object:', data);
  console.log('🔑 Top-level keys:', Object.keys(data));
  
  if (data.values) {
    console.log('📊 Values object keys:', Object.keys(data.values));
    console.log('📋 Sample of values content:');
    
    const sampleKeys = Object.keys(data.values).slice(0, 5);
    sampleKeys.forEach(key => {
      console.log(`   ${key}:`, data.values[key]);
    });
  } else {
    console.error('❌ NO VALUES OBJECT FOUND IN DATA!');
  }
  
  console.groupEnd();
};


const ChartValidation = {
  // Validate complete chart data structure
  validateChartData: (data) => {
    if (!data || typeof data !== 'object') {
      console.error('❌ Chart data is not an object:', data);
      return false;
    }

    // Check for required properties
    if (!data.labels || !Array.isArray(data.labels)) {
      console.error('❌ Chart data missing valid labels array:', data.labels);
      return false;
    }

    if (!data.datasets || !Array.isArray(data.datasets)) {
      console.error('❌ Chart data missing valid datasets array:', data.datasets);
      return false;
    }

    // Validate labels
    if (data.labels.length === 0) {
      console.error('❌ Chart labels array is empty');
      return false;
    }

    // Validate each dataset
    for (let i = 0; i < data.datasets.length; i++) {
      const dataset = data.datasets[i];
      if (!dataset || typeof dataset !== 'object') {
        console.error(`❌ Dataset ${i} is not a valid object:`, dataset);
        return false;
      }

      if (!dataset.data || !Array.isArray(dataset.data)) {
        console.error(`❌ Dataset ${i} missing data array:`, dataset.data);
        return false;
      }

      // Check data length matches labels length
      if (dataset.data.length !== data.labels.length) {
        console.error(`❌ Dataset ${i} data length (${dataset.data.length}) doesn't match labels length (${data.labels.length})`);
        return false;
      }

      // Validate individual data points
      for (let j = 0; j < dataset.data.length; j++) {
        const value = dataset.data[j];
        if (value === null || value === undefined || isNaN(Number(value))) {
          console.error(`❌ Invalid data point at index ${j} in dataset ${i}:`, value);
          return false;
        }
      }
    }

    console.log('✅ Chart data validation passed');
    return true;
  },

  // Create safe fallback data
  createFallbackData: (labels = ['Default Dimension']) => {
    return {
      labels: Array.isArray(labels) ? labels : ['Default Dimension'],
      datasets: [
        {
          label: 'Fallback Data',
          data: [50],
          backgroundColor: 'rgba(200, 200, 200, 0.2)',
          borderColor: 'rgba(100, 100, 100, 0.5)',
          borderWidth: 1,
        }
      ]
    };
  },

  // Sanitize and normalize chart data
  sanitizeChartData: (data, expectedLabels) => {
    try {
      // If data is completely invalid, return fallback
      if (!data || typeof data !== 'object') {
        console.warn('⚠️ Data is invalid, using fallback');
        return ChartValidation.createFallbackData(expectedLabels);
      }

      // Ensure labels exist and are valid
      const safeLabels = Array.isArray(data.labels) && data.labels.length > 0 
        ? data.labels 
        : (Array.isArray(expectedLabels) ? expectedLabels : ['Dimension 1', 'Dimension 2', 'Dimension 3']);

      // Ensure datasets exist
      const safeDatasets = Array.isArray(data.datasets) ? [...data.datasets] : [];

      // Validate and fix each dataset
      const validatedDatasets = safeDatasets.map((dataset, index) => {
        if (!dataset || typeof dataset !== 'object') {
          return {
            label: `Dataset ${index + 1}`,
            data: Array(safeLabels.length).fill(50),
            backgroundColor: 'rgba(200, 200, 200, 0.2)',
            borderColor: `hsl(${index * 60}, 70%, 50%)`,
            borderWidth: 2,
          };
        }

        // Ensure data array exists and has correct length
        const dataArray = Array.isArray(dataset.data) ? dataset.data : [];
        const safeData = safeLabels.map((_, i) => {
          const value = dataArray[i];
          return value !== null && value !== undefined && !isNaN(Number(value)) 
            ? Math.max(0, Math.min(100, Number(value))) 
            : 50;
        });

        return {
          label: dataset.label || `Dataset ${index + 1}`,
          data: safeData,
          backgroundColor: dataset.backgroundColor || `rgba(${100 + index * 50}, ${150 + index * 30}, ${200}, 0.2)`,
          borderColor: dataset.borderColor || `hsl(${index * 60}, 70%, 50%)`,
          borderWidth: dataset.borderWidth || 2,
          pointBackgroundColor: dataset.pointBackgroundColor || dataset.borderColor || `hsl(${index * 60}, 70%, 50%)`,
          pointRadius: dataset.pointRadius || 4,
          ...dataset
        };
      });

      // If no valid datasets, create a default one
      if (validatedDatasets.length === 0) {
        validatedDatasets.push({
          label: 'Default Dataset',
          data: Array(safeLabels.length).fill(50),
          backgroundColor: 'rgba(100, 150, 200, 0.2)',
          borderColor: 'rgba(100, 150, 200, 1)',
          borderWidth: 2,
        });
      }

      return {
        labels: safeLabels,
        datasets: validatedDatasets
      };
    } catch (error) {
      console.error('❌ Error sanitizing chart data:', error);
      return ChartValidation.createFallbackData(expectedLabels);
    }
  }
};



// Then call it in your handleLoadScenario function after getting data:
// Add this line right after: console.log('✅ Database scenario loaded:', data.name);
//debugDatabaseStructure(data);

//***********************
// lOAD GUIDELINE-scenario loading function
// Replace the problematic handleLoadGuidelineScenario function with this fixed version

const handleLoadGuidelineScenario = async (id) => {
  try {
    const response = await axios.get(`/api/scenarios/${id}`);
    const data = response.data; // Make sure data is properly extracted from response

    // Add proper validation for the data
    if (!data) {
      throw new Error('No data received from server');
    }

    setParameters(data.parameters || defaultParameters);
    setIndustry(data.industry || 'automotive');
    setTier(data.tier || 'OEM');
    setPersona(data.persona || 'CFO');
    setTurnover(data.turnover || 100000000);
    setProjectionYear(data.projectionYear || 1);
    setScenarioName(`Copy of ${data.name || 'Guideline Scenario'}`);
    
    enqueueSnackbar('Guideline scenario loaded. Customize as needed!', { 
      variant: 'info',
      autoHideDuration: 5000
    });
  } catch (error) {
    console.error('Failed to load guideline scenario:', error);
    enqueueSnackbar('Failed to load guideline scenario', { variant: 'error' });
  }
};

  // UI Components
  const TopBar = useMemo(() => (
    <Paper elevation={3} sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <Typography variant="h6">ROI Analyzer</Typography>
      {user && user?.credits !== null && (
        <Typography variant="body1" color="primary">
          Credits: {user?.credits}
        </Typography>
      )}
      <Button variant="contained" color="secondary" onClick={saveScenario}>
        Save Scenario
      </Button>
    </Paper>
  ), [user, saveScenario]);





const handleDeleteScenario = async (id) => {
  if (!token) {
    enqueueSnackbar('Authentication required', { variant: 'error' });
    return;
  }

  try {
    await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/scenarios/${id}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    fetchSavedScenarios();
    enqueueSnackbar('Scenario deleted successfully!', { variant: 'success' });
  } catch (error) {
    enqueueSnackbar('Failed to delete scenario', { variant: 'error' });
  }
};


/* const handlePurchaseCredits = async (amount) => {
    try {
      enqueueSnackbar('Processing payment...', { variant: 'info' });
      await addCredits(amount);
      enqueueSnackbar(`${amount} credits added!`, { variant: 'success' });
    } catch (error) {
      enqueueSnackbar(error.message, { variant: 'error' });
    }
  }; */

const handlePurchaseSuccess = (result) => {
  enqueueSnackbar(
    `Success! ${result.creditsAdded} credits added to your account`,
    { variant: 'success' }
  );
  // Refresh user data to update credits
  if (refreshUser) refreshUser();
};

// Handle package selection
// Update handlePackageSelect to include currency info

const handlePackageSelect = (selectedPackage) => {
  setSelectedPackage(selectedPackage);
  setPurchaseModalOpen(true);
};

/* const handlePurchaseCredits = () => {
  if (!user) {
    enqueueSnackbar('Please sign in to purchase credits', { variant: 'warning' });
    return;
  }
  setPurchaseModalOpen(true);
}; */

const handleTabChange = async (tabId) => {
  setLocalActiveTab(tabId);
  setActiveTab(tabId);

  // Force reload scenarios when "Scenario Vault" is opened
  if (tabId === 'scenarios' && isAuthenticated) {
    try {
      await fetchScenarios();  // Explicitly reload
    } catch (error) {
      enqueueSnackbar('Failed to load scenarios', { variant: 'error' });
    }
  }
};


const validateScenarioData = (data) => {
  const warnings = [];
  let isValid = true;

  // Check if data exists
  if (!data) {
    warnings.push('No data received from database');
    return { isValid: false, warnings };
  }

  // Check if values object exists
  if (!data.values || typeof data.values !== 'object') {
    warnings.push('No values object found in scenario data');
    isValid = false;
    return { isValid, warnings };
  }

  // Check if values object is empty
  if (Object.keys(data.values).length === 0) {
    warnings.push('Values object is empty');
    isValid = false;
  }

  // Check for all zeros scenario
  const allValues = Object.values(data.values);
  const allZeros = allValues.every(value => 
    value && value.current === 0 && value.target === 0
  );
  
  if (allZeros) {
    warnings.push('All slider values are set to zero (0) - this may indicate corrupted data');
    isValid = false;
  }

  // Check for invalid number ranges
  let invalidRanges = 0;
  Object.entries(data.values).forEach(([key, value]) => {
    if (value) {
      if (value.current < 0 || value.current > 10) invalidRanges++;
      if (value.target < 0 || value.target > 10) invalidRanges++;
    }
  });
  
  if (invalidRanges > 0) {
    warnings.push(`${invalidRanges} values are outside valid range (0-10)`);
  }

  return { isValid, warnings };
};

const processSliderValuesWithValidation = (values) => {
  const processedValues = {};
  const validationIssues = [];
  let factorsProcessed = 0;
  let factorsWithData = 0;

  console.group('🔍 Processing Slider Values with Validation');
  
  categories.forEach((category, catIndex) => {
    category.factors.forEach((factor, factorIndex) => {
      const factorKey = factor.key;
      factorsProcessed++;
      
      const savedValue = values?.[factorKey];
      
      console.log(`🔧 Processing ${factorKey}:`, savedValue);

      if (savedValue && typeof savedValue === 'object') {
        factorsWithData++;
        
        // Validate and clamp values
        const current = Math.min(10, Math.max(0, Number(savedValue.current) || 0));
        const target = Math.min(10, Math.max(0, Number(savedValue.target) || 0));
        
        // Check for data quality issues
        if (current === 0 && target === 0) {
          validationIssues.push(`${factorKey}: Both current and target are zero`);
        }
        
        if (current > target) {
          validationIssues.push(`${factorKey}: Current (${current}) > Target (${target})`);
        }
        
        processedValues[factorKey] = { current, target };
        console.log(`✅ ${factorKey}: Current=${current}, Target=${target}`);
        
      } else {
        // No data found for this factor - use defaults
        processedValues[factorKey] = { current: 0, target: 5 };
        validationIssues.push(`${factorKey}: No data found, using defaults`);
        console.log(`⚠️ ${factorKey}: No data, using defaults`);
      }
    });
  });

  console.log(`📊 Validation Summary: ${factorsWithData}/${factorsProcessed} factors had data`);
  console.log('❌ Validation Issues:', validationIssues);
  console.groupEnd();

  return {
    processedValues,
    validationSummary: {
      totalFactors: factorsProcessed,
      factorsWithData,
      validationIssues
    }
  };
};



// HANDLE LOAD SCENARIO


const handleLoadScenario = useCallback(async (id) => {
  if (!token) {
    enqueueSnackbar('Authentication required', { variant: 'error' });
    return;
  }

  try {
    console.group('🚀 START: handleLoadScenario - DIRECT DATA MAPPING');
    console.log('📥 Loading scenario ID:', id);
    
    const { data } = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/api/scenarios/${id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
        timeout: 10000
      }
    );

    if (!data) throw new Error('No scenario data received');
    if (!data._id || !data.userId) throw new Error('Invalid scenario data');

    console.log('✅ Database scenario loaded:', data.name);
    console.log('📊 Full data.values object:', data.values);

    // ✅ CRITICAL FIX: Create a new sliderValues object that directly maps to your categories
    const newSliderValues = {};
    
    // Get all factor keys from your categories
    const allFactorKeys = categories.flatMap(category => 
      category.factors.map(factor => factor.key)
    );
    
    console.log('🔑 All factor keys from categories:', allFactorKeys);
    
    // Map each factor key to its corresponding database value
    allFactorKeys.forEach(factorKey => {
      const databaseValue = data.values[factorKey];
      
      console.log(`🔍 Mapping ${factorKey}:`, {
        existsInDatabase: databaseValue !== undefined,
        databaseValue: databaseValue,
        factorKey: factorKey
      });
      
      if (databaseValue && 
          typeof databaseValue.current === 'number' && 
          typeof databaseValue.target === 'number') {
        // ✅ Direct mapping from database to state
        newSliderValues[factorKey] = {
          current: databaseValue.current,
          target: databaseValue.target
        };
        console.log(`✅ ${factorKey}: Successfully mapped current=${databaseValue.current}, target=${databaseValue.target}`);
      } else {
        // Use defaults if not found or invalid
        newSliderValues[factorKey] = { current: 0, target: 5 };
        console.warn(`⚠️ ${factorKey}: Using defaults - current=0, target=5`);
      }
    });
    
    console.log('🎯 Final newSliderValues:', newSliderValues);
    
    // ✅ Set the state with the properly mapped values
    setSliderValues(newSliderValues);
    setParameters(data.parameters || defaultParameters);
    setIndustry(data.industry || 'automotive');
    setTier(data.tier || 'OEM');
    setPersona(data.persona || 'CFO');
    setTurnover(Number(data.turnover) || 100000000);
    setProjectionYear(Number(data.projectionYear) || 1);
    setScenarioName(data.name || 'Unnamed Scenario');

    // Reset analysis state
    setProgress(0);
    setIsPlaying(false);
    
    console.log('✅ All state updates completed');
    console.groupEnd();

    enqueueSnackbar(`"${data.name}" loaded successfully!`, { 
      variant: 'success',
      autoHideDuration: 2000
    });

  } catch (error) {
    console.error('❌ FAILED to load scenario:', error);
    console.groupEnd();
    enqueueSnackbar(error.message || 'Failed to load scenario', { 
      variant: 'error',
      autoHideDuration: 3000
    });
  }
}, [token, enqueueSnackbar, categories]);




// HANDLE VIEW SCENARIO

const debugDataStructure = (data) => {
  console.group('🏗️ DATA STRUCTURE VERIFICATION');
  
  // Check if data.values exists and has the right structure
  if (!data.values) {
    console.error('❌ data.values is undefined!');
    console.groupEnd();
    return;
  }
  
  console.log('✅ data.values exists with keys:', Object.keys(data.values));
  
  // Check a few sample factors to verify structure
  const sampleFactors = ['sustainabilityPressure', 'esgCompliance', 'greenProductInnovation'];
  sampleFactors.forEach(factorKey => {
    const factorData = data.values[factorKey];
    console.log(`🔍 ${factorKey}:`, {
      exists: factorData !== undefined,
      structure: factorData,
      hasCurrent: factorData?.current !== undefined,
      hasTarget: factorData?.target !== undefined,
      currentValue: factorData?.current,
      targetValue: factorData?.target
    });
  });
  
  console.groupEnd();
};


const handleViewScenarioDetails = useCallback((scenario) => {
  console.group("🔍 handleViewScenarioDetails Debug");
  console.log("📥 Scenario object received:", scenario);
  console.log("🆔 Scenario ID:", scenario?._id);
  console.log("📛 Scenario name:", scenario?.name);
  console.log("📊 Values structure:", scenario?.values);
  
  if (!scenario?._id) {
    console.error("❌ No scenario ID provided!");
    console.groupEnd();
    return;
  }
  
  // 🛡️ VALIDATION 1: Check if values object exists and has data
  if (!scenario.values || typeof scenario.values !== 'object') {
    console.error("❌ No values object found in scenario!");
    console.groupEnd();
    enqueueSnackbar('Scenario data is corrupted - no values found', { variant: 'error' });
    return;
  }
  
  // 🛡️ VALIDATION 2: Check if values object is not empty
  if (Object.keys(scenario.values).length === 0) {
    console.error("❌ Values object is empty!");
    console.groupEnd();
    enqueueSnackbar('Scenario has no configuration data', { variant: 'warning' });
    return;
  }
  
  // 🔧 DIRECT SLIDER POSITIONING - Set slider values immediately
  console.group("🎯 DIRECT SLIDER POSITIONING");
  
  let validFactorsCount = 0;
  let totalFactors = 0;
  
  // Create new slider values object
  const newSliderValues = { ...sliderValues }; // Start with current state
  
  categories.forEach(category => {
    category.factors.forEach(factor => {
      const factorKey = factor.key;
      totalFactors++;
      
      const savedValue = scenario.values[factorKey];
      
      if (savedValue && typeof savedValue === 'object') {
        // 🎯 EXTRACT AND VALIDATE X (current) and Y (target) VALUES
        const x = Number(savedValue.current);
        const y = Number(savedValue.target);
        
        console.log(`📈 ${factorKey}:`, {
          raw: { current: savedValue.current, target: savedValue.target },
          parsed: { x, y },
          valid: !isNaN(x) && !isNaN(y)
        });
        
        // 🛡️ RANGE VALIDATION: Ensure values are between 0-10
        if (!isNaN(x) && !isNaN(y)) {
          const clampedX = Math.max(0, Math.min(10, x));
          const clampedY = Math.max(0, Math.min(10, y));
          
          newSliderValues[factorKey] = {
            current: clampedX,  // X position
            target: clampedY    // Y position
          };
          
          validFactorsCount++;
          
          // Log if clamping was needed
          if (x !== clampedX || y !== clampedY) {
            console.warn(`⚡ ${factorKey}: Values clamped from (${x},${y}) to (${clampedX},${clampedY})`);
          }
        } else {
          console.error(`❌ ${factorKey}: Invalid numeric values`, { x, y });
          // Use defaults for invalid data
          newSliderValues[factorKey] = { current: 0, target: 5 };
        }
      } else {
        console.warn(`⚠️ ${factorKey}: No data found, using defaults`);
        newSliderValues[factorKey] = { current: 0, target: 5 };
      }
    });
  });
  
  console.log(`📊 Positioning Summary: ${validFactorsCount}/${totalFactors} factors positioned`);
  console.groupEnd();
  
  // 🛡️ VALIDATION 3: Check if we have any valid data
  if (validFactorsCount === 0) {
    console.error("❌ No valid slider data found in scenario!");
    enqueueSnackbar('Scenario contains no valid configuration data', { variant: 'error' });
    console.groupEnd();
    return;
  }
  
  // 🎯 IMMEDIATE SLIDER POSITIONING - Update state directly
  console.log("🚀 DIRECT STATE UPDATE: Setting slider positions...");
  setSliderValues(newSliderValues);
  
  // 📊 Log the final positioned values for verification
  console.group("✅ FINAL SLIDER POSITIONS");
  Object.entries(newSliderValues).slice(0, 3).forEach(([key, values]) => {
    console.log(`🎚️ ${key}: Current(X)=${values.current}, Target(Y)=${values.target}`);
  });
  console.groupEnd();
  
  // 🔄 ALSO call handleLoadScenario for comprehensive loading
  console.log("🔄 Calling handleLoadScenario for full data sync...");
  handleLoadScenario(scenario._id);
  
  // 📝 Update scenario name
  setScenarioName(scenario.name || 'Unnamed Scenario');
  
  // 🎯 Force UI update by resetting and immediately showing results
  setProgress(100);
  setIsPlaying(false);
  
  // 💬 User feedback
  setScenarioNotification({
    open: true,
    message: `✅ "${scenario.name}" loaded - ${validFactorsCount} factors positioned`
  });
  
  // 📊 Additional success logging
  console.group("🎉 SCENARIO LOAD SUCCESS");
  console.log("✅ Slider positions set directly");
  console.log("✅ handleLoadScenario called for full sync");
  console.log("✅ UI state updated");
  console.log(`✅ ${validFactorsCount} factors successfully positioned`);
  console.groupEnd();
  
  // 🏠 Switch to analyze tab to show the results
  handleTabChange('analyze');
  
  console.groupEnd();
}, [sliderValues, categories, handleLoadScenario, handleTabChange, enqueueSnackbar]);

// Adding Helper functions for compare scenarios,


// Utility functions for scenario comparison
const triggerSelectionAnimation = (scenarioId) => {
  console.log(`Selected scenario: ${scenarioId}`);
};

const trackComparisonEvent = (scenarioCount, mode) => {
  console.log(`Comparison event: ${scenarioCount} scenarios, mode: ${mode}`);
};

const preloadComparisonData = (scenarioIds) => {
  console.log('Preloading comparison data for:', scenarioIds);
};


const getProbabilityColor = (scenario) => {
  const probability = calculateSuccessProbability(scenario);
  if (probability >= 85) return 'success.main';
  if (probability >= 70) return 'warning.main';
  return 'error.main';
};

// Enhanced scenario selection handler
const toggleScenarioSelection = useCallback((scenarioId) => {
  setSelectedScenarios(prev => {
    const isSelected = prev.includes(scenarioId);
    
    if (isSelected) {
      return prev.filter(id => id !== scenarioId);
    } else {
      if (prev.length < 4) {
        triggerSelectionAnimation(scenarioId);
        return [...prev, scenarioId];
      }
      return prev;
    }
  });
}, []);

// Clear all selections
const clearSelection = useCallback(() => {
  setSelectedScenarios([]);
  enqueueSnackbar('Selection cleared', { variant: 'info' });
}, [enqueueSnackbar]);

const SelectedScenarioAnalysis = ({ scenario, quadrant }) => {
  // Safety check for undefined props
  if (!scenario || !quadrant) {
    return (
      <Paper sx={{ mt: 2, p: 3, backgroundColor: 'grey.100' }}>
        <Typography color="text.secondary">No scenario data available for analysis.</Typography>
      </Paper>
    );
  }

  const getQuadrantSpecificRecommendations = () => {
    const impact = scenario.totalImpact / 1000000;
    const complexity = scenario.implementationComplexity;
    
    switch(quadrant.label) {
      case "Quick Wins":
        return {
          priority: "HIGH PRIORITY - EXECUTE IMMEDIATELY",
          timing: "Short-term (3-6 months)",
          team: "Cross-functional rapid deployment team",
          budget: "Minimal capital required",
          risks: "Low risk, high reward",
          actions: [
            "Assign dedicated project manager",
            "Start within 30 days",
            "Measure ROI quarterly",
            "Use as showcase for executive buy-in"
          ],
          kpis: ["Time to implement", "ROI realization", "Stakeholder satisfaction"],
          successProbability: 90,
          rationale: "Maximize ROI with minimal risk and build transformation momentum."
        };
        
      case "Major Projects":
        return {
          priority: "STRATEGIC PRIORITY - PLAN CAREFULLY",
          timing: "Long-term (12-24 months)",
          team: "Executive sponsorship + dedicated program team",
          budget: "Significant capital investment required",
          risks: "High risk, high reward - requires careful governance",
          actions: [
            "Create phased implementation plan",
            "Secure executive sponsorship",
            "Establish governance committee",
            "Pilot in one business unit first",
            "Plan for change management"
          ],
          kpis: ["Strategic alignment", "Business value delivered", "Adoption rates"],
          successProbability: 70,
          rationale: "Strategic investment for long-term competitive advantage and market positioning."
        };
        
      case "Fill-Ins":
        return {
          priority: "MAINTENANCE PRIORITY - SCHEDULE APPROPRIATELY",
          timing: "Ongoing/As-needed",
          team: "Operational teams",
          budget: "Operational expense",
          risks: "Low risk, incremental benefits",
          actions: [
            "Integrate into regular operations",
            "Assign to relevant department",
            "Monitor for cumulative benefits",
            "Combine with related initiatives"
          ],
          kpis: ["Process efficiency", "Cost reduction", "Cycle time improvement"],
          successProbability: 95,
          rationale: "Operational excellence and continuous improvement for sustained efficiency."
        };
        
      case "Thankless Tasks":
        return {
          priority: "NECESSARY INVESTMENT - MANAGE EXPECTATIONS",
          timing: "Medium-term (6-12 months)",
          team: "Specialized technical team",
          budget: "Required investment with indirect ROI",
          risks: "Essential but not glamorous - manage stakeholder expectations",
          actions: [
            "Clearly communicate necessity to stakeholders",
            "Bundle with higher-value initiatives",
            "Track indirect benefits",
            "Consider outsourcing if not core competency"
          ],
          kpis: ["Risk mitigation", "Compliance adherence", "System stability"],
          successProbability: 50,
          rationale: "Essential infrastructure and compliance requirements that enable other initiatives."
        };
        
      default:
        return {
          priority: "PRIORITY NOT DEFINED",
          timing: "Timeline not specified",
          team: "Team structure not defined",
          budget: "Budget consideration not specified",
          risks: "Risk profile not defined",
          actions: ["No specific actions defined"],
          kpis: ["No KPIs defined"],
          successProbability: 0,
          rationale: "Strategic rationale not available."
        };
    }
  };

  const recommendations = getQuadrantSpecificRecommendations();
  
  // Get color based on quadrant
  const getPriorityColor = () => {
    switch(quadrant.label) {
      case "Quick Wins": return "success";
      case "Major Projects": return "primary";
      case "Fill-Ins": return "warning";
      case "Thankless Tasks": return "error";
      default: return "default";
    }
  };

  // Get progress bar color
  const getProgressColor = () => {
    switch(quadrant.label) {
      case "Quick Wins": return '#4CAF50';
      case "Major Projects": return '#2196F3';
      case "Fill-Ins": return '#FFC107';
      case "Thankless Tasks": return '#FF5722';
      default: return '#9E9E9E';
    }
  };

  return (
    <Paper sx={{ 
      mt: 2, 
      p: 3, 
      backgroundColor: `${quadrant.color}08`, 
      border: `2px solid ${quadrant.color}30`,
      borderRadius: 2
    }}>
      <Typography variant="h6" gutterBottom sx={{ color: quadrant.color, display: 'flex', alignItems: 'center' }}>
        🎯 Strategic Recommendation: {quadrant.label}
      </Typography>
      
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
              Priority Level
            </Typography>
            <Chip 
              label={recommendations.priority} 
              color={getPriorityColor()}
              sx={{ 
                fontWeight: 'bold',
                fontSize: '0.875rem',
                py: 1
              }}
            />
          </Box>
          
          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
              Recommended Timeline
            </Typography>
            <Typography variant="body1" fontWeight="medium">
              {recommendations.timing}
            </Typography>
          </Box>
          
          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
              Team Structure
            </Typography>
            <Typography variant="body1">
              {recommendations.team}
            </Typography>
          </Box>
          
          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
              Budget Consideration
            </Typography>
            <Typography variant="body1">
              {recommendations.budget}
            </Typography>
          </Box>
        </Grid>
        
        <Grid item xs={12} md={6}>
          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
              Risk Profile
            </Typography>
            <Typography variant="body1">
              {recommendations.risks}
            </Typography>
          </Box>
          
          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
              Key Actions
            </Typography>
            <List dense sx={{ maxHeight: 200, overflow: 'auto' }}>
              {recommendations.actions.map((action, index) => (
                <ListItem key={index} sx={{ py: 0.5, px: 0 }}>
                  <ListItemIcon sx={{ minWidth: 32 }}>
                    <CheckCircle sx={{ fontSize: 18, color: quadrant.color }} />
                  </ListItemIcon>
                  <ListItemText 
                    primary={action} 
                    primaryTypographyProps={{ variant: 'body2' }}
                  />
                </ListItem>
              ))}
            </List>
          </Box>
        </Grid>
      </Grid>
      
      {/* Success Probability & Strategic Rationale */}
      <Box sx={{ 
        mt: 3, 
        p: 2.5, 
        bgcolor: 'background.default', 
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider'
      }}>
        <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold', display: 'flex', alignItems: 'center' }}>
          📊 Success Probability & Strategic Rationale
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Box sx={{ mb: 1 }}>
              <LinearProgress 
                variant="determinate" 
                value={recommendations.successProbability}
                sx={{ 
                  height: 10, 
                  borderRadius: 5,
                  mb: 1.5,
                  backgroundColor: 'grey.200',
                  '& .MuiLinearProgress-bar': {
                    backgroundColor: getProgressColor(),
                    borderRadius: 5
                  }
                }}
              />
              <Typography variant="body2" color="text.secondary">
                Estimated Success Probability: <strong>{recommendations.successProbability}%</strong>
              </Typography>
            </Box>
            
            {/* KPIs Section */}
            <Box sx={{ mt: 2 }}>
              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                Key Performance Indicators:
              </Typography>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                {recommendations.kpis.map((kpi, index) => (
                  <Chip
                    key={index}
                    label={kpi}
                    size="small"
                    variant="outlined"
                    sx={{ fontSize: '0.75rem' }}
                  />
                ))}
              </Box>
            </Box>
          </Grid>
          
          <Grid item xs={12} md={6}>
            <Box>
              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                Strategic Rationale
              </Typography>
              <Typography variant="body1" sx={{ lineHeight: 1.6 }}>
                {recommendations.rationale}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
};

// Enhanced comparison handler with multiple modes
const handleCompareScenarios = useCallback((mode = 'advanced') => {
  if (selectedScenarios.length < 2) {
    enqueueSnackbar('Please select at least 2 scenarios to compare', { 
      variant: 'warning',
      action: (
        <Button 
          color="inherit" 
          size="small" 
          onClick={() => setLocalActiveTab('scenarios')}
        >
          Create Scenarios
        </Button>
      )
    });
    return;
  }

  trackComparisonEvent(selectedScenarios.length, mode);

  switch (mode) {
    case 'quick':
      startQuickComparison();
      break;
    case 'advanced':
      startAdvancedComparison();
      break;
    case 'deep-dive':
      startDeepDiveComparison();
      break;
    default:
      startAdvancedComparison();
  }
}, [selectedScenarios, enqueueSnackbar]);

// Comparison mode handlers
const startQuickComparison = useCallback(() => {
  setComparisonMode(true);
  setComparisonView('matrix');
//  setLocalActiveTab('analyze');
  
  enqueueSnackbar(`Quick comparison started for ${selectedScenarios.length} scenarios`, {
    variant: 'success',
    autoHideDuration: 2000
  });
}, [selectedScenarios, enqueueSnackbar]);

const startAdvancedComparison = useCallback(() => {
  setComparisonMode(true);
  setComparisonView('radar');
  setLocalActiveTab('analyze');
  
  preloadComparisonData(selectedScenarios);
  
  enqueueSnackbar(`Advanced multi-dimensional analysis initiated`, {
    variant: 'info',
    autoHideDuration: 2500
  });
}, [selectedScenarios, enqueueSnackbar]);

const startDeepDiveComparison = useCallback(() => {
  if (selectedScenarios.length > 3) {
    enqueueSnackbar('AI Deep Dive is optimized for 2-3 scenarios', { 
      variant: 'warning' 
    });
    return;
  }

  setComparisonMode(true);
  setComparisonView('ai');
  setLocalActiveTab('analyze');
  
  const loadingKey = enqueueSnackbar('Running AI deep-dive analysis...', {
    variant: 'info',
    persist: true,
  });

  setTimeout(() => {
    enqueueSnackbar('Deep-dive analysis complete! Check AI Insights tab.', {
      variant: 'success',
      autoHideDuration: 3000
    });
  }, 2000);
}, [selectedScenarios, enqueueSnackbar]);

// Exit comparison mode
const exitComparisonMode = useCallback(() => {
  setComparisonMode(false);
  setSelectedScenarios([]);
  setLocalActiveTab('scenarios');
  enqueueSnackbar('Comparison mode exited', { variant: 'info' });
}, [enqueueSnackbar]);

// Add this effect to show/hide the comparison launcher
useEffect(() => {
  setShowComparisonLauncher(selectedScenarios.length > 0);
}, [selectedScenarios]);




// DOne adding helper of CompareScenarios,


/*   const toggleScenarioSelection = (scenarioId) => {
    setSelectedScenarios(prev => 
      prev.includes(scenarioId) 
        ? prev.filter(id => id !== scenarioId) 
        : [...prev, scenarioId]
    );
  }; */

// Enhanced ScenarioCard component with comparison features
const EnhancedScenarioCard = React.memo(({ 
  scenario, 
  isSelected, 
  onSelect, 
  onViewDetails,
  onDelete,
  selectionIndex 
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const theme = useTheme();

  return (
    <Card 
      sx={{ 
        cursor: 'pointer',
        border: isSelected ? '3px solid' : '1px solid',
        borderColor: isSelected ? theme.palette.primary.main : theme.palette.divider,
        background: isSelected ? 
          `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.05)} 0%, ${alpha(theme.palette.primary.main, 0.1)} 100%)` : 
          theme.palette.background.paper,
        transition: 'all 0.3s ease',
        position: 'relative',
        overflow: 'visible',
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: theme.shadows[8],
        }
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={() => onSelect(scenario._id)}
    >
      {/* Selection Indicator */}
      {isSelected && (
        <Box
          sx={{
            position: 'absolute',
            top: -8,
            right: -8,
            width: 28,
            height: 28,
            bgcolor: theme.palette.primary.main,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
            fontSize: '0.75rem',
            fontWeight: 'bold',
            zIndex: 2,
            boxShadow: theme.shadows[4]
          }}
        >
          {selectionIndex}
        </Box>
      )}
      
      {/* Hover Actions */}
      <Collapse in={isHovered}>
        <Box sx={{ 
          position: 'absolute', 
          top: 8, 
          right: 8, 
          display: 'flex', 
          gap: 0.5,
          zIndex: 1
        }}>
          <Tooltip title="Quick compare">
            <IconButton 
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                handleCompareScenarios('quick');
              }}
              sx={{
                bgcolor: theme.palette.background.paper,
                '&:hover': { bgcolor: theme.palette.action.hover }
              }}
            >
              <CompareArrows fontSize="small" />
            </IconButton>
          </Tooltip>
          
          <Tooltip title="View details">
            <IconButton 
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                onViewDetails(scenario);
              }}
              sx={{
                bgcolor: theme.palette.background.paper,
                '&:hover': { bgcolor: theme.palette.action.hover }
              }}
            >
              <Visibility fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      </Collapse>

      <CardHeader
        avatar={
          <Avatar sx={{ 
            bgcolor: isSelected ? theme.palette.primary.main : theme.palette.grey[400],
            transition: 'all 0.3s ease'
          }}>
            {scenario.name?.charAt(0) || 'S'}
          </Avatar>
        }
        title={
          <Typography variant="h6" noWrap sx={{ fontWeight: 600 }}>
            {scenario.name}
          </Typography>
        }
        subheader={
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
            <Chip 
              label={scenario.industry} 
              size="small" 
              variant="outlined" 
              color="primary"
            />
            <Typography variant="caption" color="text.secondary">
              {new Date(scenario.createdAt).toLocaleDateString()}
            </Typography>
          </Box>
        }
      />
      
      <CardContent>
        {/* Impact Visualization */}
        <Box sx={{ mb: 2 }}>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Total Impact Potential
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <LinearProgress 
              variant="determinate" 
              value={Math.min(100, (scenario.totalImpact / 5000000) * 100)}
              sx={{ 
                flexGrow: 1,
                height: 8,
                borderRadius: 4,
                bgcolor: theme.palette.grey[200]
              }}
            />
            <Typography variant="body2" fontWeight="bold" color="primary">
              {getCurrencySymbol(selectedCurrency)}{(scenario.totalImpact / 1000).toFixed(0)}K
            </Typography>
          </Box>
        </Box>
        
        {/* Quick Stats */}
        <Grid container spacing={1}>
          <Grid item xs={6}>
            <Typography variant="caption" display="block" color="text.secondary">
              ROI Multiple
            </Typography>
            <Typography variant="body2" fontWeight="bold">
              {calculateROIMultiple(scenario).toFixed(1)}x
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="caption" display="block" color="text.secondary">
              Success Probability
            </Typography>
            <Typography variant="body2" fontWeight="bold" color={getProbabilityColor(scenario)}>
              {calculateSuccessProbability(scenario)}%
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
      
      <CardActions sx={{ justifyContent: 'space-between', p: 2 }}>
        <Button 
          size="small" 
          onClick={(e) => {
            e.stopPropagation();
            onViewDetails(scenario);
          }}
        >
          View Details
        </Button>
        <IconButton 
          size="small" 
          onClick={(e) => {
            e.stopPropagation();
            onDelete(scenario._id);
          }}
          color="error"
        >
          <Delete />
        </IconButton>
      </CardActions>
    </Card>
  );
});

// Comparison Launcher Component
const ComparisonLauncher = React.memo(() => {
  const theme = useTheme();
  
  return (
    <Zoom in={showComparisonLauncher}>
      <Paper 
        elevation={8} 
        sx={{ 
          position: 'fixed',
          bottom: 24,
          right: 24,
          zIndex: 1000,
          p: 2,
          borderRadius: '16px',
          background: theme.palette.background.paper,
          border: `1px solid ${theme.palette.divider}`
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          {/* Selection Avatar with Badge */}
          <Badge 
            badgeContent={selectedScenarios.length} 
            color="primary"
            overlap="circular"
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
          >
            <Avatar 
              sx={{ 
                bgcolor: theme.palette.primary.main,
                width: 56, 
                height: 56,
                boxShadow: theme.shadows[4]
              }}
            >
              <CompareArrows />
            </Avatar>
          </Badge>
          
          {/* Comparison Options */}
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Button
              variant="contained"
              size="small"
              startIcon={<CompareArrows />}
              onClick={() => handleCompareScenarios('quick')}
              sx={{ 
                borderRadius: '20px',
                fontSize: '0.75rem',
                minWidth: '140px',
                textTransform: 'none'
              }}
            >
              Quick Compare
            </Button>
            
            <Button
              variant="outlined"
              size="small"
              startIcon={<Analytics />}
              onClick={() => handleCompareScenarios('advanced')}
              sx={{ 
                borderRadius: '20px',
                fontSize: '0.75rem',
                minWidth: '140px',
                textTransform: 'none'
              }}
            >
              Advanced Analysis
            </Button>
            
            <Button
              variant="outlined"
              size="small"
              startIcon={<Psychology />}
              onClick={() => handleCompareScenarios('deep-dive')}
              disabled={selectedScenarios.length > 3}
              sx={{ 
                borderRadius: '20px',
                fontSize: '0.75rem',
                minWidth: '140px',
                textTransform: 'none',
                borderColor: selectedScenarios.length <= 3 ? theme.palette.secondary.main : undefined,
                color: selectedScenarios.length <= 3 ? theme.palette.secondary.main : undefined
              }}
            >
              AI Deep Dive
            </Button>
          </Box>
          
          {/* Close Button */}
          <IconButton 
            size="small" 
            onClick={clearSelection}
            sx={{ 
              alignSelf: 'flex-start',
              color: theme.palette.text.secondary
            }}
          >
            <Close />
          </IconButton>
        </Box>
        
        {/* Selection Summary */}
        <Typography variant="caption" sx={{ mt: 1, display: 'block', textAlign: 'center' }}>
          {selectedScenarios.length} scenario(s) selected
        </Typography>
      </Paper>
    </Zoom>
  );
});


  // Bubble Chart Comparison
// Bubble Chart Comparison Component
const BubbleChartComparison = ({ processedScenarios = [] }) => {
  const theme = useTheme();
  const [highlightedScenario, setHighlightedScenario] = useState(null);
  const [selectedScenario, setSelectedScenario] = useState(null);
  const [hoveredScenario, setHoveredScenario] = useState(null);

  // Use the scenarios passed as prop, or fallback to selected scenarios from comparison
  const scenariosToUse = useMemo(() => {
    // If processedScenarios is provided, use it
    if (processedScenarios && processedScenarios.length > 0) {
      return processedScenarios;
    }
    
    // Otherwise, use the selected scenarios from comparison mode
    if (selectedScenarios && selectedScenarios.length > 0) {
      return selectedScenarios.map(id => savedScenarios.find(s => s._id === id)).filter(Boolean);
    }
    
    // Fallback to mock data only if no scenarios are available
    return [
      { _id: '1', name: 'Digital Transformation', totalImpact: 5000000, implementationComplexity: 8.5, roiRatio: 3.2, timeline: '12 months' },
      { _id: '2', name: 'Process Automation', totalImpact: 2500000, implementationComplexity: 4.2, roiRatio: 5.1, timeline: '6 months' },
      { _id: '3', name: 'Customer Portal', totalImpact: 1800000, implementationComplexity: 6.8, roiRatio: 2.8, timeline: '9 months' },
      { _id: '4', name: 'AI Implementation', totalImpact: 7500000, implementationComplexity: 9.2, roiRatio: 4.5, timeline: '18 months' },
      { _id: '5', name: 'Mobile App', totalImpact: 1200000, implementationComplexity: 5.5, roiRatio: 3.8, timeline: '8 months' }
    ];
  }, [processedScenarios, selectedScenarios, savedScenarios]);

  // Calculate chart metrics
  const chartMetrics = useMemo(() => {
    if (!scenariosToUse.length) return null;

    const impacts = scenariosToUse.map(s => s.totalImpact / 1000000);
    const complexities = scenariosToUse.map(s => 
      s.implementationComplexity || calculateImplementationComplexity(s)
    );
    
    return {
      maxImpact: Math.max(...impacts),
      minImpact: Math.min(...impacts),
      maxComplexity: Math.max(...complexities),
      minComplexity: Math.min(...complexities),
      avgImpact: impacts.reduce((a, b) => a + b, 0) / impacts.length,
      avgComplexity: complexities.reduce((a, b) => a + b, 0) / complexities.length
    };
  }, [scenariosToUse]);

  // Generate quadrant data
  const quadrants = useMemo(() => {
    if (!chartMetrics) return [];
    
    return [
      {
        label: "Quick Wins",
        description: "High Impact, Low Complexity",
        color: "#4CAF50",
        x: 0,
        y: 0,
        width: 50,
        height: 50
      },
      {
        label: "Major Projects",
        description: "High Impact, High Complexity",
        color: "#2196F3",
        x: 50,
        y: 0,
        width: 50,
        height: 50
      },
      {
        label: "Fill-Ins",
        description: "Low Impact, Low Complexity",
        color: "#FFC107",
        x: 0,
        y: 50,
        width: 50,
        height: 50
      },
      {
        label: "Thankless Tasks",
        description: "Low Impact, High Complexity",
        color: "#FF5722",
        x: 50,
        y: 50,
        width: 50,
        height: 50
      }
    ];
  }, [chartMetrics]);

  const getBubbleSize = (impact) => {
    if (!chartMetrics || chartMetrics.maxImpact === chartMetrics.minImpact) return 60;
    const normalizedImpact = (impact - chartMetrics.minImpact) / (chartMetrics.maxImpact - chartMetrics.minImpact);
    return Math.max(40, Math.min(120, normalizedImpact * 80 + 40));
  };

  const getBubblePosition = (complexity, impact) => {
    if (!chartMetrics) return { x: 50, y: 50 };
    
    const x = ((complexity - chartMetrics.minComplexity) / 
              (chartMetrics.maxComplexity - chartMetrics.minComplexity)) * 80 + 10;
    const y = ((impact - chartMetrics.minImpact) / 
              (chartMetrics.maxImpact - chartMetrics.minImpact)) * 80 + 10;
    return { 
      x: Math.max(5, Math.min(95, x)), 
      y: Math.max(5, Math.min(95, y)) 
    };
  };

  const getQuadrant = (complexity, impact) => {
    if (!chartMetrics) return 0;
    
    const complexityMid = (chartMetrics.maxComplexity + chartMetrics.minComplexity) / 2;
    const impactMid = (chartMetrics.maxImpact + chartMetrics.minImpact) / 2;
    
    if (impact >= impactMid) {
      return complexity >= complexityMid ? 1 : 0;
    } else {
      return complexity >= complexityMid ? 3 : 2;
    }
  };

  if (!scenariosToUse.length || !chartMetrics) {
    return (
      <Paper sx={{ 
        p: 3, 
        height: 500, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        flexDirection: 'column',
        gap: 2
      }}>
        <BubbleChart sx={{ fontSize: 48, color: 'text.secondary', opacity: 0.5 }} />
        <Typography color="text.secondary" align="center">
          No scenario data available for visualization
          <br />
          <Typography variant="body2" component="span">
            Create or select scenarios to see the bubble chart
          </Typography>
        </Typography>
      </Paper>
    );
  }

  return (
    <Paper sx={{ p: 3, height: '100vh', position: 'relative', overflow: 'scroll' }}>
      {/* Header */}
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <BubbleChart sx={{ mr: 1, color: 'primary.main', fontSize: 28 }} />
          <Typography variant="h6" fontWeight="bold">
            Strategic Impact Analysis
            {processedScenarios.length === 0 && selectedScenarios.length === 0 && (
              <Chip 
                label="Demo Data" 
                size="small" 
                color="warning" 
                variant="outlined"
                sx={{ ml: 1, fontSize: '0.7rem' }} 
              />
            )}
          </Typography>
        </Box>
        <Chip 
          label={`${scenariosToUse.length} Scenario${scenariosToUse.length !== 1 ? 's' : ''}`} 
          color="primary" 
          variant="outlined" 
        />
      </Box>

      {/* Chart Container */}
      <Box sx={{ 
        height: '85%', 
        position: 'relative',
        background: `
          linear-gradient(90deg, transparent 49.5%, ${theme.palette.divider} 49.5%, ${theme.palette.divider} 50.5%, transparent 50.5%),
          linear-gradient(0deg, transparent 49.5%, ${theme.palette.divider} 49.5%, ${theme.palette.divider} 50.5%, transparent 50.5%),
          radial-gradient(circle at 50% 50%, ${theme.palette.background.default} 0%, transparent 100%)
        `,
        borderRadius: 1
      }}>
        
        {/* Quadrant Labels */}
        {quadrants.map((quadrant, index) => (
          <Box
            key={index}
            sx={{
              position: 'absolute',
              left: `${quadrant.x}%`,
              top: `${quadrant.y}%`,
              width: `${quadrant.width}%`,
              height: `${quadrant.height}%`,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              p: 1,
              textAlign: 'center',
              opacity: 0.1,
              transition: 'opacity 0.3s ease',
              '&:hover': { opacity: 0.2 }
            }}
          >
            <Typography variant="caption" fontWeight="bold" color={quadrant.color}>
              {quadrant.label}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {quadrant.description}
            </Typography>
          </Box>
        ))}

        {/* Bubbles */}
        <AnimatePresence>
          {scenariosToUse.map((scenario, index) => {
            const impact = scenario.totalImpact / 1000000;
            const complexity = scenario.implementationComplexity || calculateImplementationComplexity(scenario);
            const size = getBubbleSize(impact);
            const { x, y } = getBubblePosition(complexity, impact);
            const quadrantIndex = getQuadrant(complexity, impact);
            const quadrant = quadrants[quadrantIndex];
            
            const isHighlighted = highlightedScenario === scenario._id;
            const isSelected = selectedScenario === scenario._id;
            const isHovered = hoveredScenario === scenario._id;

            return (
              <Tooltip
                key={scenario._id}
                title={
                  <Box>
                    <Typography variant="subtitle2" gutterBottom>
                      {scenario.name || `Scenario ${index + 1}`}
                    </Typography>
                    <Typography variant="caption" display="block">
                      Impact: ${impact.toFixed(1)}M
                    </Typography>
                    <Typography variant="caption" display="block">
                      Complexity: {complexity.toFixed(1)}/10
                    </Typography>
                    <Typography variant="caption" display="block">
                      ROI: {scenario.roiRatio ? `${scenario.roiRatio.toFixed(1)}x` : 'N/A'}
                    </Typography>
                    <Chip 
                      label={quadrant.label} 
                      size="small" 
                      sx={{ 
                        mt: 0.5,
                        backgroundColor: quadrant.color,
                        color: 'white',
                        fontSize: '0.6rem'
                      }} 
                    />
                  </Box>
                }
                arrow
                placement="top"
              >
                <motion.div
                  initial={{ scale: 0, opacity: 0 }}
                  animate={{ 
                    scale: isSelected ? 1.2 : isHovered ? 1.1 : 1,
                    opacity: 1 
                  }}
                  exit={{ scale: 0, opacity: 0 }}
                  transition={{ 
                    delay: index * 0.05,
                    type: "spring",
                    stiffness: 300,
                    damping: 20
                  }}
                  style={{
                    position: 'absolute',
                    left: `${x}%`,
                    top: `${y}%`,
                    width: size,
                    height: size,
                    borderRadius: '50%',
                    backgroundColor: quadrant.color,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'white',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    border: `3px solid ${isHighlighted ? theme.palette.common.white : 'transparent'}`,
                    boxShadow: isSelected 
                      ? `0 0 0 4px ${quadrant.color}, 0 8px 24px rgba(0,0,0,0.3)`
                      : `0 4px 12px rgba(0,0,0,0.2)`,
                    zIndex: isSelected || isHovered ? 10 : 1,
                    transform: 'translate(-50%, -50%)'
                  }}
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.95 }}
                  onMouseEnter={() => setHoveredScenario(scenario._id)}
                  onMouseLeave={() => setHoveredScenario(null)}
                  onClick={() => {
                    setSelectedScenario(selectedScenario === scenario._id ? null : scenario._id);
                    setHighlightedScenario(scenario._id);
                  }}
                >
                  <Typography 
                    variant="caption" 
                    sx={{ 
                      textAlign: 'center',
                      fontSize: Math.max(8, size / 4),
                      fontWeight: isSelected ? 'bold' : 'normal',
                      textShadow: '0 1px 2px rgba(0,0,0,0.3)'
                    }}
                  >
                    S{index + 1}
                  </Typography>
                </motion.div>
              </Tooltip>
            );
          })}
        </AnimatePresence>

        {/* Axes Labels */}
        <Box sx={{ position: 'absolute', bottom: -30, left: '50%', transform: 'translateX(-50%)' }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Build sx={{ fontSize: 16, mr: 0.5 }} />
            <Typography variant="caption" fontWeight="bold">
              Implementation Complexity →
            </Typography>
          </Box>
        </Box>
        
        <Box sx={{ 
          position: 'absolute', 
          left: -40, 
          top: '50%', 
          transform: 'rotate(-90deg) translateX(-50%)',
          transformOrigin: 'left center'
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <TrendingUp sx={{ fontSize: 16, mr: 0.5 }} />
            <Typography variant="caption" fontWeight="bold">
              Business Impact ($M) →
            </Typography>
          </Box>
        </Box>

        {/* Legend */}
        <Paper sx={{ 
          position: 'absolute', 
          top: 10, 
          right: 10, 
          p: 1.5, 
          backgroundColor: 'rgba(255,255,255,0.9)',
          backdropFilter: 'blur(10px)',
          borderRadius: 2
        }}>
          <Typography variant="caption" fontWeight="bold" gutterBottom>
            Quadrants:
          </Typography>
          {quadrants.map((quadrant, index) => (
            <Box key={index} sx={{ display: 'flex', alignItems: 'center', mt: 0.5 }}>
              <Box
                sx={{
                  width: 12,
                  height: 12,
                  borderRadius: '50%',
                  backgroundColor: quadrant.color,
                  mr: 1,
                  border: '1px solid rgba(0,0,0,0.1)'
                }}
              />
              <Typography variant="caption">{quadrant.label}</Typography>
            </Box>
          ))}
        </Paper>
      </Box>

      {/* Selected Scenario Details */}
<AnimatePresence>
  {selectedScenario && (() => {
    const scenario = scenariosToUse.find(s => s._id === selectedScenario);
    if (!scenario) return null;
    
    const impact = scenario.totalImpact / 1000000;
    const complexity = scenario.implementationComplexity || calculateImplementationComplexity(scenario);
    const quadrantIndex = getQuadrant(complexity, impact);
    const quadrant = quadrants[quadrantIndex];
    
    // Safety check for quadrant
    if (!quadrant) return null;

    return (
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 20 }}
        transition={{ duration: 0.3 }}
      >
        {/* Basic Scenario Information Card */}
        <Paper sx={{ 
          mt: 2, 
          p: 2.5, 
          backgroundColor: `${quadrant.color}10`, 
          borderRadius: 2,
          border: `1px solid ${quadrant.color}30`
        }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 2 }}>
            <Box sx={{ flex: 1 }}>
              <Typography variant="h6" fontWeight="bold" gutterBottom>
                {scenario.name || `Scenario ${scenariosToUse.findIndex(s => s._id === selectedScenario) + 1}`}
              </Typography>
              <Chip 
                label={quadrant.label} 
                size="small" 
                sx={{ 
                  backgroundColor: quadrant.color,
                  color: 'white',
                  fontWeight: 'bold',
                  mt: 0.5
                }} 
              />
            </Box>
            <Box sx={{ textAlign: 'right', minWidth: 120 }}>
              <Typography variant="h5" color={quadrant.color} fontWeight="bold">
                ${impact.toFixed(2)}M
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Potential Impact
              </Typography>
            </Box>
          </Box>
          
          {/* Scenario Metrics */}
          <Box sx={{ 
            display: 'flex', 
            gap: 3, 
            mt: 2, 
            flexWrap: 'wrap',
            pt: 2,
            borderTop: '1px solid',
            borderColor: 'divider'
          }}>
            <Box sx={{ minWidth: 80 }}>
              <Typography variant="caption" color="text.secondary" display="block" gutterBottom>
                Complexity
              </Typography>
              <Typography variant="body1" fontWeight="medium">
                {complexity.toFixed(1)}/10
              </Typography>
            </Box>
            <Box sx={{ minWidth: 80 }}>
              <Typography variant="caption" color="text.secondary" display="block" gutterBottom>
                ROI Ratio
              </Typography>
              <Typography variant="body1" fontWeight="medium">
                {scenario.roiRatio ? `${scenario.roiRatio.toFixed(1)}x` : 'N/A'}
              </Typography>
            </Box>
            <Box sx={{ minWidth: 100 }}>
              <Typography variant="caption" color="text.secondary" display="block" gutterBottom>
                Timeline
              </Typography>
              <Typography variant="body1">
                {scenario.timeline || 'Not specified'}
              </Typography>
            </Box>
            <Box sx={{ minWidth: 100 }}>
              <Typography variant="caption" color="text.secondary" display="block" gutterBottom>
                Industry
              </Typography>
              <Typography variant="body1">
                {scenario.industry || 'Not specified'}
              </Typography>
            </Box>
          </Box>
        </Paper>
        
        {/* Strategic Analysis Component */}
        <SelectedScenarioAnalysis scenario={scenario} quadrant={quadrant} />
      </motion.div>
    );
  })()}
</AnimatePresence>
</Paper>
  );
};


// Scenario Comparison Interface Component
// Comprehensive ScenarioComparisonInterface Component
const ScenarioComparisonInterface = React.memo(({ scenarios, viewMode, onBack, onViewChange }) => {
  const theme = useTheme();
  const [selectedFactors, setSelectedFactors] = useState([]);
  const [highlightedScenario, setHighlightedScenario] = useState(null);
  const [animationEnabled, setAnimationEnabled] = useState(true);

  // Process scenarios data for comparison
  const processedScenarios = useMemo(() => {
    return scenarios.map(scenario => ({
      ...scenario,
      // Calculate additional metrics
      roiMultiple: calculateROIMultiple(scenario),
      successProbability: calculateSuccessProbability(scenario),
      implementationComplexity: calculateImplementationComplexity(scenario),
      paybackPeriod: calculatePaybackPeriod(scenario),
      // Extract factor data
      factors: Object.entries(scenario.values || {}).map(([key, value]) => ({
        key,
        current: value?.current || 0,
        target: value?.target || 0,
        improvement: (value?.target || 0) - (value?.current || 0)
      }))
    }));
  }, [scenarios]);

  // Calculate comparison metrics
  const comparisonMetrics = useMemo(() => {
    const impacts = processedScenarios.map(s => s.totalImpact || 0);
    return {
      maxImpact: Math.max(...impacts),
      minImpact: Math.min(...impacts),
      avgImpact: impacts.reduce((a, b) => a + b, 0) / impacts.length,
      impactRange: Math.max(...impacts) - Math.min(...impacts)
    };
  }, [processedScenarios]);

  // Enhanced Comparison Matrix Component
  const ComparisonMatrix = () => {
    const allFactors = useMemo(() => {
      const factorSet = new Set();
      processedScenarios.forEach(scenario => {
        Object.keys(scenario.values || {}).forEach(factor => factorSet.add(factor));
      });
      return Array.from(factorSet);
    }, [processedScenarios]);

    const factorLabels = useMemo(() => {
      const labels = {};
      categories.forEach(category => {
        category.factors.forEach(factor => {
          labels[factor.key] = factor.label;
        });
      });
      return labels;
    }, []);

    return (
      <Box sx={{ overflow: 'auto' }}>
        <Paper sx={{ p: 3, mb: 3 }}>
          <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
            <CompareArrows sx={{ mr: 1 }} />
            Factor-Level Comparison Matrix
          </Typography>
          <Typography color="text.secondary" sx={{ mb: 3 }}>
            Detailed comparison of all factors across selected scenarios. Green indicates better performance.
          </Typography>
          
          <Table sx={{ minWidth: 800 }} size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 'bold', minWidth: 200 }}>Factor</TableCell>
                {processedScenarios.map((scenario, index) => (
                  <TableCell key={scenario._id} align="center" sx={{ fontWeight: 'bold' }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <Chip 
                        label={`S${index + 1}`} 
                        size="small" 
                        color={highlightedScenario === scenario._id ? "primary" : "default"}
                        onClick={() => setHighlightedScenario(
                          highlightedScenario === scenario._id ? null : scenario._id
                        )}
                        sx={{ cursor: 'pointer', mb: 0.5 }}
                      />
                      <Typography variant="caption" noWrap sx={{ maxWidth: 100 }}>
                        {scenario.name}
                      </Typography>
                    </Box>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {allFactors.map(factorKey => {
                const factorData = processedScenarios.map(scenario => ({
                  current: scenario.values?.[factorKey]?.current || 0,
                  target: scenario.values?.[factorKey]?.target || 0,
                  improvement: (scenario.values?.[factorKey]?.target || 0) - 
                              (scenario.values?.[factorKey]?.current || 0)
                }));

                const maxImprovement = Math.max(...factorData.map(f => f.improvement));
                const minImprovement = Math.min(...factorData.map(f => f.improvement));

                return (
                  <TableRow 
                    key={factorKey}
                    sx={{ 
                      bgcolor: highlightedScenario ? 'transparent' : 'action.hover',
                      '&:hover': { bgcolor: 'action.selected' }
                    }}
                  >
                    <TableCell sx={{ fontWeight: 'medium' }}>
                      <Tooltip title={factorTooltips[factorKey] || factorKey}>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          {factorLabels[factorKey] || factorKey.replace(/_/g, ' ')}
                        </Box>
                      </Tooltip>
                    </TableCell>
                    {factorData.map((data, index) => (
                      <TableCell 
                        key={index} 
                        align="center"
                        sx={{
                          bgcolor: data.improvement === maxImprovement ? 
                                  'success.light' : data.improvement === minImprovement ? 
                                  'error.light' : 'transparent',
                          transition: 'all 0.3s ease',
                          border: highlightedScenario === processedScenarios[index]._id ? 
                                 '2px solid' : '1px solid',
                          borderColor: highlightedScenario === processedScenarios[index]._id ? 
                                      'primary.main' : 'divider'
                        }}
                      >
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                          <Typography variant="body2" fontWeight="bold">
                            {data.current} → {data.target}
                          </Typography>
                          <Chip 
                            label={`${data.improvement >= 0 ? '+' : ''}${data.improvement}`}
                            size="small"
                            color={data.improvement > 0 ? "success" : data.improvement < 0 ? "error" : "default"}
                            variant="outlined"
                          />
                        </Box>
                      </TableCell>
                    ))}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </Paper>
      </Box>
    );
  };

  // Enhanced Radar Comparison Component
  const RadarComparison = () => {
    const radarData = useMemo(() => {
      const categoriesData = categories.map(category => ({
        label: category.name,
        data: processedScenarios.map(scenario => {
          const categoryImpact = category.factors.reduce((sum, factor) => {
            const factorData = scenario.values?.[factor.key];
            const impact = factorData ? 
              (getFactorImpact(factor.key, factorData.target) - getFactorImpact(factor.key, factorData.current)) : 0;
            return sum + impact;
          }, 0);
          return categoryImpact / 1000; // Convert to thousands for better scaling
        })
      }));

      return {
        labels: processedScenarios.map((_, index) => `Scenario ${index + 1}`),
        datasets: categoriesData.map((category, index) => ({
          label: category.label,
          data: category.data,
          backgroundColor: `hsla(${index * 60}, 70%, 50%, 0.2)`,
          borderColor: `hsl(${index * 60}, 70%, 50%)`,
          pointBackgroundColor: `hsl(${index * 60}, 70%, 50%)`,
          pointBorderColor: '#fff',
          pointHoverRadius: 8,
          tension: 0.1
        }))
      };
    }, [processedScenarios]);

    return (
      <Paper sx={{ p: 3, height: 500 }}>
        <Typography variant="h6" gutterBottom>
          <RadarIcon sx={{ mr: 1 }} />
          Multi-Dimensional Radar Analysis
        </Typography>
        <Box sx={{ height: '90%' }}>
          <Radar 
            data={radarData}
            options={{
              responsive: true,
              maintainAspectRatio: false,
              scales: {
                r: {
                  beginAtZero: true,
                  ticks: { display: false },
                  grid: { color: 'rgba(0,0,0,0.1)' }
                }
              },
              plugins: {
                legend: { position: 'top' },
                tooltip: {
                  callbacks: {
                    label: (context) => 
                      `${context.dataset.label}: ${getCurrencySymbol(selectedCurrency)}${(context.raw * 1000).toLocaleString()}`
                  }
                }
              }
            }}
          />
        </Box>
      </Paper>
    );
  };

  // Timeline Comparison Component
  const TimelineComparison = () => {
    return (
      <Paper sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom>
          <Timeline sx={{ mr: 1 }} />
          Investment Timeline & ROI Projection
        </Typography>
        
        <Box sx={{ display: 'flex', height: 300, gap: 2 }}>
          {/* ROI Timeline */}
          <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
            <Typography variant="subtitle2" gutterBottom>ROI Timeline</Typography>
            <Box sx={{ flex: 1, position: 'relative', bgcolor: 'grey.50', borderRadius: 1 }}>
              {processedScenarios.map((scenario, index) => (
                <Box
                  key={scenario._id}
                  sx={{
                    position: 'absolute',
                    left: `${(index / processedScenarios.length) * 100}%`,
                    width: `${100 / processedScenarios.length}%`,
                    height: '100%',
                    display: 'flex',
                    alignItems: 'flex-end',
                    padding: 1
                  }}
                >
                  <Box
                    sx={{
                      width: '100%',
                      height: `${Math.min(100, (scenario.totalImpact / comparisonMetrics.maxImpact) * 100)}%`,
                      bgcolor: `hsl(${index * 60}, 70%, 50%)`,
                      borderRadius: 1,
                      transition: 'all 0.3s ease',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'white',
                      fontWeight: 'bold',
                      fontSize: '0.75rem'
                    }}
                  >
                    {getCurrencySymbol(selectedCurrency)}{(scenario.totalImpact / 1000).toFixed(0)}K
                  </Box>
                </Box>
              ))}
            </Box>
          </Box>

          {/* Payback Period */}
          <Box sx={{ flex: 1 }}>
            <Typography variant="subtitle2" gutterBottom>Payback Period (Months)</Typography>
            {processedScenarios.map((scenario, index) => (
              <Box key={scenario._id} sx={{ mb: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                  <Typography variant="body2">S{index + 1}</Typography>
                  <Typography variant="body2" fontWeight="bold">
                    {scenario.paybackPeriod} months
                  </Typography>
                </Box>
                <LinearProgress 
                  variant="determinate" 
                  value={Math.min(100, (scenario.paybackPeriod / 36) * 100)}
                  sx={{
                    height: 8,
                    borderRadius: 4,
                    bgcolor: 'grey.200',
                    '& .MuiLinearProgress-bar': {
                      bgcolor: scenario.paybackPeriod <= 12 ? 'success.main' : 
                              scenario.paybackPeriod <= 24 ? 'warning.main' : 'error.main'
                    }
                  }}
                />
              </Box>
            ))}
          </Box>
        </Box>
      </Paper>
    );
  };


  // AI Insights Component
  const AIInsights = () => {
    const [insights, setInsights] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
      // Simulate AI analysis
      const generateInsights = async () => {
        setLoading(true);
        await new Promise(resolve => setTimeout(resolve, 2000));
        
        const generatedInsights = [
          {
            type: 'recommendation',
            title: 'Optimal Scenario Selection',
            content: `Scenario ${processedScenarios.findIndex(s => s.totalImpact === comparisonMetrics.maxImpact) + 1} shows the highest ROI potential with balanced implementation complexity.`,
            confidence: 0.92,
            impact: 'high'
          },
          {
            type: 'warning',
            title: 'Risk Assessment',
            content: 'Scenario 2 has high implementation complexity relative to its ROI. Consider phased approach.',
            confidence: 0.87,
            impact: 'medium'
          },
          {
            type: 'opportunity',
            title: 'Synergy Potential',
            content: 'Combining factors from Scenario 1 and 3 could yield 15% higher ROI than any single scenario.',
            confidence: 0.78,
            impact: 'high'
          }
        ];
        
        setInsights(generatedInsights);
        setLoading(false);
      };

      generateInsights();
    }, [processedScenarios, comparisonMetrics]);

    if (loading) {
      return (
        <Paper sx={{ p: 3, textAlign: 'center' }}>
          <CircularProgress />
          <Typography variant="body2" sx={{ mt: 2 }}>
            AI is analyzing your scenarios...
          </Typography>
        </Paper>
      );
    }

    return (
      <Paper sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
          <Psychology sx={{ mr: 1 }} />
          AI-Powered Insights & Recommendations
        </Typography>
        
        <Grid container spacing={2}>
          {insights.map((insight, index) => (
            <Grid item xs={12} md={6} key={index}>
              <Card 
                sx={{ 
                  borderLeft: `4px solid ${
                    insight.type === 'recommendation' ? '#4caf50' :
                    insight.type === 'warning' ? '#ff9800' : '#2196f3'
                  }`
                }}
              >
                <CardContent>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
                    <Typography variant="subtitle1" fontWeight="bold">
                      {insight.title}
                    </Typography>
                    <Chip 
                      label={`${(insight.confidence * 100).toFixed(0)}% conf`}
                      size="small"
                      color={insight.confidence > 0.9 ? "success" : insight.confidence > 0.7 ? "warning" : "error"}
                    />
                  </Box>
                  <Typography variant="body2" color="text.secondary" paragraph>
                    {insight.content}
                  </Typography>
                  <LinearProgress 
                    variant="determinate" 
                    value={insight.confidence * 100}
                    sx={{ 
                      height: 4,
                      borderRadius: 2,
                      bgcolor: 'grey.200',
                      '& .MuiLinearProgress-bar': {
                        bgcolor: insight.confidence > 0.9 ? 'success.main' : 
                                insight.confidence > 0.7 ? 'warning.main' : 'error.main'
                      }
                    }}
                  />
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Paper>
    );
  };

  // Main render function
  const renderComparisonView = () => {
    switch (viewMode) {
      case 'matrix':
        return <ComparisonMatrix />;
      case 'radar':
        return <RadarComparison />;
      case 'timeline':
        return <TimelineComparison />;
      case 'bubble':
        return <BubbleChartComparison />;
      case 'capabilities':
		return (
			<AdvancedCapabilitiesMatrix 
			  scenarios={processedScenarios}
			  categories={categories}
			  industry={industry}
			  tier={tier}
			/>
		  );
      case 'ai':
        return <AIInsights />;
      default:
        return <ComparisonMatrix />;
    }
  };

  return (
    <Box>
      {/* Enhanced Header with Metrics */}
      <Paper sx={{ 
        p: 4, 
        mb: 3, 
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
        position: 'relative',
        overflow: 'hidden'
      }}>
        <Watermark opacity={0.1} fontSize={96} />
        
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', position: 'relative', zIndex: 1 }}>
          <Box>
            <Typography variant="h3" sx={{ fontWeight: 'bold', mb: 1, fontSize: { xs: '2rem', md: '3rem' } }}>
              <CompareArrows sx={{ mr: 2, verticalAlign: 'middle', fontSize: 'inherit' }} />
              Quantum Comparison Dashboard
            </Typography>
            <Typography variant="h6" sx={{ opacity: 0.9, mb: 3 }}>
              Analyzing {scenarios.length} scenarios • {comparisonMetrics.impactRange > 0 ? 
                `${getCurrencySymbol(selectedCurrency)}${(comparisonMetrics.impactRange/1000).toFixed(0)}K impact range` : 
                'Identical impact scenarios'
              }
            </Typography>
            
            {/* Quick Stats */}
            <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap' }}>
              <Box>
                <Typography variant="overline" sx={{ opacity: 0.8 }}>Best Scenario</Typography>
                <Typography variant="h6" fontWeight="bold">
                  {getCurrencySymbol(selectedCurrency)}{(comparisonMetrics.maxImpact/1000).toFixed(0)}K
                </Typography>
              </Box>
              <Box>
                <Typography variant="overline" sx={{ opacity: 0.8 }}>Average Impact</Typography>
                <Typography variant="h6" fontWeight="bold">
                  {getCurrencySymbol(selectedCurrency)}{(comparisonMetrics.avgImpact/1000).toFixed(0)}K
                </Typography>
              </Box>
              <Box>
                <Typography variant="overline" sx={{ opacity: 0.8 }}>Variance</Typography>
                <Typography variant="h6" fontWeight="bold">
                  {((comparisonMetrics.impactRange / comparisonMetrics.avgImpact) * 100).toFixed(1)}%
                </Typography>
              </Box>
            </Box>
          </Box>
          
          <Button
            variant="contained"
            color="secondary"
            startIcon={<ArrowBack />}
            onClick={onBack}
            sx={{ 
              minWidth: 'auto',
              bgcolor: 'rgba(255,255,255,0.2)',
              '&:hover': { bgcolor: 'rgba(255,255,255,0.3)' }
            }}
          >
            Back
          </Button>
        </Box>
      </Paper>

      {/* Enhanced View Selector */}
      <Paper sx={{ p: 2, mb: 3 }}>
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', justifyContent: 'center' }}>
          {[
            { id: 'matrix', label: 'Comparison Matrix', icon: <CompareArrows />, description: 'Detailed factor-level analysis' },
            { id: 'radar', label: 'Radar Analysis', icon: <RadarIcon />, description: 'Multi-dimensional comparison' },
            { id: 'timeline', label: 'Timeline View', icon: <Timeline />, description: 'ROI progression over time' },
            { id: 'bubble', label: 'Bubble Chart', icon: <BubbleChart />, description: 'Impact vs complexity' },
            { id: 'capabilities', label: 'capabilities', icon: <capabilities />, description: 'Capabilities of Selections' },
            { id: 'ai', label: 'AI Insights', icon: <Psychology />, description: 'Intelligent recommendations' }
          ].map((view) => (
            <Tooltip key={view.id} title={view.description} arrow>
              <Button
                variant={viewMode === view.id ? 'contained' : 'outlined'}
                startIcon={view.icon}
                onClick={() => onViewChange(view.id)}
                sx={{ 
                  borderRadius: '20px',
                  minWidth: { xs: '100%', sm: 'auto' },
                  flexDirection: { xs: 'column', sm: 'row' },
                  py: { xs: 1.5, sm: 1 }
                }}
              >
                {view.label}
              </Button>
            </Tooltip>
          ))}
        </Box>
      </Paper>

      {/* Main Comparison Content */}
      <AnimatePresence mode="wait">
        <motion.div
          key={viewMode}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.3 }}
        >
          {renderComparisonView()}
        </motion.div>
      </AnimatePresence>

      {/* Scenario Quick Summary */}
      <Paper sx={{ p: 3, mt: 3 }}>
        <Typography variant="h6" gutterBottom>Scenario Summary</Typography>
        <Grid container spacing={2}>
          {processedScenarios.map((scenario, index) => (
            <Grid item xs={12} sm={6} md={3} key={scenario._id}>
              <Card 
                sx={{ 
                  cursor: 'pointer',
                  border: highlightedScenario === scenario._id ? '2px solid' : '1px solid',
                  borderColor: highlightedScenario === scenario._id ? 'primary.main' : 'divider',
                  transition: 'all 0.3s ease',
                  '&:hover': { transform: 'translateY(-2px)', boxShadow: 4 }
                }}
                onClick={() => setHighlightedScenario(
                  highlightedScenario === scenario._id ? null : scenario._id
                )}
              >
                <CardContent>
                  <Typography variant="subtitle2" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
                    <Chip label={`S${index + 1}`} size="small" color="primary" sx={{ mr: 1 }} />
                    {scenario.name}
                  </Typography>
                  <Typography variant="h6" color="primary" gutterBottom>
                    {getCurrencySymbol(selectedCurrency)}{(scenario.totalImpact/1000).toFixed(0)}K
                  </Typography>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography variant="caption">ROI Multiple</Typography>
                    <Typography variant="caption" fontWeight="bold">{scenario.roiMultiple.toFixed(1)}x</Typography>
                  </Box>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography variant="caption">Success</Typography>
                    <Typography variant="caption" fontWeight="bold">{scenario.successProbability}%</Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Paper>
    </Box>
  );
});

// Add these utility functions outside the component
const calculateROIMultiple = (scenario) => {
  const investment = (scenario.turnover || 100000000) * 0.05; // 5% of turnover
  return investment > 0 ? (scenario.totalImpact || 0) / investment : 1;
};

const calculateSuccessProbability = (scenario) => {
  const baseProbability = 70;
  const impactBonus = Math.min(30, ((scenario.totalImpact || 0) / 1000000) * 5);
  const complexityPenalty = Math.max(0, (calculateImplementationComplexity(scenario) - 5) * 3);
  return Math.min(95, Math.max(50, Math.round(baseProbability + impactBonus - complexityPenalty)));
};

const calculateImplementationComplexity = (scenario) => {
  const factors = Object.values(scenario.values || {});
  if (factors.length === 0) return 5;
  
  const avgImprovement = factors.reduce((sum, f) => sum + (f.target - f.current), 0) / factors.length;
  return Math.min(10, Math.max(1, 10 - avgImprovement));
};

const calculatePaybackPeriod = (scenario) => {
  const monthlyBenefit = (scenario.totalImpact || 0) / 12;
  const investment = (scenario.turnover || 100000000) * 0.05;
  return monthlyBenefit > 0 ? Math.ceil(investment / monthlyBenefit) : 36;
};

/* 
  const handleCompareScenarios = () => {
    if (selectedScenarios.length < 2) {
      enqueueSnackbar('Please select at least 2 scenarios to compare', { variant: 'warning' });
      return;
    }
    setCompareMode(true);
    setLocalActiveTab('analyze');
  };
 */
const runAnalysis = () => {
  // Ensure we use the current slider values for calculation
  const currentValues = { ...sliderValues };
  
  setIsPlaying(true);
  setProgress(0);
  
  const interval = setInterval(() => {
    setProgress(prev => {
      if (prev >= 100) {
        clearInterval(interval);
        setIsPlaying(false);
        
        // ✅ FORCE RECALCULATION with current values
        const recalculatedCategoryTotals = {};
        categories.forEach(cat => {
          recalculatedCategoryTotals[cat.name] = cat.factors.reduce((sum, f) => {
            const currentValue = currentValues[f.key]?.current ?? 0;
            const targetValue = currentValues[f.key]?.target ?? 0;
            const currentImpact = getFactorImpact(f.key, currentValue);
            const targetImpact = getFactorImpact(f.key, targetValue);
            return sum + (targetImpact - currentImpact);
          }, 0);
        });
        
        // Update the totals (this will trigger a re-render)
        setCategoryTotals(recalculatedCategoryTotals);
        
        enqueueSnackbar('Analysis completed!', { variant: 'success' });
        return 100;
      }
      return prev + 10;
    });
  }, 300);
};


// Add this function to load custom fonts
const initializePDFWithCustomFont = async () => {
  const doc = new jsPDF();
  
  // You would need to load a font that supports the Rupee symbol
  // This is a more complex solution but provides better symbols
  try {
    // Example with a custom font (you'd need to have the font file)
    const fontUrl = '/fonts/DejaVuSans.ttf'; // This font supports Rupee symbol
    const font = await fetch(fontUrl).then(r => r.arrayBuffer());
    doc.addFileToVFS('DejaVuSans.ttf', font);
    doc.addFont('DejaVuSans.ttf', 'DejaVuSans', 'normal');
    doc.setFont('DejaVuSans');
    
    return doc;
  } catch (error) {
    console.warn('Custom font loading failed, using fallback:', error);
    return new jsPDF(); // Fallback to default
  }
};


//PDF

const handleExportPDF = () => {
  const doc = new jsPDF();
  
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const margin = 15;
  let yPosition = margin;
  
  // Add custom fonts and styles
  doc.setFont("helvetica", "bold");
  
  // Create cover page
  doc.setFillColor(25, 118, 210);
  doc.rect(0, 0, pageWidth, pageHeight, 'F');
  
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(36);
  doc.text("PLM ROI ANALYSIS", pageWidth / 2, pageHeight / 2 - 20, { align: 'center' });
  
  doc.setFontSize(18);
  doc.text("Quantum Impact Assessment Report", pageWidth / 2, pageHeight / 2, { align: 'center' });
  
  doc.setFontSize(14);
  doc.text(`Generated on ${new Date().toLocaleDateString()}`, pageWidth / 2, pageHeight / 2 + 20, { align: 'center' });
  
  doc.setTextColor(255, 255, 255, 0.7);
  doc.text("Confidential - For Executive Review Only", pageWidth / 2, pageHeight - 20, { align: 'center' });
  
  // Add watermark to cover page
  doc.setGState(new doc.GState({opacity: 0.15}));
  doc.setFont("helvetica", "normal");
  doc.setFontSize(50);
  doc.setTextColor(200, 200, 200);
  const text = "eEvolve.ai";
  const textWidth = doc.getTextWidth(text);
  const x = (pageWidth - textWidth) / 2;
  const y = pageHeight / 2;
  doc.text(text, x, y, { angle: 45 });
  doc.setGState(new doc.GState({opacity: 1}));
  
  // Add second page
  doc.addPage();
  yPosition = margin;
  
  // Add header with logo and title
  doc.setFillColor(255, 255, 255);
  doc.setTextColor(25, 118, 210);
  doc.setFontSize(24);
  doc.text("PLM ROI Analysis Report", pageWidth / 2, yPosition, { align: 'center' });
  yPosition += 10;
  
  doc.setFontSize(12);
  doc.setTextColor(100, 100, 100);
  doc.text(`Generated on ${new Date().toLocaleDateString()}`, pageWidth / 2, yPosition, { align: 'center' });
  yPosition += 15;
  
  // Add company details section
  doc.setDrawColor(25, 118, 210);
  doc.setFillColor(240, 245, 255);
  doc.roundedRect(margin, yPosition, pageWidth - (margin * 2), 40, 3, 3, 'F');
  
  doc.setFontSize(14);
  doc.setTextColor(25, 118, 210);
  doc.text("Company Profile", margin + 5, yPosition + 8);
  yPosition += 12;
  
  doc.setFontSize(10);
  doc.setTextColor(80, 80, 80);
  
const companyDetails = [
  { label: "Industry:", value: industry, x: margin + 5 },
  { label: "Tier:", value: tier, x: margin + 5 },
  { label: "Perspective:", value: persona, x: pageWidth / 2 },
  { label: "Annual Revenue:",value: `${getCurrencySymbol(selectedCurrency)}${turnover.toLocaleString()}`, x: pageWidth / 2 },
  { label: "Projection Period:", value: `${projectionYear} year${projectionYear > 1 ? 's' : ''}`, x: margin + 5 }
];

// Group items properly for 2-column layout
const leftColumnItems = companyDetails.filter((_, index) => index % 2 === 0);
const rightColumnItems = companyDetails.filter((_, index) => index % 2 === 1);

// Find the maximum number of rows needed
const maxRows = Math.max(leftColumnItems.length, rightColumnItems.length);

// Draw items with proper row alignment
for (let i = 0; i < maxRows; i++) {
  const y = yPosition + (i * 12);
  
  // Left column item
  if (leftColumnItems[i]) {
    doc.text(`${leftColumnItems[i].label} ${leftColumnItems[i].value}`, margin + 5, y);
  }
  
  // Right column item
  if (rightColumnItems[i]) {
    doc.text(`${rightColumnItems[i].label} ${rightColumnItems[i].value}`, pageWidth / 2, y);
  }
}

yPosition += (maxRows * 12) + 10; // Add extra spacing after the section
  
  // Add summary section with highlight
  doc.setFillColor(240, 248, 255);
  doc.roundedRect(margin, yPosition, pageWidth - (margin * 2), 30, 3, 3, 'F');
  
  doc.setFontSize(16);
  doc.setTextColor(25, 118, 210);
  doc.text("ROI Summary", margin + 5, yPosition + 10);
  
  doc.setFontSize(18);
  doc.setTextColor(76, 175, 80);
  doc.text(`Total Potential Annual Impact: ${getCurrencySymbol(selectedCurrency)}${totalImpact.toLocaleString()}`, pageWidth - margin - 5, yPosition + 10, { align: 'right' });
  
  yPosition += 40;
  
  // Add category breakdown with enhanced pie chart
  doc.setFontSize(14);
  doc.setTextColor(0, 0, 0);
  doc.text("Impact Distribution by Category", margin, yPosition);
  yPosition += 10;
  
  const pieChartRadius = 40;
  const pieChartX = margin + pieChartRadius + 10;
  const pieChartY = yPosition + pieChartRadius + 10;
  
  const colors = [
    [65, 105, 225], // Royal Blue
    [220, 20, 60],  // Crimson
    [46, 139, 87],  // Sea Green
    [255, 140, 0],  // Dark Orange
    [148, 0, 211],  // Dark Violet
    [255, 69, 0],   // Red-Orange
    [30, 144, 255], // Dodger Blue
    [50, 205, 50]   // Lime Green
  ];
  
  const totalValue = Object.values(categoryTotals).reduce((sum, value) => sum + value, 0);


// Add this check right after filtering nonZeroCategories
if (nonZeroCategories.length === 0) {
  doc.setFontSize(12);
  doc.setTextColor(100, 100, 100);
  doc.text("No significant impact identified across any categories. Consider adjusting your target levels.", 
           margin, yPosition, { maxWidth: pageWidth - (margin * 2) });
  yPosition += 20;
  
  // Skip all category visualizations if no impact
  // Continue with other sections or end the report
  return;
}

  
  // Draw colored circles for each category
  let currentAngle = 0;
  nonZeroCategories.forEach((category, i) => {
    const slicePercentage = categoryTotals[category.name] / totalValue;
    if (slicePercentage > 0) {
      const color = colors[i % colors.length];
      doc.setFillColor(color[0], color[1], color[2]);
      
      const circleRadius = pieChartRadius * Math.sqrt(slicePercentage);
      const angle = currentAngle * Math.PI * 2;
      const circleX = pieChartX + Math.cos(angle) * (pieChartRadius / 2);
      const circleY = pieChartY + Math.sin(angle) * (pieChartRadius / 2);
      
      doc.circle(circleX, circleY, circleRadius, 'F');
      currentAngle += slicePercentage;
    }
  });
  
  // Add center circle for donut effect
  doc.setFillColor(255, 255, 255);
  doc.circle(pieChartX, pieChartY, pieChartRadius * 0.5, 'F');
  
  // Add total value in center
  doc.setFontSize(12);
  doc.setTextColor(25, 118, 210);
  doc.text("Total", pieChartX, pieChartY - 5, { align: 'center' });
  doc.setFontSize(10);
  doc.text(`${getCurrencySymbol(selectedCurrency)}${Math.round(totalValue/1000)}K`, pieChartX, pieChartY + 5, { align: 'center' });
  
  // Add legend
  const legendX = pieChartX + pieChartRadius + 20;
  let legendY = pieChartY - pieChartRadius;
  
  nonZeroCategories.forEach((category, i) => {
    if (categoryTotals[category.name] > 0) {
      const color = colors[i % colors.length];
      doc.setFillColor(color[0], color[1], color[2]);
      doc.rect(legendX, legendY, 5, 5, 'F');
      
      doc.setFontSize(8);
      doc.setTextColor(0, 0, 0);
      doc.text(`${category.name}: ${getCurrencySymbol(selectedCurrency)}${Math.round(categoryTotals[category.name]).toLocaleString()} (${Math.round((categoryTotals[category.name] / totalValue) * 100)}%)`, 
               legendX + 8, legendY + 4);
      
      legendY += 8;
    }
  });
  
  yPosition += pieChartRadius * 2 + 30;
  
  // Add Performance Dimensions Radar section
  if (yPosition > pageHeight - 200) {
    doc.addPage();
    yPosition = margin;
  }
  
  doc.setFontSize(16);
  doc.setTextColor(25, 118, 210);
  doc.text("Performance Dimensions Analysis", margin, yPosition);
  yPosition += 10;
  
  doc.setFontSize(10);
  doc.setTextColor(100, 100, 100);
  doc.text("Visual representation of current vs. target performance across key dimensions", margin, yPosition);
  yPosition += 15;
  
  // Create a container for the radar chart
  const radarContainerWidth = pageWidth - (margin * 2);
  const radarContainerHeight = 120;
  
  doc.setFillColor(250, 250, 250);
  doc.roundedRect(margin, yPosition, radarContainerWidth, radarContainerHeight, 3, 3, 'F');
  doc.setDrawColor(220, 220, 220);
  doc.roundedRect(margin, yPosition, radarContainerWidth, radarContainerHeight, 3, 3, 'S');
  
  // Add radar chart title
  doc.setFontSize(12);
  doc.setTextColor(25, 118, 210);
  doc.text("Performance Dimensions Radar", margin + 10, yPosition + 10);
  
  // Create a simplified radar chart visualization
  const radarCenterX = margin + (radarContainerWidth / 2);
  const radarCenterY = yPosition + (radarContainerHeight / 2) + 10;
  const radarRadius = Math.min(radarContainerWidth, radarContainerHeight) * 0.3;
  
  // Draw radar grid
  doc.setDrawColor(240, 240, 240);
  for (let i = 1; i <= 5; i++) {
    const radius = radarRadius * (i / 5);
    doc.circle(radarCenterX, radarCenterY, radius, 'S');
  }
  
  // Draw axes
  const dimensions = [
    'Operational Efficiency',
    'Cost Reduction',
    'Time to Market',
    'Innovation Capacity',
    'Compliance Risk',
    'Revenue Growth',
    'Sustainability',
    'Supply Chain Resilience'
  ];
  
  dimensions.forEach((dimension, i) => {
    const angle = (i * 2 * Math.PI) / dimensions.length;
    const endX = radarCenterX + radarRadius * Math.cos(angle);
    const endY = radarCenterY + radarRadius * Math.sin(angle);
    
    doc.setDrawColor(200, 200, 200);
    doc.line(radarCenterX, radarCenterY, endX, endY);
    
    // Add dimension labels
    doc.setFontSize(6);
    doc.setTextColor(100, 100, 100);
    const labelX = radarCenterX + (radarRadius + 10) * Math.cos(angle);
    const labelY = radarCenterY + (radarRadius + 10) * Math.sin(angle);
    
    // Shorten long labels
    let shortLabel = dimension;
    if (dimension.length > 15) {
      shortLabel = dimension.substring(0, 12) + '...';
    }
    
    doc.text(shortLabel, labelX, labelY, { align: 'center' });
  });
  
  // Draw sample data (current and target)
  const sampleCurrentData = [65, 45, 70, 60, 80, 55, 40, 75];
  const sampleTargetData = [85, 70, 90, 85, 90, 80, 75, 90];
  
  // Draw current performance
  doc.setDrawColor(59, 130, 246);
  doc.setFillColor(59, 130, 246, 0.2);
  
  const currentPoints = sampleCurrentData.map((value, i) => {
    const angle = (i * 2 * Math.PI) / dimensions.length;
    const radius = (value / 100) * radarRadius;
    return {
      x: radarCenterX + radius * Math.cos(angle),
      y: radarCenterY + radius * Math.sin(angle)
    };
  });
  
  // Draw current polygon
  for (let i = 0; i < currentPoints.length; i++) {
    const nextIndex = (i + 1) % currentPoints.length;
    doc.line(currentPoints[i].x, currentPoints[i].y, currentPoints[nextIndex].x, currentPoints[nextIndex].y);
  }
  
  // Draw target performance
  doc.setDrawColor(16, 185, 129);
  doc.setFillColor(16, 185, 129, 0.2);
  
  const targetPoints = sampleTargetData.map((value, i) => {
    const angle = (i * 2 * Math.PI) / dimensions.length;
    const radius = (value / 100) * radarRadius;
    return {
      x: radarCenterX + radius * Math.cos(angle),
      y: radarCenterY + radius * Math.sin(angle)
    };
  });
  
  // Draw target polygon
  for (let i = 0; i < targetPoints.length; i++) {
    const nextIndex = (i + 1) % targetPoints.length;
    doc.line(targetPoints[i].x, targetPoints[i].y, targetPoints[nextIndex].x, targetPoints[nextIndex].y);
  }
  
  // Add data points
  currentPoints.forEach(point => {
    doc.setFillColor(59, 130, 246);
    doc.circle(point.x, point.y, 1.5, 'F');
  });
  
  targetPoints.forEach(point => {
    doc.setFillColor(16, 185, 129);
    doc.circle(point.x, point.y, 1.5, 'F');
  });
  
  // Add legend
  doc.setFontSize(8);
  doc.setTextColor(0, 0, 0);
  
  doc.setFillColor(59, 130, 246);
  doc.rect(radarCenterX - 40, yPosition + radarContainerHeight - 15, 5, 5, 'F');
  doc.text("Current Performance", radarCenterX - 30, yPosition + radarContainerHeight - 10);
  
  doc.setFillColor(16, 185, 129);
  doc.rect(radarCenterX + 10, yPosition + radarContainerHeight - 15, 5, 5, 'F');
  doc.text("Target Performance", radarCenterX + 20, yPosition + radarContainerHeight - 10);
  
  yPosition += radarContainerHeight + 20;
  
  // Add Performance Dimensions insights
  doc.setFontSize(10);
  doc.setTextColor(80, 80, 80);
  
  const insights = [
    "• The radar visualization shows performance across 8 key dimensions",
    "• Current performance (blue) vs. Target performance (green)",
    "• Largest gaps indicate highest improvement opportunities",
    "• Focus on dimensions with the largest performance gaps"
  ];
  
  insights.forEach((insight, i) => {
    doc.text(insight, margin, yPosition + (i * 5));
  });
  
  yPosition += insights.length * 5 + 15;
  
  // Add category breakdown table
  if (yPosition > pageHeight - 150) {
    doc.addPage();
    yPosition = margin;
  }
  
  const categoryData = categories.map(cat => [
    cat.name,
    `${getCurrencySymbol(selectedCurrency)}${categoryTotals[cat.name].toLocaleString()}`,
    `${Math.round((categoryTotals[cat.name] / totalImpact) * 100)}%`
  ]);
  
  doc.setFontSize(14);
  doc.setTextColor(0, 0, 0);
  doc.text("Category Impact Summary", margin, yPosition);
  yPosition += 10;
  
  doc.autoTable({
    startY: yPosition,
    head: [['Category', 'Impact ($)', '% of Total']],
    body: categoryData,
    headStyles: {
      fillColor: [25, 118, 210],
      textColor: 255,
      fontStyle: 'bold'
    },
    bodyStyles: {
      fontSize: 9
    },
    alternateRowStyles: {
      fillColor: [240, 240, 240]
    },
    margin: { top: 10 },
    theme: 'grid'
  });
  
  yPosition = doc.lastAutoTable.finalY + 15;
  
  // Add detailed factor analysis
  if (yPosition > pageHeight - 100) {
    doc.addPage();
    yPosition = margin;
  }
  
  doc.setFontSize(14);
  doc.setTextColor(0, 0, 0);
  doc.text("Detailed Factor Analysis", margin, yPosition);
  yPosition += 10;
  
  const factorData = nonZeroCategories.flatMap(cat => 
    cat.factors.map(factor => {
      const key = factor.key;
      const current = sliderValues[key]?.current ?? 0;
      const target = sliderValues[key]?.target ?? 0;
      const impact = getFactorImpact(key, target) - getFactorImpact(key, current);
      
      return [
        factor.label,
        sliderLabels[key]?.[current] || `Level ${current}`,
        sliderLabels[key]?.[target] || `Level ${target}`,
        `${getCurrencySymbol(selectedCurrency)}${impact.toLocaleString()}`,
        impact >= 0 ? 'Gain' : 'Loss'
      ];
    })
  );
  
  doc.autoTable({
    startY: yPosition,
    head: [['Factor', 'Current Level', 'Target Level', 'Impact ($)', 'Type']],
    body: factorData,
    headStyles: {
      fillColor: [25, 118, 210],
      textColor: 255,
      fontStyle: 'bold'
    },
    columnStyles: {
      0: { cellWidth: 50, fontSize: 8 },
      1: { cellWidth: 30, fontSize: 8 },
      2: { cellWidth: 30, fontSize: 8 },
      3: { cellWidth: 30, fontSize: 8 },
      4: { cellWidth: 20, fontSize: 8 }
    },
    alternateRowStyles: {
      fillColor: [245, 245, 245]
    },
    willDrawCell: function(data) {
      if (data.column.index === 4) {
        if (data.cell.raw === 'Gain') {
          doc.setFillColor(220, 255, 220);
          doc.setTextColor(76, 175, 80);
        } else {
          doc.setFillColor(255, 220, 220);
          doc.setTextColor(244, 67, 54);
        }
      }
    }
  });
  
  yPosition = doc.lastAutoTable.finalY + 15;
  
  // Add detailed dimension breakdown for top 5 factors
  if (yPosition > pageHeight - 100) {
    doc.addPage();
    yPosition = margin;
  }
  
  doc.setFontSize(14);
  doc.setTextColor(0, 0, 0);
  doc.text("Top 5 Factors - Dimension Breakdown", margin, yPosition);
  yPosition += 10;
  
  // Get top 5 factors by impact
  const topFactors = categories.flatMap(cat => 
    cat.factors.map(factor => {
      const key = factor.key;
      const current = sliderValues[key]?.current ?? 0;
      const target = sliderValues[key]?.target ?? 0;
      const impact = getFactorImpact(key, target) - getFactorImpact(key, current);
      
      return {
        key,
        label: factor.label,
        impact,
        category: cat.name
      };
    })
  ).sort((a, b) => b.impact - a.impact).slice(0, 5);
  
// Add dimension breakdown for each top factor

topFactors.forEach((factor, factorIndex) => {
  if (yPosition > pageHeight - 200) {
    doc.addPage();
    yPosition = margin;
  }
  
  // Factor Header with Impact Highlight (ENCODING SAFE)
  doc.setFontSize(14);
  doc.setTextColor(25, 50, 80);
  doc.text(`${factorIndex + 1}. ${factor.label}`, margin, yPosition);
  yPosition += 8;
  
  doc.setFontSize(10);
  doc.setTextColor(100, 100, 100);
  doc.text(`Category: ${factor.category} | Impact: ${getCurrencySymbol(selectedCurrency)}${Math.round(factor.impact).toLocaleString()}`, margin, yPosition);
  yPosition += 12;
  
  // Separator line
  doc.setDrawColor(200, 200, 200);
  doc.line(margin, yPosition, pageWidth - margin, yPosition);
  yPosition += 15;
  
  // ✅ FIXED: Retrieve and display dimension data CORRECTLY
  const factorKey = factor.key;
  const currentLevel = Math.max(1, Math.min(10, sliderValues[factorKey]?.current || 0));
  const targetLevel = Math.max(1, Math.min(10, sliderValues[factorKey]?.target || 0));
  
  // Check if dimension data exists for this factor
  const factorDimensionData = dimensionsData[factorKey];
  
  if (factorDimensionData && Object.keys(factorDimensionData).length > 0) {
    try {
      // Get the correct level keys
      const levelKeys = Object.keys(factorDimensionData).sort();
      const currentLevelKey = levelKeys[Math.min(currentLevel, levelKeys.length - 1)];
      const targetLevelKey = levelKeys[Math.min(targetLevel, levelKeys.length - 1)];
      
      const currentData = factorDimensionData[currentLevelKey];
      const targetData = factorDimensionData[targetLevelKey];
      
      if (currentData && targetData) {
        // Create RADAR CHART for this factor
        const radarWidth = pageWidth - (margin * 2);
        const radarHeight = 120;
        const radarCenterX = margin + (radarWidth / 2);
        const radarCenterY = yPosition + (radarHeight / 2);
        const radarRadius = Math.min(radarWidth, radarHeight) * 0.35;
        
        // Draw radar chart container
        doc.setFillColor(245, 248, 255);
        doc.roundedRect(margin, yPosition, radarWidth, radarHeight, 5, 5, 'F');
        doc.setDrawColor(220, 220, 220);
        doc.roundedRect(margin, yPosition, radarWidth, radarHeight, 5, 5, 'S');
        
        // Radar chart title (ENCODING SAFE - no emojis)
        doc.setFontSize(11);
        doc.setTextColor(25, 50, 80);
        doc.text("PERFORMANCE DIMENSIONS RADAR", radarCenterX, yPosition + 15, { align: 'center' });
        
        // Define dimensions for radar
        const dimensions = [
          "Operational Efficiency", "Cost Reduction", "Time to Market", "Innovation Capacity",
          "Compliance Risk", "Revenue Growth", "Sustainability", "Supply Chain Resilience"
        ];
        
        // Get dimension values
        const getDimensionValue = (data, dimensionName) => {
          const propertyMap = {
            "Operational Efficiency": "OperationalEfficiency",
            "Cost Reduction": "CostReduction", 
            "Time to Market": "TimeToMarket",
            "Innovation Capacity": "InnovationCapacity",
            "Compliance Risk": "ComplianceRisk",
            "Revenue Growth": "RevenueGrowth", 
            "Sustainability": "Sustainability",
            "Supply Chain Resilience": "SupplyChainResilience"
          };
          
          const property = propertyMap[dimensionName];
          return data[property] || 50;
        };
        
        const currentValues = dimensions.map(dim => getDimensionValue(currentData, dim));
        const targetValues = dimensions.map(dim => getDimensionValue(targetData, dim));
        
        // Draw radar grid
        doc.setDrawColor(230, 230, 230);
        for (let i = 1; i <= 5; i++) {
          const radius = (i / 5) * radarRadius;
          const segments = 24;
          for (let j = 0; j < segments; j++) {
            const angle1 = (j / segments) * Math.PI * 2;
            const angle2 = ((j + 1) / segments) * Math.PI * 2;
            const x1 = radarCenterX + radius * Math.cos(angle1);
            const y1 = radarCenterY + radius * Math.sin(angle1);
            const x2 = radarCenterX + radius * Math.cos(angle2);
            const y2 = radarCenterY + radius * Math.sin(angle2);
            doc.line(x1, y1, x2, y2);
          }
        }
        
        // Draw dimension axes
        dimensions.forEach((dim, i) => {
          const angle = (i / dimensions.length) * Math.PI * 2;
          const x = radarCenterX + radarRadius * Math.cos(angle);
          const y = radarCenterY + radarRadius * Math.sin(angle);
          
          doc.setDrawColor(200, 200, 200);
          doc.line(radarCenterX, radarCenterY, x, y);
          
          // Add dimension labels (shortened)
          const labelDistance = radarRadius + 20;
          const labelX = radarCenterX + labelDistance * Math.cos(angle);
          const labelY = radarCenterY + labelDistance * Math.sin(angle);
          
          doc.setFontSize(6);
          doc.setTextColor(100, 100, 100);
          const shortLabel = dim.length > 12 ? dim.substring(0, 10) + '..' : dim;
          doc.text(shortLabel, labelX, labelY, { align: 'center' });
        });
        
        // Draw CURRENT performance polygon (BLUE)
        const currentPoints = dimensions.map((_, i) => {
          const angle = (i / dimensions.length) * Math.PI * 2;
          const value = (currentValues[i] / 100) * radarRadius;
          return [
            radarCenterX + value * Math.cos(angle),
            radarCenterY + value * Math.sin(angle)
          ];
        });
        
        doc.setDrawColor(59, 130, 246);
        for (let i = 0; i < currentPoints.length; i++) {
          const nextIndex = (i + 1) % currentPoints.length;
          doc.line(currentPoints[i][0], currentPoints[i][1], currentPoints[nextIndex][0], currentPoints[nextIndex][1]);
        }
        
        // Draw TARGET performance polygon (GREEN)
        const targetPoints = dimensions.map((_, i) => {
          const angle = (i / dimensions.length) * Math.PI * 2;
          const value = (targetValues[i] / 100) * radarRadius;
          return [
            radarCenterX + value * Math.cos(angle),
            radarCenterY + value * Math.sin(angle)
          ];
        });
        
        doc.setDrawColor(16, 185, 129);
        for (let i = 0; i < targetPoints.length; i++) {
          const nextIndex = (i + 1) % targetPoints.length;
          doc.line(targetPoints[i][0], targetPoints[i][1], targetPoints[nextIndex][0], targetPoints[nextIndex][1]);
        }
        
        // Add legend (ENCODING SAFE)
        doc.setFontSize(8);
        doc.setTextColor(59, 130, 246);
        doc.text("Current", radarCenterX - 30, yPosition + radarHeight - 10);
        doc.setTextColor(16, 185, 129);
        doc.text("Target", radarCenterX + 10, yPosition + radarHeight - 10);
        
        yPosition += radarHeight + 20;
        
        // 📊 IMPROVEMENT METRICS TABLE (PROPER TABLE FORMAT)
        doc.setFontSize(11);
        doc.setTextColor(25, 50, 80);
        doc.text("PERFORMANCE IMPROVEMENT ANALYSIS", margin, yPosition);
        yPosition += 12;
        
        // Calculate improvements
        const improvements = dimensions.map((dim, i) => ({
          dimension: dim,
          current: Math.round(currentValues[i]),
          target: Math.round(targetValues[i]),
          improvement: Math.max(0, Math.round(targetValues[i] - currentValues[i])),
        })).filter(imp => imp.improvement > 5) // Only significant improvements
          .sort((a, b) => b.improvement - a.improvement)
          .slice(0, 4);
        
        if (improvements.length > 0) {
          // Table header
          doc.setFillColor(25, 50, 80);
          doc.rect(margin, yPosition, pageWidth - (margin * 2), 12, 'F');
          
          doc.setFontSize(9);
          doc.setTextColor(255, 255, 255);
          doc.text("Dimension", margin + 5, yPosition + 8);
          doc.text("Current", margin + 100, yPosition + 8);
          doc.text("Target", margin + 140, yPosition + 8);
          doc.text("Improvement", margin + 180, yPosition + 8);
          
          yPosition += 12;
          
          // Table rows
          improvements.forEach((imp, index) => {
            // Alternate row colors
            if (index % 2 === 0) {
              doc.setFillColor(245, 248, 250);
              doc.rect(margin, yPosition, pageWidth - (margin * 2), 10, 'F');
            }
            
            doc.setFontSize(9);
            doc.setTextColor(25, 50, 80);
            
            // Dimension name (shortened if needed)
            const shortDim = imp.dimension.length > 20 ? imp.dimension.substring(0, 18) + '..' : imp.dimension;
            doc.text(shortDim, margin + 5, yPosition + 7);
            
            // Current value
            doc.setTextColor(59, 130, 246);
            doc.text(`${imp.current}%`, margin + 100, yPosition + 7);
            
            // Target value
            doc.setTextColor(16, 185, 129);
            doc.text(`${imp.target}%`, margin + 140, yPosition + 7);
            
            // Improvement with color coding
            if (imp.improvement > 20) {
              doc.setTextColor(46, 139, 87); // Dark green for big improvements
            } else if (imp.improvement > 10) {
              doc.setTextColor(76, 175, 80); // Green for medium improvements
            } else {
              doc.setTextColor(106, 195, 90); // Light green for small improvements
            }
            doc.text(`+${imp.improvement}%`, margin + 180, yPosition + 7);
            
            yPosition += 10;
          });
          
          yPosition += 15;
        } else {
          doc.setFontSize(9);
          doc.setTextColor(100, 100, 100);
          doc.text("No significant improvements detected across dimensions", margin, yPosition);
          yPosition += 15;
        }
        
        // 🔧 CAPABILITIES SECTION (ENCODING SAFE)
        const currentCapabilities = currentData.PLMCapabilities || [];
        const targetCapabilities = targetData.PLMCapabilities || [];
        const newCapabilities = targetCapabilities.filter(cap => !currentCapabilities.includes(cap));
        
        if (newCapabilities.length > 0) {
          doc.setFontSize(11);
          doc.setTextColor(156, 39, 176);
          doc.text("NEW CAPABILITIES UNLOCKED", margin, yPosition);
          yPosition += 10;
          
          doc.setFontSize(9);
          doc.setTextColor(80, 80, 80);
          
          // Display capabilities in two columns for better layout
          const midPoint = Math.ceil(newCapabilities.length / 2);
          const leftColumn = newCapabilities.slice(0, midPoint);
          const rightColumn = newCapabilities.slice(midPoint, midPoint + 4);
          
          const maxRows = Math.max(leftColumn.length, rightColumn.length);
          const columnWidth = (pageWidth - (margin * 2)) / 2;
          
          for (let i = 0; i < maxRows; i++) {
            const y = yPosition + (i * 8);
            
            if (leftColumn[i]) {
              doc.text(`• ${leftColumn[i]}`, margin + 5, y);
            }
            
            if (rightColumn[i]) {
              doc.text(`• ${rightColumn[i]}`, margin + columnWidth + 5, y);
            }
          }
          
          yPosition += (maxRows * 8) + 15;
        }
        
        // 💡 INSIGHTFUL SUMMARY (ENCODING SAFE)
        const totalImprovement = improvements.reduce((sum, imp) => sum + imp.improvement, 0);
        const avgImprovement = improvements.length > 0 ? totalImprovement / improvements.length : 0;
        
        if (avgImprovement > 0) {
          doc.setFillColor(240, 248, 255);
          doc.roundedRect(margin, yPosition, pageWidth - (margin * 2), 30, 3, 3, 'F');
          
          doc.setFontSize(10);
          doc.setTextColor(25, 50, 80);
          doc.text("KEY INSIGHT:", margin + 5, yPosition + 10);
          
          let insightText = "";
          let impactLevel = "";
          
          if (avgImprovement > 25) {
            insightText = "TRANSFORMATIONAL opportunity that will dramatically reshape performance";
            impactLevel = "HIGH IMPACT";
          } else if (avgImprovement > 15) {
            insightText = "STRATEGIC improvement expected across multiple business dimensions";
            impactLevel = "MEDIUM IMPACT";
          } else {
            insightText = "INCREMENTAL gains with focused implementation benefits";
            impactLevel = "FOCUSED IMPACT";
          }
          
          doc.setFontSize(9);
          doc.setTextColor(80, 80, 80);
          doc.text(insightText, margin + 5, yPosition + 18);
          
          // Impact level badge
          doc.setFillColor(25, 50, 80);
          doc.rect(pageWidth - margin - 80, yPosition + 5, 75, 8, 'F');
          doc.setFontSize(8);
          doc.setTextColor(255, 255, 255);
          doc.text(impactLevel, pageWidth - margin - 77, yPosition + 10);
          
          yPosition += 35;
        }
        
      } else {
        showDataNotFoundMessage();
      }
    } catch (error) {
      console.error('Error generating radar chart:', error);
      showDataNotFoundMessage();
    }
  } else {
    showDataNotFoundMessage();
  }
  
  // Add separator between factors
  if (factorIndex < topFactors.length - 1) {
    doc.setDrawColor(220, 220, 220);
    doc.line(margin, yPosition, pageWidth - margin, yPosition);
    yPosition += 25;
  }
  
  function showDataNotFoundMessage() {
    doc.setFontSize(10);
    doc.setTextColor(100, 100, 100);
    doc.text("Advanced dimension analysis not available for this factor", margin, yPosition);
    yPosition += 15;
  }
});  

  // Add radar charts for each category with enhanced visualization
  nonZeroCategories.forEach(category => {
    // Check if we need a new page
    if (yPosition > pageHeight - 200) {
      doc.addPage();
      yPosition = margin;
    }
    
    doc.setFontSize(14);
    doc.setTextColor(0, 0, 0);
    doc.text(`${category.name} - Maturity Assessment`, margin, yPosition);
    yPosition += 10;
    
    // Create enhanced radar chart for this category
    const factors = category.factors;
    const chartWidth = pageWidth - (margin * 2);
    const chartHeight = 100;
    
    // Draw radar chart background
    doc.setFillColor(240, 245, 255);
    doc.roundedRect(margin, yPosition, chartWidth, chartHeight, 3, 3, 'F');
    
    // Draw radar axes
    const centerX = margin + (chartWidth / 2);
    const centerY = yPosition + (chartHeight / 2);
    const radius = Math.min(chartWidth, chartHeight) * 0.35;
    
    // Draw concentric circles with labels
    doc.setDrawColor(220, 220, 220);
    for (let i = 1; i <= 5; i++) {
      const circleRadius = radius * (i / 5);
      // Draw circle using multiple line segments (approximation)
      const segments = 36;
      const points = [];
      for (let j = 0; j < segments; j++) {
        const angle = (j / segments) * Math.PI * 2;
        points.push([
          centerX + circleRadius * Math.cos(angle),
          centerY + circleRadius * Math.sin(angle)
        ]);
      }
      // Close the circle
      points.push(points[0]);
      
      // Draw the circle
      for (let j = 0; j < points.length - 1; j++) {
        doc.line(points[j][0], points[j][1], points[j + 1][0], points[j + 1][1]);
      }
      
      // Add value labels
      doc.setFontSize(6);
      doc.setTextColor(150, 150, 150);
      doc.text(`${i * 2}`, centerX, centerY - circleRadius - 2, { align: 'center' });
    }
    
    // Draw axes and labels
    factors.forEach((factor, i) => {
      const angle = (i * 2 * Math.PI) / factors.length;
      const endX = centerX + radius * Math.cos(angle);
      const endY = centerY + radius * Math.sin(angle);
      
      // Draw axis line
      doc.setDrawColor(180, 180, 180);
      doc.line(centerX, centerY, endX, endY);
      
      // Draw factor label
      doc.setFontSize(7);
      doc.setTextColor(80, 80, 80);
      const labelX = centerX + (radius + 12) * Math.cos(angle);
      const labelY = centerY + (radius + 12) * Math.sin(angle);
      doc.text(factor.label, labelX, labelY, { align: 'center', maxWidth: 40 });
    });
    
    // Draw current values
    const currentPoints = factors.map((factor, i) => {
      const key = factor.key;
      const currentValue = sliderValues[key]?.current ?? 0;
      const normalizedValue = (currentValue / 10) * radius;
      const angle = (i * 2 * Math.PI) / factors.length;
      
      return {
        x: centerX + normalizedValue * Math.cos(angle),
        y: centerY + normalizedValue * Math.sin(angle)
      };
    });
    
    // Draw target values
    const targetPoints = factors.map((factor, i) => {
      const key = factor.key;
      const targetValue = sliderValues[key]?.target ?? 0;
      const normalizedValue = (targetValue / 10) * radius;
      const angle = (i * 2 * Math.PI) / factors.length;
      
      return {
        x: centerX + normalizedValue * Math.cos(angle),
        y: centerY + normalizedValue * Math.sin(angle)
      };
    });
    
    // Draw current polygon
    doc.setDrawColor(99, 102, 241);
    doc.setFillColor(99, 102, 241, 0.3);
    
    // Create path for current values
    const currentPath = [];
    for (let i = 0; i < currentPoints.length; i++) {
      currentPath.push([currentPoints[i].x, currentPoints[i].y]);
    }
    // Close the path
    currentPath.push([currentPoints[0].x, currentPoints[0].y]);
    
    // Draw the polygon
    for (let i = 0; i < currentPath.length - 1; i++) {
      doc.line(currentPath[i][0], currentPath[i][1], currentPath[i + 1][0], currentPath[i + 1][1]);
    }
    
    // Draw target polygon
    doc.setDrawColor(16, 185, 129);
    doc.setFillColor(16, 185, 129, 0.3);
    
    // Create path for target values
    const targetPath = [];
    for (let i = 0; i < targetPoints.length; i++) {
      targetPath.push([targetPoints[i].x, targetPoints[i].y]);
    }
    // Close the path
    targetPath.push([targetPoints[0].x, targetPoints[0].y]);
    
    // Draw the polygon
    for (let i = 0; i < targetPath.length - 1; i++) {
      doc.line(targetPath[i][0], targetPath[i][1], targetPath[i + 1][0], targetPath[i + 1][1]);
    }
    
    // Draw data points with emphasis
    currentPoints.forEach(point => {
      doc.setFillColor(99, 102, 241);
      // Draw circle using small rectangle approximation
      doc.rect(point.x - 1, point.y - 1, 2, 2, 'F');
    });
    
    targetPoints.forEach(point => {
      doc.setFillColor(16, 185, 129);
      // Draw circle using small rectangle approximation
      doc.rect(point.x - 1, point.y - 1, 2, 2, 'F');
      
      // Add value labels for target points
      const factorIndex = targetPoints.indexOf(point);
      const currentVal = sliderValues[factors[factorIndex].key]?.current ?? 0;
      const targetVal = sliderValues[factors[factorIndex].key]?.target ?? 0;
      const improvement = targetVal - currentVal;
      
      doc.setFontSize(6);
      if (improvement > 0) {
        doc.setTextColor(16, 185, 129);
        doc.text(`+${improvement}`, point.x, point.y - 5, { align: 'center' });
      }
    });
    
    // Add legend
    doc.setFontSize(8);
    doc.setTextColor(0, 0, 0);
    doc.text("Current Maturity", margin + 5, yPosition + chartHeight + 5);
    doc.setFillColor(99, 102, 241);
    doc.rect(margin + 40, yPosition + chartHeight + 2, 5, 5, 'F');
    
    doc.text("Target Maturity", margin + 70, yPosition + chartHeight + 5);
    doc.setFillColor(16, 185, 129);
    doc.rect(margin + 100, yPosition + chartHeight + 2, 5, 5, 'F');
    
    doc.text("Improvement", margin + 120, yPosition + chartHeight + 5);
    doc.setTextColor(16, 185, 129);
    doc.text("+X", margin + 150, yPosition + chartHeight + 5);
    
    yPosition += chartHeight + 15;
    
    // Add factor details table for this category
    const categoryFactorData = category.factors.map(factor => {
      const key = factor.key;
      const current = sliderValues[key]?.current ?? 0;
      const target = sliderValues[key]?.target ?? 0;
      const impact = getFactorImpact(key, target) - getFactorImpact(key, current);
      const improvement = target - current;
      
      return [
        factor.label,
        sliderLabels[key]?.[current] || `Level ${current}`,
        sliderLabels[key]?.[target] || `Level ${target}`,
        `${getCurrencySymbol(selectedCurrency)}${Math.round(impact).toLocaleString()}`,
        `${improvement > 0 ? '+' : ''}${improvement * 10}%`
      ];
    });
    
    doc.autoTable({
      startY: yPosition,
      head: [['Factor', 'Current', 'Target', 'Impact', 'Improvement']],
      body: categoryFactorData,
      headStyles: {
        fillColor: [100, 100, 100],
        textColor: 255,
        fontStyle: 'bold'
      },
      columnStyles: {
        0: { cellWidth: 50, fontSize: 7 },
        1: { cellWidth: 25, fontSize: 7 },
        2: { cellWidth: 25, fontSize: 7 },
        3: { cellWidth: 25, fontSize: 7 },
        4: { cellWidth: 25, fontSize: 7 }
      },
      styles: {
        fontSize: 7
      },
      willDrawCell: function(data) {
        if (data.column.index === 4) {
          const value = parseFloat(data.cell.raw);
          if (value > 0) {
            doc.setFillColor(220, 255, 220);
            doc.setTextColor(16, 185, 129);
          } else if (value < 0) {
            doc.setFillColor(255, 220, 220);
            doc.setTextColor(244, 67, 54);
          }
        }
        // Restore default styles for other cells
        else {
          doc.setFillColor(255, 255, 255);
          doc.setTextColor(0, 0, 0);
        }
      },
      theme: 'grid'
    });
    
    yPosition = doc.lastAutoTable.finalY + 15;
  });
  
  // Add visual impact chart with advanced visualization
  if (yPosition > pageHeight - 100) {
    doc.addPage();
    yPosition = margin;
  }
  
  doc.setFontSize(14);
  doc.setTextColor(0, 0, 0);
  doc.text("Impact Distribution Visualization", pageWidth / 2, yPosition, { align: 'center' });
  yPosition += 10;
  
  // Create advanced bar chart visualization
  const chartY = yPosition;
  const chartHeight = 80;
  const chartWidth = pageWidth - (margin * 2);
  const maxValue = Math.max(...Object.values(categoryTotals));
  const barWidth = (chartWidth - (categories.length * 10)) / categories.length;
  
  // Draw chart background
  doc.setDrawColor(220, 220, 220);
  doc.setFillColor(245, 245, 245);
  doc.rect(margin, chartY, chartWidth, chartHeight, 'F');
  
  // Draw grid lines
  doc.setDrawColor(230, 230, 230);
  for (let i = 1; i <= 4; i++) {
    const y = chartY + chartHeight - (i * chartHeight / 4);
    doc.line(margin, y, margin + chartWidth, y);
    
    // Add value labels
    doc.setFontSize(7);
    doc.setTextColor(150, 150, 150);
    doc.text(`${getCurrencySymbol(selectedCurrency)}${Math.round((i * maxValue / 4) / 1000)}K`, margin - 5, y, { align: 'right' });
  }
  
  // Draw bars with solid fills
  categories.forEach((cat, i) => {
    const barHeight = (categoryTotals[cat.name] / maxValue) * chartHeight;
    const x = margin + (i * (barWidth + 10)) + 5;
    const y = chartY + chartHeight - barHeight;
    
    const color = colors[i % colors.length];
    doc.setFillColor(color[0], color[1], color[2]);
    doc.rect(x, y, barWidth, barHeight, 'F');
    
    // Add bar border
    doc.setDrawColor(color[0] - 60, color[1] - 60, color[2] - 60);
    doc.rect(x, y, barWidth, barHeight, 'S');
    
    // Add value on top of bar
    doc.setFontSize(7);
    doc.setTextColor(0, 0, 0);
    doc.text(`${getCurrencySymbol(selectedCurrency)}${Math.round(categoryTotals[cat.name] / 1000)}K`, x + barWidth / 2, y - 5, { align: 'center' });
    
    // Add category label
    doc.text(cat.name.substring(0, 12), x + barWidth / 2, chartY + chartHeight + 5, { align: 'center', maxWidth: barWidth });
  });
  
  yPosition += chartHeight + 20;
  
  // Add key insights and recommendations
  if (yPosition > pageHeight - 100) {
    doc.addPage();
    yPosition = margin;
  }
  
  doc.setFontSize(14);
  doc.setTextColor(25, 118, 210);
  doc.text("Key Insights & Recommendations", margin, yPosition);
  yPosition += 10;
  
  doc.setFontSize(10);
  doc.setTextColor(0, 0, 0);
  
  // Find top 3 impactful categories
  const sortedCategories = [...nonZeroCategories].sort((a, b) => 
    categoryTotals[b.name] - categoryTotals[a.name]
  );
  
  const insights_perform = [
    `Top opportunity area: ${sortedCategories[0].name} with potential impact of ${getCurrencySymbol(selectedCurrency)}${Math.round(categoryTotals[sortedCategories[0].name]).toLocaleString()}`,
    `Focus on improving ${sortedCategories[0].factors[0].label} and ${sortedCategories[0].factors[1].label} for maximum ROI`,
    `Consider a phased implementation approach starting with high-impact, low-complexity initiatives`,
    `Expected payback period: ${Math.round(totalImpact / (turnover * 0.05))} months based on 5% investment of annual revenue`
  ];
  
  insights_perform.forEach((insight, i) => {
    if (yPosition > pageHeight - 20) {
      doc.addPage();
      yPosition = margin;
    }
    
    doc.setFillColor(240, 248, 255);
    doc.roundedRect(margin, yPosition, pageWidth - (margin * 2), 10, 2, 2, 'F');
    
    doc.setTextColor(25, 118, 210);
    doc.text("💡", margin + 3, yPosition + 7);
    doc.setTextColor(0, 0, 0);
    doc.text(insight, margin + 15, yPosition + 7);
    
    yPosition += 15;
  });
  
  // Add watermark to all pages
  const pageCount = doc.internal.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    
    // Add watermark on top of all content
    doc.setGState(new doc.GState({opacity: 0.15}));
    doc.setFont("helvetica", "normal");
    doc.setFontSize(50);
    doc.setTextColor(200, 200, 200);
    const watermarkText = "eEvolve.ai";
    const watermarkWidth = doc.getTextWidth(watermarkText);
    const watermarkX = (pageWidth - watermarkWidth) / 2;
    const watermarkY = pageHeight / 2;
    doc.text(watermarkText, watermarkX, watermarkY, { angle: 45 });
    doc.setGState(new doc.GState({opacity: 1}));
    
    // Add footer (after watermark to ensure it's visible)
    doc.setFontSize(8);
    doc.setTextColor(100, 100, 100);
    doc.text(`Page ${i} of ${pageCount}`, pageWidth / 2, pageHeight - 10, { align: 'center' });
    doc.text("Confidential - Quantum PLM ROI Analysis", pageWidth - margin, pageHeight - 10, { align: 'right' });
  }
  
// Add legal disclaimer as the final page
addLegalDisclaimer(doc, pageWidth, pageHeight, margin);  
  
  // Save the PDF
  doc.save(`PLM_ROI_Quantum_Report_${new Date().toISOString().split('T')[0]}.pdf`);
  enqueueSnackbar('Advanced PDF report generated with executive visualizations!', { variant: 'success' });
};

// Add comprehensive legal disclaimer at the end
const addLegalDisclaimer = (doc, pageWidth, pageHeight, margin) => {
  // Add new page for disclaimer
  doc.addPage();
  let yPosition = margin;
  
  // Disclaimer Header
  doc.setFontSize(16);
  doc.setTextColor(200, 0, 0); // Red for importance
  doc.text("IMPORTANT LEGAL DISCLAIMER & LIMITATIONS OF LIABILITY", pageWidth / 2, yPosition, { align: 'center' });
  yPosition += 15;
  
  // Red warning line
  doc.setDrawColor(200, 0, 0);
  doc.line(margin, yPosition, pageWidth - margin, yPosition);
  yPosition += 10;
  
  // Disclaimer content
  doc.setFontSize(8);
  doc.setTextColor(100, 100, 100);
  
  const disclaimerLines = [
    "1. NATURE OF ANALYSIS: This report contains predictive analysis, projections, and estimates based on",
    "   mathematical models and industry benchmarks. All results are hypothetical and for informational",
    "   purposes only. Actual results may vary significantly from projections.",
    "",
    "2. NO WARRANTY: This analysis is provided 'AS IS' without any warranties, express or implied. eEvolve.ai",
    "   makes no representations regarding the accuracy, completeness, reliability, or suitability of the",
    "   information contained herein. Users assume all risks associated with reliance on this analysis.",
    "",
    "3. NOT PROFESSIONAL ADVICE: This report does not constitute financial, legal, investment, or professional",
    "   advice of any kind. Users should consult qualified professional advisors before making any business",
    "   decisions based on this analysis.",
    "",
    "4. INTELLECTUAL PROPERTY: All models, algorithms, and methodologies are proprietary intellectual property",
    "   of eEvolve.ai. This report is licensed for internal use only and may not be reproduced or distributed",
    "   without written permission.",
    "",
    "5. LIMITATION OF LIABILITY: To the fullest extent permitted by law, eEvolve.ai and its affiliates shall",
    "   not be liable for any direct, indirect, incidental, special, consequential, or punitive damages",
    "   arising from or related to the use of this analysis, including but not limited to:",
    "   - Business decisions made based on this report",
    "   - Financial losses or missed opportunities",
    "   - Implementation costs or project failures",
    "   - Any third-party claims",
    "",
    "6. CONFIDENTIALITY: This report may contain confidential and proprietary information. Recipients agree",
    "   to maintain the confidentiality of the methodologies and analysis techniques disclosed herein.",
    "",
    "7. ASSUMPTIONS & LIMITATIONS: The analysis relies on user-provided data and industry averages. Key",
    "   assumptions include stable market conditions, accurate input data, and typical implementation",
    "   scenarios. Results are sensitive to changes in these assumptions.",
    "",
    "8. NO GUARANTEES: Past performance or hypothetical projections are not indicative of future results.",
    "   eEvolve.ai does not guarantee any specific outcomes, ROI, or business benefits.",
    "",
    "9. GOVERNING LAW: This disclaimer shall be governed by and construed in accordance with the laws of",
    "   England and Wales, without regard to its conflict of law provisions.",
    "",
    "10. ACCEPTANCE: By using this report, you acknowledge that you have read, understood, and agree to be",
    "    bound by these terms and limitations."
  ];
  
  // Add current date
  const currentDate = new Date().toLocaleDateString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });
  
  disclaimerLines.push("", `Report generated on: ${currentDate}`, "© 2024 eEvolve.ai. All rights reserved.");
  
  // Add disclaimer text with proper formatting
  disclaimerLines.forEach(line => {
    if (yPosition > pageHeight - 20) {
      doc.addPage();
      yPosition = margin;
    }
    
    if (line === "") {
      yPosition += 4; // Extra space for empty lines
    } else {
      // Split long lines if needed
      if (doc.getTextWidth(line) > (pageWidth - (margin * 2))) {
        const words = line.split(' ');
        let currentLine = '';
        
        for (let i = 0; i < words.length; i++) {
          const testLine = currentLine + words[i] + ' ';
          if (doc.getTextWidth(testLine) > (pageWidth - (margin * 2)) && currentLine !== '') {
            doc.text(currentLine, margin, yPosition);
            yPosition += 4;
            currentLine = words[i] + ' ';
          } else {
            currentLine = testLine;
          }
        }
        doc.text(currentLine, margin, yPosition);
      } else {
        doc.text(line, margin, yPosition);
      }
      yPosition += 4;
    }
  });
  
  // Add final acceptance box
  yPosition += 10;
  doc.setDrawColor(200, 0, 0);
  doc.setLineWidth(0.5);
  doc.rect(margin, yPosition, pageWidth - (margin * 2), 20);
  
  doc.setFontSize(7);
  doc.setTextColor(200, 0, 0);
  doc.text("BY USING THIS REPORT, YOU ACKNOWLEDGE AND AGREE TO THE TERMS ABOVE", 
           pageWidth / 2, yPosition + 12, { align: 'center' });
};


// valueSpectrum for PDF value spectrum

const valueSpectrum = (doc, pageWidth, pageHeight, margin, yPosition, totalImpact, categoryTotals, categories, sliderValues, turnover, projectionYear, selectedCurrency) => {
  // Store initial yPosition for page management
  let currentY = yPosition;
  
  // Add Value Spectrum Master Title Page
  doc.addPage();
  currentY = margin;
  
  // Create impressive title page
  doc.setFillColor(25, 50, 80);
  doc.rect(0, 0, pageWidth, pageHeight, 'F');
  
  doc.setGState(new doc.GState({opacity: 0.1}));
  doc.setFillColor(255, 255, 255);
  const titleBgSize = 200;
  doc.rect((pageWidth - titleBgSize) / 2, (pageHeight - titleBgSize) / 2 - 20, titleBgSize, titleBgSize, 'F');
  doc.setGState(new doc.GState({opacity: 1}));
  
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(28);
  doc.text("QUANTUM VALUE SPECTRUM", pageWidth / 2, pageHeight / 2 - 40, { align: 'center' });
  
  doc.setFontSize(18);
  doc.text("PLM Transformation Impact Analysis", pageWidth / 2, pageHeight / 2 - 15, { align: 'center' });
  
  // Create radiating circles effect
  doc.setDrawColor(255, 255, 255, 0.3);
  for (let i = 1; i <= 5; i++) {
    const radius = 20 + (i * 15);
    // Use multiple line segments to approximate a circle since circle() might not be available
    const segments = 36;
    for (let j = 0; j < segments; j++) {
      const angle1 = (j / segments) * Math.PI * 2;
      const angle2 = ((j + 1) / segments) * Math.PI * 2;
      const x1 = pageWidth / 2 + radius * Math.cos(angle1);
      const y1 = pageHeight / 2 + 20 + radius * Math.sin(angle1);
      const x2 = pageWidth / 2 + radius * Math.cos(angle2);
      const y2 = pageHeight / 2 + 20 + radius * Math.sin(angle2);
      doc.line(x1, y1, x2, y2);
    }
  }
  
  doc.setFontSize(14);
  doc.text(`Total Value Potential: ${getCurrencySymbol(selectedCurrency)}${Math.round(totalImpact/1000)}K`, pageWidth / 2, pageHeight / 2 + 20, { align: 'center' });
  
  // FIX: Properly handle projection period to avoid overlap
  const projectionText = `Projection Period: ${projectionYear} Year${projectionYear !== 1 ? 's' : ''}`;
  doc.text(projectionText, pageWidth / 2, pageHeight / 2 + 40, { align: 'center' });
  
  doc.setFontSize(10);
  doc.setTextColor(200, 200, 200);
  doc.text("Confidential - Strategic Value Assessment", pageWidth / 2, pageHeight - 30, { align: 'center' });
  
  // Add second page with executive summary
  doc.addPage();
  currentY = margin;
  
  doc.setFontSize(16);
  doc.setTextColor(25, 50, 80);
  doc.text("EXECUTIVE VALUE SUMMARY", pageWidth / 2, currentY, { align: 'center' });
  currentY += 15;
  
  // Create value at a glance visualization
  const summaryWidth = pageWidth - (margin * 2);
  const summaryHeight = 80;
  
  // Draw summary background
  doc.setFillColor(245, 248, 250);
  doc.roundedRect(margin, currentY, summaryWidth, summaryHeight, 5, 5, 'F');
  
  // Add key metrics
  const metrics = [
    { label: "Total Impact", value: `${getCurrencySymbol(selectedCurrency)}${Math.round(totalImpact/1000)}K`, color: [25, 118, 210] },
    { label: "ROI Multiple", value: `${Math.round((totalImpact / (turnover * 0.05)))}x`, color: [76, 175, 80] },
    { label: "Payback", value: `${Math.round((turnover * 0.05) / (totalImpact / 12))} months`, color: [255, 152, 0] },
    { label: "Annualized ROI", value: `${Math.round((totalImpact / (turnover * 0.05)) * 100)}%`, color: [156, 39, 176] }
  ];
  
  const metricWidth = summaryWidth / metrics.length;
  metrics.forEach((metric, i) => {
    const x = margin + (i * metricWidth) + (metricWidth / 2);
    const y = currentY + (summaryHeight / 2);
    
    doc.setFontSize(20);
    doc.setTextColor(metric.color[0], metric.color[1], metric.color[2]);
    doc.text(metric.value, x, y - 5, { align: 'center' });
    
    doc.setFontSize(9);
    doc.setTextColor(100, 100, 100);
    doc.text(metric.label, x, y + 10, { align: 'center' });
  });
  
  currentY += summaryHeight + 20;
  
  // Add overall value spectrum visualization
  doc.setFontSize(14);
  doc.setTextColor(25, 50, 80);
  doc.text("OVERALL VALUE SPECTRUM", margin, currentY);
  currentY += 10;
  
  // Create advanced value spectrum visualization
  const spectrumWidth = pageWidth - (margin * 2);
  const spectrumHeight = 100;
  
  // Draw gradient manually using multiple rectangles
  const gradientSteps = 10;
  const stepWidth = spectrumWidth / gradientSteps;
  
  for (let i = 0; i < gradientSteps; i++) {
    // Calculate gradient color transition
    const ratio = i / (gradientSteps - 1);
    const r = Math.floor(68 + (249 - 68) * ratio);
    const g = Math.floor(138 + (168 - 138) * ratio);
    const b = Math.floor(255 + (37 - 255) * ratio);
    
    doc.setFillColor(r, g, b);
    doc.rect(margin + (i * stepWidth), currentY, stepWidth, spectrumHeight, 'F');
  }
  
  // Add spectrum intensity markers
  const intensityMarkers = ["Foundational", "Operational", "Strategic", "Transformational"];
  intensityMarkers.forEach((marker, i) => {
    const x = margin + (i * (spectrumWidth / (intensityMarkers.length - 1)));
    doc.setDrawColor(255, 255, 255);
    doc.line(x, currentY, x, currentY + spectrumHeight);
    
    doc.setFontSize(8);
    doc.setTextColor(255, 255, 255);
    doc.text(marker, x, currentY + spectrumHeight + 5, { align: 'center' });
  });
  
  // Plot category values on spectrum
  const maxCategoryValue = Math.max(...Object.values(categoryTotals));
  nonZeroCategories.forEach((category, i) => {
    const categoryValue = categoryTotals[category.name];
    const normalizedValue = categoryValue / maxCategoryValue;
    const x = margin + (normalizedValue * spectrumWidth);
    const y = currentY + (spectrumHeight / 2) + (Math.sin(i) * 20);
    
    // Draw category marker
    doc.setFillColor(255, 255, 255);
    doc.rect(x - 2.5, y - 2.5, 5, 5, 'F');
    
    // Add connecting line
    doc.setDrawColor(255, 255, 255, 0.5);
    doc.line(x, y, x, currentY + spectrumHeight + 10);
    
    // Add category label
    doc.setFontSize(8);
    doc.setTextColor(25, 50, 80);
    doc.text(category.name, x, currentY + spectrumHeight + 15, { align: 'center', maxWidth: 60 });
    
    // Add value label
    doc.setFontSize(7);
    doc.setTextColor(100, 100, 100);
    doc.text(`${getCurrencySymbol(selectedCurrency)}${Math.round(categoryValue/1000)}K`, x, currentY + spectrumHeight + 22, { align: 'center' });
  });
  
  currentY += spectrumHeight + 35;
  
  // Add value distribution chart
  if (currentY > pageHeight - 150) {
    doc.addPage();
    currentY = margin;
  }
  
  doc.setFontSize(14);
  doc.setTextColor(25, 50, 80);
  doc.text("VALUE DISTRIBUTION ANALYSIS", margin, currentY);
  currentY += 10;
  
  // Create sunburst chart for value distribution
  const sunburstRadius = 50;
  const sunburstX = margin + sunburstRadius + 20;
  const sunburstY = currentY + sunburstRadius + 10;
  
  // Calculate total value for percentages
  const totalValue = Object.values(categoryTotals).reduce((sum, val) => sum + val, 0);
  
  // Draw sunburst chart manually
  let startAngle = 0;
  categories.forEach((category, i) => {
    const sliceAngle = (categoryTotals[category.name] / totalValue) * (Math.PI * 2);
    
    if (sliceAngle > 0) {
      // Draw outer ring (category) using line segments
      const color = [
        [65, 105, 225],
        [220, 20, 60],
        [46, 139, 87],
        [255, 140, 0],
        [148, 0, 211],
        [255, 69, 0],
        [30, 144, 255],
        [50, 205, 50]
      ][i % 8];
      
      doc.setFillColor(color[0], color[1], color[2]);
      
      // Draw pie slice using multiple line segments
      const segments = Math.max(10, Math.floor(sliceAngle * 10));
      const points = [];
      
      // Center point
      points.push([sunburstX, sunburstY]);
      
      // Outer arc points
      for (let j = 0; j <= segments; j++) {
        const angle = startAngle + (j / segments) * sliceAngle;
        points.push([
          sunburstX + sunburstRadius * Math.cos(angle),
          sunburstY + sunburstRadius * Math.sin(angle)
        ]);
      }
      
      // Draw filled polygon
      for (let j = 1; j < points.length - 1; j++) {
        doc.setFillColor(color[0], color[1], color[2]);
        // Draw triangle fan from center to two outer points
        doc.triangle(
          points[0][0], points[0][1],
          points[j][0], points[j][1],
          points[j + 1][0], points[j + 1][1],
          'F'
        );
      }
      
      // Add category label
      const labelAngle = startAngle + (sliceAngle / 2);
      const labelRadius = sunburstRadius + 15;
      const labelX = sunburstX + Math.cos(labelAngle) * labelRadius;
      const labelY = sunburstY + Math.sin(labelAngle) * labelRadius;
      
      doc.setFontSize(7);
      doc.setTextColor(25, 50, 80);
      doc.text(category.name, labelX, labelY, { align: 'center', maxWidth: 40 });
      
      // Add value percentage
      const valueRadius = sunburstRadius + 25;
      const valueX = sunburstX + Math.cos(labelAngle) * valueRadius;
      const valueY = sunburstY + Math.sin(labelAngle) * valueRadius;
      
      doc.setFontSize(6);
      doc.setTextColor(100, 100, 100);
      doc.text(`${Math.round((categoryTotals[category.name] / totalValue) * 100)}%`, valueX, valueY, { align: 'center' });
      
      startAngle += sliceAngle;
    }
  });
  
  // Add center circle with total value
  doc.setFillColor(255, 255, 255);
  // Draw center circle using multiple line segments
  const centerSegments = 36;
  for (let i = 0; i < centerSegments; i++) {
    const angle1 = (i / centerSegments) * Math.PI * 2;
    const angle2 = ((i + 1) / centerSegments) * Math.PI * 2;
    const x1 = sunburstX + (sunburstRadius * 0.4) * Math.cos(angle1);
    const y1 = sunburstY + (sunburstRadius * 0.4) * Math.sin(angle1);
    const x2 = sunburstX + (sunburstRadius * 0.4) * Math.cos(angle2);
    const y2 = sunburstY + (sunburstRadius * 0.4) * Math.sin(angle2);
    
    doc.setFillColor(255, 255, 255);
    doc.triangle(sunburstX, sunburstY, x1, y1, x2, y2, 'F');
  }
  
  doc.setFontSize(10);
  doc.setTextColor(25, 50, 80);
  doc.text("Total", sunburstX, sunburstY - 5, { align: 'center' });
  doc.setFontSize(12);
  doc.text(`${getCurrencySymbol(selectedCurrency)}${Math.round(totalValue/1000)}K`, sunburstX, sunburstY + 5, { align: 'center' });
  
  currentY += sunburstRadius * 2 + 20;
  
  // Add new page for the 8-dimension radar chart
  doc.addPage();
  currentY = margin;
  
  doc.setFontSize(16);
  doc.setTextColor(25, 50, 80);
  doc.text("8-DIMENSION IMPACT RADAR", pageWidth / 2, currentY, { align: 'center' });
  currentY += 20;
  
  // Create radar chart for the 8 dimensions
  const radarCenterX = pageWidth / 2;
  const radarCenterY = currentY + 150;
  const radarRadius = 120;
  
  // Define the 8 dimensions from the dimensionMapping
  const dimensions = [
    "operationalEfficiency", 
    "costReduction", 
    "timeToMarket", 
    "innovationCapacity",
    "complianceRisk", 
    "revenueGrowth", 
    "sustainability", 
    "supplyChainResilience"
  ];
  
  // Calculate average values for each dimension across all selected factors
  const dimensionAverages = {};
  dimensions.forEach(dim => {
    dimensionAverages[dim] = 0;
  });
  
  let factorCount = 0;
  
  // Calculate averages for each dimension
  Object.keys(sliderValues).forEach(factorKey => {
    const selectedLevel = sliderValues[factorKey]?.current || 0;
    
    // Check if dimensionsData exists and has the factor
    if (dimensionsData && dimensionsData[factorKey]) {
      // Get the level data for this factor
      const levelData = dimensionsData[factorKey][selectedLevel];
      
      if (levelData) {
        dimensions.forEach(dim => {
          // Use the dimension name directly (e.g., "operationalEfficiency")
          dimensionAverages[dim] += levelData[dim] || 0;
        });
        factorCount++;
      }
    }
  });
  
  // Calculate averages
  dimensions.forEach(dim => {
    dimensionAverages[dim] = factorCount > 0 ? dimensionAverages[dim] / factorCount : 0;
  });
  
  // Draw radar chart
  const maxRadarValue = 100; // Maximum value for radar scale
  
  // Draw radar grid
  const gridCircles = 5;
  for (let i = 1; i <= gridCircles; i++) {
    const radius = (i / gridCircles) * radarRadius;
    doc.setDrawColor(220, 220, 220);
    
    // Draw concentric circles
    const segments = 36;
    for (let j = 0; j < segments; j++) {
      const angle1 = (j / segments) * Math.PI * 2;
      const angle2 = ((j + 1) / segments) * Math.PI * 2;
      const x1 = radarCenterX + radius * Math.cos(angle1);
      const y1 = radarCenterY + radius * Math.sin(angle1);
      const x2 = radarCenterX + radius * Math.cos(angle2);
      const y2 = radarCenterY + radius * Math.sin(angle2);
      doc.line(x1, y1, x2, y2);
    }
    
    // Add value labels
    doc.setFontSize(7);
    doc.setTextColor(150, 150, 150);
    doc.text(`${(i / gridCircles) * 100}`, radarCenterX, radarCenterY - radius - 3, { align: 'center' });
  }
  
  // Draw dimension axes
  dimensions.forEach((dim, i) => {
    const angle = (i / dimensions.length) * Math.PI * 2;
    const x = radarCenterX + radarRadius * Math.cos(angle);
    const y = radarCenterY + radarRadius * Math.sin(angle);
    
    doc.setDrawColor(180, 180, 180);
    doc.line(radarCenterX, radarCenterY, x, y);
    
    // Add dimension labels with careful positioning to avoid overlap
    const labelDistance = radarRadius + 25;
    const labelX = radarCenterX + labelDistance * Math.cos(angle);
    const labelY = radarCenterY + labelDistance * Math.sin(angle);
    
    doc.setFontSize(8);
    doc.setTextColor(25, 50, 80);
    
    // Adjust text alignment based on angle to prevent overlap
    let align = 'center';
    if (Math.cos(angle) > 0.7) align = 'left';
    if (Math.cos(angle) < -0.7) align = 'right';
    if (Math.sin(angle) > 0.7) align = 'center';
    if (Math.sin(angle) < -0.7) align = 'center';
    
    doc.text(dim.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase()), labelX, labelY, { align, maxWidth: 60 });
  });
  
  // Draw data polygon
  const points = dimensions.map((dim, i) => {
    const angle = (i / dimensions.length) * Math.PI * 2;
    const value = (dimensionAverages[dim] / maxRadarValue) * radarRadius;
    return [
      radarCenterX + value * Math.cos(angle),
      radarCenterY + value * Math.sin(angle)
    ];
  });
  
  // Fill the polygon
  doc.setFillColor(65, 105, 225, 0.3);
  for (let i = 1; i < points.length - 1; i++) {
    doc.triangle(
      radarCenterX, radarCenterY,
      points[i][0], points[i][1],
      points[i + 1][0], points[i + 1][1],
      'F'
    );
  }
  
  // Connect the last point to the first
  doc.triangle(
    radarCenterX, radarCenterY,
    points[points.length - 1][0], points[points.length - 1][1],
    points[0][0], points[0][1],
    'F'
  );
  
  // Draw polygon outline
  doc.setDrawColor(65, 105, 225);
  doc.setLineWidth(1.5);
  for (let i = 0; i < points.length; i++) {
    const nextIndex = (i + 1) % points.length;
    doc.line(points[i][0], points[i][1], points[nextIndex][0], points[nextIndex][1]);
  }
  
  // Add data points
  points.forEach((point, i) => {
    doc.setFillColor(65, 105, 225);
    doc.rect(point[0] - 2, point[1] - 2, 4, 4, 'F');
  });
  
  currentY += 300;
  
  // Add dimension scores table
  if (currentY > pageHeight - 100) {
    doc.addPage();
    currentY = margin;
  }
  
  doc.setFontSize(12);
  doc.setTextColor(25, 50, 80);
  doc.text("DIMENSION PERFORMANCE SCORES", margin, currentY);
  currentY += 15;
  
  // Create dimension scores table
  const tableTop = currentY;
  const colWidth = (pageWidth - (margin * 2)) / 2;
  
  // Table header
  doc.setFillColor(25, 50, 80);
  doc.rect(margin, tableTop, colWidth, 12, 'F');
  doc.rect(margin + colWidth, tableTop, colWidth, 12, 'F');
  
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(10);
  doc.text("Dimension", margin + 5, tableTop + 8);
  doc.text("Score", margin + colWidth + 5, tableTop + 8);
  
  currentY += 12;
  
  // Table rows
  dimensions.forEach((dim, i) => {
    if (currentY > pageHeight - 20) {
      doc.addPage();
      currentY = margin + 12;
    }
    
    // Alternate row colors
    if (i % 2 === 0) {
      doc.setFillColor(245, 248, 250);
      doc.rect(margin, currentY, colWidth * 2, 10, 'F');
    }
    
    doc.setTextColor(25, 50, 80);
    doc.setFontSize(9);
    doc.text(dim.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase()), margin + 5, currentY + 7);
    
    // Score with color coding
    const score = Math.round(dimensionAverages[dim]);
    let scoreColor = [220, 20, 60]; // red
    if (score > 33) scoreColor = [255, 140, 0]; // orange
    if (score > 66) scoreColor = [46, 139, 87]; // green
    
    doc.setTextColor(scoreColor[0], scoreColor[1], scoreColor[2]);
    doc.text(`${score}%`, margin + colWidth + 5, currentY + 7);
    
    currentY += 10;
  });
  
  currentY += 15;
  
  return currentY;
};

// Add triangle function to jsPDF if it doesn't exist
if (typeof jsPDF !== 'undefined' && !jsPDF.prototype.triangle) {
  jsPDF.prototype.triangle = function(x1, y1, x2, y2, x3, y3, style) {
    this.line(x1, y1, x2, y2);
    this.line(x2, y2, x3, y3);
    this.line(x3, y3, x1, y1);
    if (style === 'F') {
      // For fill, we need to use path and fill - this is a simplified version
      this.setFillColor(this.internal.getCurrentFillColor());
      this.setDrawColor(this.internal.getCurrentFillColor());
      this.line(x1, y1, x2, y2);
      this.line(x2, y2, x3, y3);
      this.line(x3, y3, x1, y1);
    }
    return this;
  };

}


//***************************** Try Advance Visualization






//*****************************

/*   const handleSaveScenario = async (name, description) => {
    if (!user) {
      navigate('/login');
      return;
    }

  try {
    // Show saving state
    setSnackbar({
      open: true,
      message: 'Saving quantum scenario...',
      severity: 'info'
    });

    const scenarioData = {
        name,
        description,
        values: sliderValues,
        parameters,
        industry,
        tier,
        persona,
        turnover,
        projectionYear,
        totalImpact,
        userId: user._id
      };

    // Add optimistic UI update
    const tempScenario = {
      ...scenarioData,
      _id: `temp-${Date.now()}`,
      createdAt: new Date()
    };
    setSavedScenarios(prev => [tempScenario, ...prev]);

    const { data } = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/api/scenarios`,
      scenarioData,
      {
        headers: { Authorization: `Bearer ${token}` },
        timeout: 10000 // 10 second timeout
      }
    );

    // Update UI with real data
    setSavedScenarios(prev => [
      data,
      ...prev.filter(s => s._id !== tempScenario._id)
    ]);

    // Update credits
    const updatedCredits = user.credits - 1;
    setCredits(updatedCredits);
    await refreshUser(); // Ensure AuthContext updates

    setSnackbar({
      open: true,
      message: 'Scenario saved successfully!',
      severity: 'success'
    });

    // Trigger visual celebration
    if (triggerCreditPulse) triggerCreditPulse();
    
    return true;
  } catch (error) {
    console.error('Save failed:', error);
    
    // Remove optimistic update
    setSavedScenarios(prev => prev.filter(s => !s._id.startsWith('temp-')));
    
    const errorMessage = error.response?.data?.message || 
                       error.message || 
                       'Failed to save scenario';
    
    setSnackbar({
      open: true,
      message: errorMessage,
      severity: 'error'
    });

    // Auto-retry for network errors
    if (error.code === 'ECONNABORTED' || !error.response) {
      setTimeout(() => {
        setSnackbar({
          open: true,
          message: 'Retrying save...',
          severity: 'info'
        });
        handleSaveScenario(name, description);
      }, 3000);
    }
    
    return false;
  }
}; */


// Add this component inside your ROIAnalyzer, before the return statement
const DockableImpactDisplay = () => {
  const theme = useTheme();
  
  // Handle drag start
  const handleDragStart = (e) => {
    if (impactDisplayPosition === 'floating') {
      setIsDragging(true);
      const rect = e.currentTarget.getBoundingClientRect();
      dragOffset.current = {
        x: e.clientX - rect.left,
        y: e.clientY - rect.top
      };
      e.currentTarget.style.cursor = 'grabbing';
    }
  };

  // Handle dragging
  const handleDrag = useCallback((e) => {
    if (isDragging && impactDisplayPosition === 'floating') {
      const newX = e.clientX - dragOffset.current.x;
      const newY = e.clientY - dragOffset.current.y;
      
      // Keep within viewport bounds
      const boundedX = Math.max(0, Math.min(window.innerWidth - 300, newX));
      const boundedY = Math.max(100, Math.min(window.innerHeight - 200, newY));
      
      setFloatingPosition({ x: boundedX, y: boundedY });
    }
  }, [isDragging, impactDisplayPosition]);

  // Handle drag end
  const handleDragEnd = () => {
    setIsDragging(false);
    document.body.style.cursor = 'default';
  };

  // Add event listeners for dragging
  useEffect(() => {
    if (isDragging) {
      document.addEventListener('mousemove', handleDrag);
      document.addEventListener('mouseup', handleDragEnd);
      document.body.style.cursor = 'grabbing';
      
      return () => {
        document.removeEventListener('mousemove', handleDrag);
        document.removeEventListener('mouseup', handleDragEnd);
        document.body.style.cursor = 'default';
      };
    }
  }, [isDragging, handleDrag]);

  const impactContent = (
    <DynamicGradientText variant="h2" sx={{ 
      fontWeight: 'bold',
      fontSize: impactDisplayPosition === 'config-matrix' ? '3.5rem' : '2.5rem',
      my: impactDisplayPosition === 'config-matrix' ? 2 : 1,
      textAlign: 'center',
      display: 'block'
    }}>
      {`${getCurrencySymbol(selectedCurrency)}`}<AnimatedCounter 
        value={totalImpact} 
        duration={2000} 
        formattingFn={(val) => 
          Number(val).toLocaleString('en-US', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
          })
        }
      />
    </DynamicGradientText>
  );

  // Floating docked version
  if (impactDisplayPosition === 'floating') {
    return (
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        style={{
          position: 'fixed',
          left: floatingPosition.x,
          top: floatingPosition.y,
          zIndex: 1000,
          cursor: isDragging ? 'grabbing' : 'grab'
        }}
        onMouseDown={handleDragStart}
      >
        <Paper
          elevation={8}
          sx={{
            p: 2,
            background: `linear-gradient(135deg, ${theme.palette.primary.main}20, ${theme.palette.secondary.main}20)`,
            backdropFilter: 'blur(10px)',
            border: `2px solid ${theme.palette.primary.main}30`,
            borderRadius: 3,
            minWidth: 200,
            textAlign: 'center',
            '&:hover': {
              boxShadow: theme.shadows[16],
              border: `2px solid ${theme.palette.primary.main}50`,
            }
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
            <Typography variant="caption" color="text.secondary">
              Total Impact
            </Typography>
            <Box sx={{ display: 'flex', gap: 0.5 }}>
              <Tooltip title="Dock to config">
                <IconButton 
                  size="small"
                  onClick={() => setImpactDisplayPosition('config-matrix')}
                  sx={{ fontSize: '0.8rem' }}
                >
                  <CheckCircle fontSize="inherit" />
                </IconButton>
              </Tooltip>
              <Tooltip title="Close">
                <IconButton 
                  size="small"
                  onClick={() => setImpactDisplayPosition('docked')}
                  sx={{ fontSize: '0.8rem' }}
                >
                  <Close fontSize="inherit" />
                </IconButton>
              </Tooltip>
            </Box>
          </Box>
          {impactContent}
          <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
            Drag to move • Click icons to dock/close
          </Typography>
        </Paper>
      </motion.div>
    );
  }

  // Docked (hidden) version - shows a small button to restore
  if (impactDisplayPosition === 'docked') {
    return (
      <Tooltip title="Show Total Impact">
        <IconButton
          sx={{
            position: 'fixed',
            top: 100,
            right: 20,
            zIndex: 1000,
            background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
            color: 'white',
            '&:hover': {
              transform: 'scale(1.1)',
              background: `linear-gradient(135deg, ${theme.palette.primary.dark}, ${theme.palette.secondary.dark})`,
            }
          }}
          onClick={() => setImpactDisplayPosition('floating')}
        >
          <TrendingUp />
        </IconButton>
      </Tooltip>
    );
  }

  // Default position in config matrix
  return impactContent;
};

// Update handleSaveScenario to use context

  const handleSaveScenario = async (name, description) => {
    if (!user) {
      navigate('/login');
      return;
    }

    try {
      const scenarioData = {
        name,
        description,
        values: sliderValues,
        parameters,
        industry,
        tier,
        persona,
        turnover,
        projectionYear,
        totalImpact,
		currency: selectedCurrency,
        userId: user._id,
		userEmail: user.email
      };

      // The ScenarioContext will handle the save and update the scenarios list
      await saveScenario(scenarioData);
      
      enqueueSnackbar('Scenario saved successfully!', { variant: 'success' });
      return true;
    } catch (error) {
      enqueueSnackbar(error.message || 'Failed to save scenario', { 
        variant: 'error',
        autoHideDuration: 3000
      });
      return false;
    }
  };


  const handleParameterChange = (factorKey, paramKey, value) => {
    setParameters(prev => ({
      ...prev,
      [paramKey]: {
        ...prev[paramKey],
        [factorKey]: value
      }
    }));
  };
//*****************************************************************************



// In ROIAnalyzer.js, use these same utility functions
const getCreditColor = (credits, isBackground = false) => {
  if (credits > 10) return isBackground ? '#4caf50' : '#4caf50'; // Green
  if (credits === 3) return isBackground ? '#ff9800' : '#ff9800'; // Orange
  if (credits === 2) return isBackground ? '#f44336' : '#f44336'; // Red
  if (credits === 1) return isBackground ? '#f44336' : '#f44336'; // Red
  return isBackground ? '#bdbdbd' : '#9e9e9e'; // Grey
};

const getCreditTextColor = (credits) => {
  const creditValue = credits || 0;
  
  if (creditValue === 0) return "error.main";
  if (creditValue === 1) return "warning.main";
  if (creditValue <= 5) return "info.main";
  return "success.main";
};

const getCreditAnimation = (credits) => {
  if (credits === 2) {
    return {
      animation: 'pulse 2s infinite, glow 1.5s infinite',
      '@keyframes pulse': {
        '0%': { opacity: 0.8 },
        '50%': { opacity: 1 },
        '100%': { opacity: 0.8 }
      },
      '@keyframes glow': {
        '0%': { boxShadow: '0 0 5px rgba(244, 67, 54, 0.5)' },
        '50%': { boxShadow: '0 0 20px rgba(244, 67, 54, 0.8)' },
        '100%': { boxShadow: '0 0 5px rgba(244, 67, 54, 0.5)' }
      }
    };
  }
  if (credits === 1) {
    return {
      animation: 'blink 0.5s infinite',
      '@keyframes blink': {
        '0%': { opacity: 0.3 },
        '50%': { opacity: 1 },
        '100%': { opacity: 0.3 }
      }
    };
  }
  return {};
};


//***********************************************************************

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Container maxWidth="xl" sx={{ py: 9 }}>
      {/* Futuristic Header */}

<HolographicCard sx={{ mb: 4 }}>
  <Box sx={{
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    p: 3
  }}>
    <DynamicGradientText variant="h4" sx={{ fontWeight: 'bold' }}>
      <TrendingUp sx={{ verticalAlign: 'middle', mr: 1 }} />
      PLM ROI Quantum Analyzer
    </DynamicGradientText>
    
    {user && (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Tooltip 
          title={
            <>
              <Typography variant="body2">{user.email}</Typography>
              <Typography variant="body2">
                {user.credits || 0} analysis credit{(user.credits || 0) !== 1 ? 's' : ''} available
              </Typography>
            </>
          }
          arrow
        >
<Chip
  icon={<CreditScore />}
  label={`${user.credits || 0} ${(user.credits || 0) === 1 ? "Credit" : "Credits"}`}
  color={getCreditColor(user.credits || 0)}
  sx={{ 
    '& .MuiChip-icon': { 
      color: getCreditColor(user.credits || 0)
    }
  }}
/>

        </Tooltip>

        <IconButton
          onClick={(e) => setAnchorEl(e.currentTarget)}
          sx={{
            border: '1px solid',
            borderColor: 'divider',
            '&:hover': { 
              backgroundColor: 'primary.light',
              boxShadow: `0 0 10px ${theme.palette.primary.light}`
            }
          }}
        >
          <Avatar 
            src={user.avatar} 
            sx={{ 
              width: 36, 
              height: 36,
              bgcolor: getCreditColor(user?.credits, true)
            }}
          >
            {user.name?.charAt(0) || user.email?.charAt(0).toUpperCase()}
          </Avatar>
        </IconButton>

        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          <MenuItem dense>
            <ListItemAvatar>
              <Avatar 
                src={user.avatar} 
                sx={{
                  bgcolor: getCreditColor(user?.credits, true)
                }}
              >
                {user.name?.charAt(0) || user.email?.charAt(0).toUpperCase()}
              </Avatar>
            </ListItemAvatar>
            <ListItemText 
              primary={user.name || user.email} 
              secondary={
                <>
                  <Typography component="span" display="block">
                    {user.email}
                  </Typography>
                  <Typography component="span" variant="body2" color={getCreditTextColor(user?.credits)}>
                    {user?.credits || 0} credit{(user?.credits || 0) !== 1 ? 's' : ''} available
                  </Typography>
                </>
              } 
            />
          </MenuItem>
        </Menu>
      </Box>
    )}
  </Box>
</HolographicCard>

      {/* Navigation Tabs */}
      <Box sx={{ mb: 4 }}>
        <Grid container spacing={1}>
          {[
            { id: 'analyze', label: 'Quantum Analysis', icon: <Insights /> },
            { id: 'scenarios', label: 'Scenario Vault', icon: <BarChart /> },
            { id: 'credits', label: 'Energy Credits', icon: <Paid /> },
            { id: 'insights', label: 'AI Insights', icon: <Lightbulb /> }
          ].map((tab) => (
            <Grid item key={tab.id}>
              <GlowingButton
                variant={activeTab === tab.id ? 'contained' : 'outlined'}
                color="primary"
                startIcon={tab.icon}
                onClick={() => handleTabChange(tab.id)}
                sx={{
                  minWidth: isMobile ? 'auto' : 180,
                  borderRadius: '12px'
                }}
              >
                {!isMobile && tab.label}
              </GlowingButton>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* Main Content Area */}
      <AnimatePresence mode="wait">
        {activeTab === 'analyze' && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            {/* Analysis Configuration */}
<HolographicCard sx={{ mb: 4 }}>
  <CardContent>
    {/* Add this section to show the loaded scenario name */}
    {scenarioName && scenarioName !== 'Unnamed Scenario' && (
      <Box sx={{ 
        mb: 2, 
        p: 1.5, 
        bgcolor: 'success.light', 
        borderRadius: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}>
        <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
          📋 Currently analyzing: <strong>{scenarioName}</strong>
        </Typography>
        <IconButton 
          size="small" 
          onClick={() => setScenarioName('Unnamed Scenario')}
          title="Clear scenario name"
        >
          <Close fontSize="small" />
        </IconButton>
      </Box>
    )}

    <Box sx={{ 
      display: 'flex', 
      justifyContent: 'space-between',
      alignItems: 'center',
      mb: 3
    }}>
      <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
        <Tune sx={{ mr: 1, verticalAlign: 'middle' }} />
        Quantum Configuration Matrix
      </Typography>
      <Chip 
        label={`v${parameters.modelVersion}`}
        color="info"
        size="small"
      />
    </Box>

    {/* Use isMobile directly here */}
    <Grid container spacing={isMobile ? 2 : 3}>
      <Grid item xs={12} md={3}>
        <FormControl fullWidth>
          <InputLabel>Industry Sector</InputLabel>
          <Select
            value={industry}
            onChange={(e) => setIndustry(e.target.value)}
            label="Industry Sector"
          >
            <MenuItem value="automotive">
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <LocalShipping /> Automotive
              </Box>
            </MenuItem>
            <MenuItem value="aerospace">
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <RocketLaunch /> Aerospace
              </Box>
            </MenuItem>
            <MenuItem value="electronics">
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Science /> Electronics
              </Box>
            </MenuItem>
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={12} md={2}>
        <FormControl fullWidth>
          <InputLabel>Value Chain Tier</InputLabel>
          <Select
            value={tier}
            onChange={(e) => setTier(e.target.value)}
            label="Value Chain Tier"
          >
            <MenuItem value="OEM">OEM</MenuItem>
            <MenuItem value="T1">Tier 1</MenuItem>
            <MenuItem value="T2">Tier 2</MenuItem>
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={12} md={2}>
        <FormControl fullWidth>
          <InputLabel>Analysis Perspective</InputLabel>
          <Select
            value={persona}
            onChange={(e) => setPersona(e.target.value)}
            label="Analysis Perspective"
          >
            <MenuItem value="CFO">Financial</MenuItem>
            <MenuItem value="CTO">Technical</MenuItem>
            <MenuItem value="COO">Operational</MenuItem>
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={12} md={2}>
        <FormControl fullWidth>
          <InputLabel>Time Horizon</InputLabel>
          <Select
            value={projectionYear}
            onChange={(e) => setProjectionYear(e.target.value)}
            label="Time Horizon"
          >
            {[1, 3, 5].map((year) => (
              <MenuItem key={year} value={year}>
                {year} Year{year > 1 ? 's' : ''}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      
      <Grid item xs={12} md={2}>
        <FormControl fullWidth>
          <InputLabel>Currency</InputLabel>
          <Select
            value={selectedCurrency}
            onChange={(e) => setSelectedCurrency(e.target.value)}
            label="Currency"
            renderValue={(selected) => {
              const selectedCurrencyObj = currencies.find(c => c.code === selected);
              return selectedCurrencyObj ? `${selectedCurrencyObj.code} (${selectedCurrencyObj.symbol})` : selected;
            }}
          >
            {currencies.map((currency) => (
              <MenuItem key={currency.code} value={currency.code}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <CurrencyExchangeIcon fontSize="small" />
                  <Box>
                    <Typography variant="body2">{currency.code}</Typography>
                    <Typography variant="caption" color="text.secondary">
                      {currency.name} ({currency.symbol})
                    </Typography>
                  </Box>
                </Box>
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={12} md={3}>
        <TextField
          fullWidth
          label="Annual Revenue"
          type="number"
          value={turnover}
          onChange={(e) => setTurnover(Number(e.target.value))}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                {getCurrencySymbol(selectedCurrency)}
              </InputAdornment>
            ),
            sx: { fontSize: '0.875rem' }
          }}
        />
      </Grid>

      {/* DOCKABLE IMPACT DISPLAY - Positioned after Annual Revenue */}
<Grid item xs={12}>
  <Paper 
    sx={{ 
      p: isImpactExpanded ? 4 : 2,
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      color: 'white',
      position: 'relative',
      borderRadius: 3,
      border: '2px solid rgba(255,255,255,0.1)',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
        border: '2px solid rgba(255,255,255,0.2)'
      }
    }}
    onClick={() => setIsImpactExpanded(!isImpactExpanded)}
  >
    {/* Header Section */}
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: isImpactExpanded ? 3 : 1 }}>
      <Box sx={{ flex: 1 }}>
        <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
          <RocketLaunch sx={{ mr: 1 }} />
          Quantum Impact Potential
          <Chip 
            label={isImpactExpanded ? "EXPANDED" : "SHOW IMPACT"} 
            size="small" 
            sx={{ 
              ml: 1, 
              background: 'rgba(255,255,255,0.2)', 
              color: 'white',
              fontWeight: 'bold',
              fontSize: '0.7rem'
            }} 
          />
        </Typography>
        {isImpactExpanded && (
          <Typography variant="body2" sx={{ opacity: 0.9 }}>
            Real-time calculation based on current configuration
          </Typography>
        )}
      </Box>
      
      <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
        <Tooltip title={isImpactExpanded ? "Collapse" : "Expand for details"}>
          <IconButton 
            sx={{ 
              color: 'white',
              background: 'rgba(255,255,255,0.1)',
              '&:hover': { 
                background: 'rgba(255,255,255,0.2)',
                transform: 'scale(1.1)'
              }
            }}
            onClick={(e) => {
              e.stopPropagation();
              setIsImpactExpanded(!isImpactExpanded);
            }}
          >
            {isImpactExpanded ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        </Tooltip>
        
        <Tooltip title="Undock to floating window">
          <IconButton 
            sx={{ 
              color: 'white',
              background: 'rgba(255,255,255,0.1)',
              '&:hover': { 
                background: 'rgba(255,255,255,0.2)',
                transform: 'scale(1.1)'
              }
            }}
            onClick={(e) => {
              e.stopPropagation();
              setImpactDisplayPosition('floating');
            }}
          >
            <OpenInNew />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
    
    {/* 3D Embossed Impact Display */}
    <Box sx={{ 
      textAlign: 'center', 
      py: isImpactExpanded ? 3 : 1,
      position: 'relative'
    }}>
      {/* 3D Text Effect Container */}
      <Box sx={{
        position: 'relative',
        display: 'inline-block',
        perspective: '1000px',
        transformStyle: 'preserve-3d'
      }}>
        {/* Main 3D Text */}
        <DynamicGradientText variant="h2" sx={{ 
          fontWeight: 'bold',
          fontSize: isImpactExpanded ? '4rem' : '2.5rem',
          my: 2,
          textAlign: 'center',
          display: 'block',
          position: 'relative',
          textShadow: `
            /* Deep 3D Shadow Effect */
            0 1px 0 #ccc,
            0 2px 0 #c9c9c9,
            0 3px 0 #bbb,
            0 4px 0 #b9b9b9,
            0 5px 0 #aaa,
            0 6px 1px rgba(0,0,0,.1),
            0 0 5px rgba(0,0,0,.1),
            0 1px 3px rgba(0,0,0,.3),
            0 3px 5px rgba(0,0,0,.2),
            0 5px 10px rgba(0,0,0,.25),
            0 10px 10px rgba(0,0,0,.2),
            0 20px 20px rgba(0,0,0,.15)
          `,
          transform: 'translateZ(20px)',
          transition: 'all 0.3s ease',
          '&:hover': {
            transform: 'translateZ(30px) scale(1.05)',
            textShadow: `
              0 1px 0 #ccc,
              0 2px 0 #c9c9c9,
              0 3px 0 #bbb,
              0 4px 0 #b9b9b9,
              0 5px 0 #aaa,
              0 6px 1px rgba(0,0,0,.1),
              0 0 5px rgba(0,0,0,.1),
              0 1px 3px rgba(0,0,0,.3),
              0 3px 5px rgba(0,0,0,.2),
              0 5px 10px rgba(0,0,0,.25),
              0 10px 10px rgba(0,0,0,.2),
              0 20px 20px rgba(0,0,0,.15),
              0 0 20px rgba(255,255,255,0.3)
            `
          }
        }}>
          {`${getCurrencySymbol(selectedCurrency)}`}
          <AnimatedCounter 
            value={totalImpact} 
            duration={2000} 
            formattingFn={(val) => 
              Number(val).toLocaleString('en-US', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
              })
            }
          />
        </DynamicGradientText>
        
        {/* Glow Effect */}
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '100%',
          height: '100%',
          background: 'radial-gradient(circle, rgba(255,255,255,0.3) 0%, transparent 70%)',
          filter: 'blur(15px)',
          opacity: 0.7,
          zIndex: -1,
          animation: 'pulseGlow 2s ease-in-out infinite alternate'
        }} />
      </Box>
      
      {/* Impact Label with 3D Effect */}
      <Typography variant="h6" sx={{
        fontWeight: 'bold',
        mt: 1,
        textShadow: `
          0 1px 0 rgba(255,255,255,0.3),
          0 2px 2px rgba(0,0,0,0.2),
          0 4px 4px rgba(0,0,0,0.1)
        `,
        opacity: 0.9,
        letterSpacing: '1px'
      }}>
        TOTAL QUANTUM IMPACT
      </Typography>
    </Box>
    
    {/* Expanded Details Section */}
    <Collapse in={isImpactExpanded} timeout="auto">
      <Box sx={{ 
        mt: 3, 
        pt: 3, 
        borderTop: '1px solid rgba(255,255,255,0.1)',
        animation: 'fadeInUp 0.5s ease-out'
      }}>
        {/* Impact Breakdown */}
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Typography variant="h6" gutterBottom sx={{ 
              display: 'flex', 
              alignItems: 'center',
              textShadow: '0 2px 4px rgba(0,0,0,0.2)'
            }}>
              <Insights sx={{ mr: 1 }} />
              Impact Breakdown
            </Typography>
            
            <Box sx={{ 
              background: 'rgba(255,255,255,0.1)', 
              borderRadius: 2, 
              p: 2,
              backdropFilter: 'blur(10px)'
            }}>
              {nonZeroCategories.map((category, index) => (
                <Box key={category.name} sx={{ 
                  display: 'flex', 
                  justifyContent: 'space-between', 
                  alignItems: 'center',
                  mb: 1,
                  p: 1,
                  borderRadius: 1,
                  background: 'rgba(255,255,255,0.05)',
                  '&:hover': {
                    background: 'rgba(255,255,255,0.1)'
                  }
                }}>
                  <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center' }}>
                    <Box 
                      sx={{ 
                        width: 12, 
                        height: 12, 
                        borderRadius: '50%', 
                        background: `hsl(${index * 60}, 70%, 60%)`,
                        mr: 1
                      }} 
                    />
                    {category.name}
                  </Typography>
                  <Typography variant="body2" fontWeight="bold">
                    {getCurrencySymbol(selectedCurrency)}{Math.round(categoryTotals[category.name] || 0).toLocaleString()}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Grid>
          
          <Grid item xs={12} md={6}>
            <Typography variant="h6" gutterBottom sx={{ 
              display: 'flex', 
              alignItems: 'center',
              textShadow: '0 2px 4px rgba(0,0,0,0.2)'
            }}>
              <Analytics sx={{ mr: 1 }} />
              Performance Metrics
            </Typography>
            
            <Box sx={{ 
              background: 'rgba(255,255,255,0.1)', 
              borderRadius: 2, 
              p: 2,
              backdropFilter: 'blur(10px)'
            }}>
              {/* Additional impact metrics */}
              <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap', justifyContent: 'space-around' }}>
                <Box sx={{ textAlign: 'center', minWidth: 80 }}>
                  <Typography variant="h4" fontWeight="bold" sx={{
                    textShadow: '0 2px 8px rgba(0,0,0,0.3)',
                    background: 'linear-gradient(45deg, #FFD700, #FFA500)',
                    backgroundClip: 'text',
                    WebkitBackgroundClip: 'text',
                    color: 'transparent'
                  }}>
                    {nonZeroCategories.length}
                  </Typography>
                  <Typography variant="caption" sx={{ opacity: 0.8, display: 'block' }}>
                    Active Categories
                  </Typography>
                </Box>
                <Box sx={{ textAlign: 'center', minWidth: 80 }}>
                  <Typography variant="h4" fontWeight="bold" sx={{
                    textShadow: '0 2px 8px rgba(0,0,0,0.3)',
                    background: 'linear-gradient(45deg, #00FF87, #00D4FF)',
                    backgroundClip: 'text',
                    WebkitBackgroundClip: 'text',
                    color: 'transparent'
                  }}>
                    {Object.values(sliderValues).filter(v => v && v.target > v.current).length}
                  </Typography>
                  <Typography variant="caption" sx={{ opacity: 0.8, display: 'block' }}>
                    Improving Factors
                  </Typography>
                </Box>
                <Box sx={{ textAlign: 'center', minWidth: 80 }}>
                  <Typography variant="h4" fontWeight="bold" sx={{
                    textShadow: '0 2px 8px rgba(0,0,0,0.3)',
                    background: 'linear-gradient(45deg, #FF6B6B, #FF8E53)',
                    backgroundClip: 'text',
                    WebkitBackgroundClip: 'text',
                    color: 'transparent'
                  }}>
                    {Math.round((totalImpact / turnover) * 100)}%
                  </Typography>
                  <Typography variant="caption" sx={{ opacity: 0.8, display: 'block' }}>
                    of Revenue
                  </Typography>
                </Box>
              </Box>
              
              {/* ROI Indicator */}
              <Box sx={{ mt: 2, p: 2, background: 'rgba(255,255,255,0.05)', borderRadius: 2 }}>
                <Typography variant="body2" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
                  <TrendingUp sx={{ mr: 1, fontSize: '1rem' }} />
                  Estimated ROI: <strong sx={{ ml: 1 }}>{Math.round((totalImpact / (turnover * 0.05)) * 100)}%</strong>
                </Typography>
                <LinearProgress 
                  variant="determinate" 
                  value={Math.min(100, (totalImpact / (turnover * 0.05)) * 10)}
                  sx={{ 
                    height: 8, 
                    borderRadius: 4,
                    background: 'rgba(255,255,255,0.1)',
                    '& .MuiLinearProgress-bar': {
                      background: 'linear-gradient(45deg, #00FF87, #00D4FF)',
                      borderRadius: 4
                    }
                  }}
                />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Collapse>
  </Paper>
</Grid>
    </Grid>
  </CardContent>
</HolographicCard>

{/* Floating Impact Display Component */}
{impactDisplayPosition === 'floating' && (
  <motion.div
    initial={{ opacity: 0, scale: 0.8 }}
    animate={{ opacity: 1, scale: 1 }}
    style={{
      position: 'fixed',
      left: floatingPosition.x,
      top: floatingPosition.y,
      zIndex: 1000,
      cursor: isDragging ? 'grabbing' : 'grab'
    }}
    onMouseDown={(e) => {
      if (impactDisplayPosition === 'floating') {
        setIsDragging(true);
        const rect = e.currentTarget.getBoundingClientRect();
        dragOffset.current = {
          x: e.clientX - rect.left,
          y: e.clientY - rect.top
        };
        e.currentTarget.style.cursor = 'grabbing';
      }
    }}
  >
    <Paper
      elevation={8}
      sx={{
        p: 2,
        background: `linear-gradient(135deg, ${theme.palette.primary.main}20, ${theme.palette.secondary.main}20)`,
        backdropFilter: 'blur(10px)',
        border: `2px solid ${theme.palette.primary.main}30`,
        borderRadius: 3,
        minWidth: 200,
        textAlign: 'center',
        '&:hover': {
          boxShadow: theme.shadows[16],
          border: `2px solid ${theme.palette.primary.main}50`,
        }
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
        <Typography variant="caption" color="text.secondary" fontWeight="bold">
          Total Impact
        </Typography>
        <Box sx={{ display: 'flex', gap: 0.5 }}>
          <Tooltip title="Dock to config">
            <IconButton 
              size="small"
              onClick={() => setImpactDisplayPosition('config-matrix')}
              sx={{ fontSize: '0.8rem' }}
            >
              <CheckCircle fontSize="inherit" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Close">
            <IconButton 
              size="small"
              onClick={() => setImpactDisplayPosition('docked')}
              sx={{ fontSize: '0.8rem' }}
            >
              <Close fontSize="inherit" />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>
      
      <DynamicGradientText variant="h4" sx={{ 
        fontWeight: 'bold',
        my: 1,
        textAlign: 'center',
        display: 'block'
      }}>
        {`${getCurrencySymbol(selectedCurrency)}`}<AnimatedCounter 
          value={totalImpact} 
          duration={2000} 
          formattingFn={(val) => 
            Number(val).toLocaleString('en-US', {
              minimumFractionDigits: 0,
              maximumFractionDigits: 0
            })
          }
        />
      </DynamicGradientText>
      
      <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
        Drag to move • Click icons to dock/close
      </Typography>
    </Paper>
  </motion.div>
)}

{/* Hidden docked button */}
{impactDisplayPosition === 'docked' && (
  <Tooltip title="Show Total Impact">
    <IconButton
      sx={{
        position: 'fixed',
        top: 100,
        right: 20,
        zIndex: 1000,
        background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
        color: 'white',
        '&:hover': {
          transform: 'scale(1.1)',
          background: `linear-gradient(135deg, ${theme.palette.primary.dark}, ${theme.palette.secondary.dark})`,
        }
      }}
      onClick={() => setImpactDisplayPosition('floating')}
    >
      <TrendingUp />
    </IconButton>
  </Tooltip>
)}


            {/* Impact Factors */}
            {categories.map((category) => (
              <AnimatedCard
                key={category.name}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
                sx={{ mb: 3 }}
              >
                <Accordion 
                  expanded={expandedCategory === category.name}
                  onChange={(_, isExpanded) => 
                    setExpandedCategory(isExpanded ? category.name : null)
                  }
                  sx={{
                    background: 'rgba(255, 255, 255, 0.05)',
                    backdropFilter: 'blur(10px)',
                    borderRadius: '12px !important'
                  }}
                >
                  <AccordionSummary expandIcon={<ExpandMore />}>
                    <Box sx={{ 
                      display: 'flex', 
                      alignItems: 'center',
                      width: '100%'
                    }}>
                      <Box sx={{ mr: 2 }}>
                        {category.icon}
                      </Box>
                      <Typography variant="h6" sx={{ flexGrow: 1 }}>
                        {category.name}
                      </Typography>
                      <Typography color="text.secondary">
                        <AnimatedCounter
                          value={categoryTotals[category.name]}
                          duration={1000}
                          prefix={getCurrencySymbol(selectedCurrency)}
                          suffix=" impact"
                        />
                      </Typography>
                    </Box>
                  </AccordionSummary>

                  <AccordionDetails>
				  
{category.factors.map((factor) => {
  const factorKey = factor.key;
  const factorData = sliderValues[factorKey]; // This should be {current: X, target: Y}
  
  console.log(`🔄 Rendering FactorSlider for ${factorKey}:`, factorData);
  
  return (
    <Box key={factorKey}>
<FactorSlider
  factor={factor}
  factorData={sliderValues[factor.key]}
  onSliderChange={(newValues) => handleSliderChange(factor.key, newValues)}
  activeFactor={activeFactor}
  setActiveFactor={setActiveFactor}
  getFactorImpact={getFactorImpact}
  sliderLabels={sliderLabels}
  theme={theme}
  factorTooltips={factorTooltips}
  currency={selectedCurrency}
  industry={industry}
/>
    </Box>
  );
})}



                  </AccordionDetails>
                </Accordion>
              </AnimatedCard>
            ))}

            {/* Action Panel */}
            <Box sx={{ 
              display: 'flex', 
              justifyContent: 'center', 
              gap: 3, 
              mt: 4,
              flexWrap: 'wrap'
            }}>
              <GlowingButton
                variant="contained"
                color="primary"
                size="large"
                startIcon={isPlaying ? <Pause /> : <PlayCircle />}
                onClick={isPlaying ? () => setIsPlaying(false) : runAnalysis}
                disabled={isPlaying && progress < 100}
                sx={{ minWidth: 200 }}
              >
                {isPlaying ? 'Pause Quantum Analysis' : 'Run Quantum Analysis'}
              </GlowingButton>


<Button
  variant="outlined"
  color="primary"
  size="large"
  startIcon={<Replay />}
  onClick={() => setResetDialogOpen(true)}
  sx={{ minWidth: 150 }}
>
  Reset
</Button>


              <Tooltip 
                title={!user ? "Sign in to save scenarios" : 
                  user?.credits <= 0 ? "Purchase more energy credits" : ""}
              >
                <span>
                  <GlowingButton
                    variant="contained"
                    color="success"
                    size="large"
                    startIcon={<CheckCircle />}
                    onClick={() => setSaveDialogOpen(true)}
                    disabled={!user || user?.credits <= 0}
                    sx={{ minWidth: 220 }}
                  >
                    Save Quantum Scenario (1 Credit)
                  </GlowingButton>
                </span>
              </Tooltip>
            </Box>

            {/* Scenario Name Input */}
            {user && (
              <Fade in={progress > 0 || Object.keys(sliderValues).length > 0}>
                <Box sx={{ 
                  mt: 3, 
                  display: 'flex', 
                  justifyContent: 'center',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: 2
                }}>
                  <Typography variant="caption" color="text.secondary">
                    Give your scenario a meaningful name for future reference
                  </Typography>
                </Box>
              </Fade>
            )}

            {/* Analysis Progress */}
            {isPlaying && (
              <Zoom in={isPlaying}>
                <Box sx={{ mt: 4 }}>
                  <Typography gutterBottom variant="body2" color="text.secondary">
                    Quantum analysis in progress...
                  </Typography>
                  <LinearProgress 
                    variant="determinate" 
                    value={progress} 
                    sx={{ 
                      height: 10, 
                      borderRadius: 5,
                      background: 'rgba(255,255,255,0.1)',
                      '& .MuiLinearProgress-bar': {
                        background: 'linear-gradient(90deg, #1976d2, #4caf50)',
                        borderRadius: 5
                      }
                    }} 
                  />
                </Box>
              </Zoom>
            )}

            {/* Results Display */}
            {!isPlaying && progress === 100 && (
              <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5 }}
              >
                <HolographicCard sx={{ mt: 4 }}>
                  <CardContent>
                    <Box sx={{ 
                      display: 'flex', 
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      mb: 3
                    }}>
                      <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
                        <Insights sx={{ verticalAlign: 'middle', mr: 1 }} />
                        Quantum Analysis Results
                      </Typography>
                      <Chip 
                        label={`Year ${projectionYear} Projection`}
                        color="info"
                      />
                    </Box>

                    <Box sx={{ textAlign: 'center', py: 3 }}>
                      <Typography variant="h6" color="text.secondary">
                        Potential Annual ROI Impact
                      </Typography>
                      <DynamicGradientText variant="h2" sx={{ 
                        fontWeight: 'bold',
                        fontSize: '3.5rem',
                        my: 2
                      }}>
                        {` ${getCurrencySymbol(selectedCurrency)}`}<AnimatedCounter 
                          value={totalImpact} 
                          duration={2000} 
                          formattingFn={(val) => 
                            Number(val).toLocaleString('en-US', {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0
                            })
                          }
                        />
                      </DynamicGradientText>
                      <Typography paragraph sx={{ maxWidth: 600, mx: 'auto' }}>
                        Based on your configuration and industry benchmarks, this is the projected 
                        annual return on investment from implementing a PLM solution.
                      </Typography>
                    </Box>

                    <Box sx={{ 
                      display: 'flex', 
                      justifyContent: 'center',
                      gap: 2,
                      mt: 3,
                      flexWrap: 'wrap'
                    }}>
                      <Button 
                        variant="contained" 
                        startIcon={<Share />}
                        sx={{ borderRadius: '20px' }}
                      >
                        Share Results
                      </Button>
                      <Button 
                        variant="outlined" 
                        startIcon={<FileDownload />} 
                        onClick={handleExportPDF}
                        sx={{ borderRadius: '20px' }}
                      >
                        Export Full Report
                      </Button>
                    </Box>
                  </CardContent>
                </HolographicCard>
              </motion.div>
            )}
          </motion.div>
        )}
		
// RESET DIALOG

<StableResetDialog
  open={resetDialogOpen}
  onClose={() => setResetDialogOpen(false)}
  onConfirm={(resetValues) => {
    setSliderValues(Object.fromEntries(
      categories.flatMap(cat => 
        cat.factors.map(factor => [
          factor.key, 
          { current: resetValues.current, target: resetValues.target }
        ])
      )
    ));
    setProgress(0);
    enqueueSnackbar(`All sliders reset to Current: Level ${resetValues.current}, Target: Level ${resetValues.target}`, {
      variant: 'success',
      autoHideDuration: 3000
    });
  }}
/>



{/* Scenarios Tab */}

{activeTab === 'scenarios' && (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0 }}
    transition={{ duration: 0.3 }}
  >
    {comparisonMode ? (
      <ScenarioComparisonInterface 
        scenarios={selectedScenarios.map(id => savedScenarios.find(s => s._id === id))}
        viewMode={comparisonView}
        onBack={exitComparisonMode}
        onViewChange={setComparisonView}
      />
    ) : (
      <Box>
        {/* Enhanced Controls Header */}
        <Paper sx={{ p: 2, mb: 3 }}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                size="small"
                placeholder="Search scenarios..."
                value={scenarioSearchTerm}
                onChange={(e) => setScenarioSearchTerm(e.target.value)}
                InputProps={{
                  startAdornment: <Search sx={{ mr: 1, color: 'text.secondary' }} />
                }}
              />
            </Grid>
            
            <Grid item xs={12} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel>Filter by Industry</InputLabel>
                <Select 
                  value={scenarioFilter} 
                  onChange={(e) => setScenarioFilter(e.target.value)} 
                  label="Filter by Industry"
                >
                  <MenuItem value="all">All Industries</MenuItem>
                  <MenuItem value="automotive">Automotive</MenuItem>
                  <MenuItem value="aerospace">Aerospace</MenuItem>
                  <MenuItem value="electronics">Electronics</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            
            <Grid item xs={12} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel>Sort by</InputLabel>
                <Select value={sortBy} onChange={(e) => setSortBy(e.target.value)} label="Sort by">
                  <MenuItem value="newest">Newest First</MenuItem>
                  <MenuItem value="oldest">Oldest First</MenuItem>
                  <MenuItem value="impact">Highest Impact</MenuItem>
                  <MenuItem value="name">Name A-Z</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            
            <Grid item xs={12} md={2}>
              <Button
                fullWidth
                variant="contained"
                startIcon={<CompareArrows />}
                onClick={() => handleCompareScenarios('advanced')}
                disabled={selectedScenarios.length < 2}
                sx={{ whiteSpace: 'nowrap' }}
              >
                Compare ({selectedScenarios.length})
              </Button>
            </Grid>
          </Grid>
          
          {/* Selection Summary */}
          {selectedScenarios.length > 0 && (
            <Box sx={{ 
              mt: 2, 
              p: 1.5, 
              bgcolor: 'primary.light', 
              borderRadius: 1,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              <Typography variant="body2" color="white">
                <strong>{selectedScenarios.length}</strong> scenario(s) selected for comparison
              </Typography>
              <Button 
                size="small" 
                onClick={clearSelection}
                sx={{ color: 'white' }}
                startIcon={<Close />}
              >
                Clear selection
              </Button>
            </Box>
          )}
        </Paper>

        {/* Enhanced Scenarios Grid */}
        {loadingScenarios ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
            <CircularProgress />
          </Box>
        ) : sortedScenarios.length === 0 ? (
          <EmptyState onClick={() => setLocalActiveTab('analyze')} />
        ) : (
          <>
            <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>
              Showing {sortedScenarios.length} scenario{sortedScenarios.length !== 1 ? 's' : ''}
            </Typography>
            <Grid container spacing={3}>
              {sortedScenarios.map((scenario) => (
                <Grid item xs={12} sm={6} md={4} key={scenario._id}>
                  <EnhancedScenarioCard
                    scenario={scenario}
                    isSelected={selectedScenarios.includes(scenario._id)}
                    onSelect={toggleScenarioSelection}
                    onViewDetails={handleViewScenarioDetails}
                    onDelete={handleDeleteScenario}
                    selectionIndex={selectedScenarios.indexOf(scenario._id) + 1}
					currencySymbol={getCurrencySymbol(selectedCurrency)} 
                  />
                </Grid>
              ))}
            </Grid>
          </>
        )}
        
        {/* Floating Comparison Launcher */}
        <ComparisonLauncher />
      </Box>
    )}
  </motion.div>
)}



// In the credits tab section, replace the entire section with:

{activeTab === 'credits' && (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0 }}
    transition={{ duration: 0.3 }}
  >
    <Box sx={{ mb: 4 }}>
      <Typography variant="h5" gutterBottom>
        <Paid sx={{ verticalAlign: 'middle', mr: 1 }} />
        Energy Credits
      </Typography>
      <Typography color="text.secondary" paragraph>
        Purchase analysis credits to save scenarios and unlock advanced features
      </Typography>
      
      {/* Currency Selector */}
<Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
  <CurrencyExchangeIcon color="primary" />
  <FormControl size="small" sx={{ minWidth: 120 }}>
    <InputLabel>Currency</InputLabel>
    <Select
      value={selectedCurrency}
      onChange={(e) => setSelectedCurrency(e.target.value)}
      label="Currency"
      renderValue={(selected) => {
        const selectedCurrency = currencies.find(c => c.code === selected);
        return selectedCurrency ? `${selectedCurrency.code} (${selectedCurrency.symbol})` : selected;
      }}
    >
      {currencies.map((curr) => (  // ✅ Fixed naming conflict
        <MenuItem key={curr.code} value={curr.code}>
          <Tooltip title={curr.name} placement="right" arrow>
            <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
              <Typography variant="body2" sx={{ minWidth: 40 }}>
                {curr.symbol}
              </Typography>
              <Typography variant="body2" sx={{ flex: 1 }}>
                {curr.code}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {curr.name}
              </Typography>
            </Box>
          </Tooltip>
        </MenuItem>
      ))}
    </Select>
  </FormControl>
  {isLoadingRates && <CircularProgress size={20} sx={{ ml: 1 }} />}
  <Typography variant="caption" color="text.secondary" sx={{ ml: 1 }}>
    Base currency: {BASE_CURRENCY} ({BASE_CURRENCY_SYMBOL})
  </Typography>
</Box>
    </Box>

    {!user ? (
      <Box sx={{ 
        textAlign: 'center', 
        p: 4,
        border: '1px dashed',
        borderColor: 'divider',
        borderRadius: 2
      }}>
        <Typography variant="h6" color="text.secondary" gutterBottom>
          Sign in to purchase credits
        </Typography>
        <Typography color="text.secondary" sx={{ mb: 3 }}>
          You need to be signed in to your quantum account to purchase energy credits
        </Typography>
        <Button
          variant="contained"
          onClick={() => navigate('/login')}
        >
          Sign In Now
        </Button>
      </Box>
    ) : (
      <>
<HolographicCard sx={{ mb: 4 }}>
  <CardContent sx={{ textAlign: 'center' }}>
    <Typography variant="h6" gutterBottom>
      Current Balance
    </Typography>
         <Box sx={{ mt: 3, p: 2, bgcolor: 'background.default', borderRadius: 2 }}>
           <Typography variant="h6" color="blue">
            Available credits: <strong color="red" variant="h9">{credits}</strong>
          </Typography>
          <Typography variant="body2" color="black" sx={{ mt: 1 }}>
            Each scenario analysis or paid actions consume minimum 1 credit in this web application.
          </Typography>
        </Box>
  </CardContent>
</HolographicCard>

        {/* Replace the old package grid with the new PackageSelector */}
<PackageSelector 
  onPackageSelect={handlePackageSelect}
  creditPackages={CREDIT_PACKAGES}
  selectedCurrency={selectedCurrency}  // ✅ CHANGE: currency → selectedCurrency
  currencySymbol={currencySymbol}  // ✅ CHANGE: Get symbol from hook
  convertPrice={convertPrice}  // ✅ Use convertPrice from hook
/>


        {/* Additional info section */}
        <Box sx={{ 
          mt: 4,
          p: 3,
          borderRadius: 2,
          bgcolor: 'background.paper',
          border: '1px solid',
          borderColor: 'divider'
        }}>
          <Typography variant="h6" gutterBottom>
            <Help sx={{ verticalAlign: 'middle', mr: 1 }} />
            How Energy Credits Work
          </Typography>
          <List dense>
            <ListItem>
              <ListItemIcon><CheckCircle color="primary" /></ListItemIcon>
              <ListItemText primary="1 credit = 1 paid action like - save scenario" />
            </ListItem>
            <ListItem>
              <ListItemIcon><CheckCircle color="primary" /></ListItemIcon>
              <ListItemText primary="Credits expire according to validity of purchased package by user" />
            </ListItem>
            <ListItem>
              <ListItemIcon><CheckCircle color="primary" /></ListItemIcon>
              <ListItemText primary="Bulk discounts available" />
            </ListItem>
            <ListItem>
              <ListItemIcon><CheckCircle color="primary" /></ListItemIcon>
              <ListItemText primary="Free credits for active users" />
            </ListItem>
            <ListItem>
              <ListItemIcon><CurrencyExchangeIcon color="primary" /></ListItemIcon>
              <ListItemText 
                primary="Multiple currencies supported" 
                secondary="Prices rounded up to market standards" 
              />
            </ListItem>
          </List>
        </Box>
      </>
    )}
  </motion.div>
)}



        {/* Insights Tab */}
        {activeTab === 'insights' && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <Box sx={{ mb: 4 }}>
              <Typography variant="h5" gutterBottom>
                <Lightbulb sx={{ verticalAlign: 'middle', mr: 1 }} />
                Quantum AI Insights
              </Typography>
              <Typography color="text.secondary" paragraph>
                Intelligent recommendations based on your analysis history
              </Typography>
            </Box>

            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <HolographicCard>
                  <CardContent>
                    <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                      <TrendingUp sx={{ verticalAlign: 'middle', mr: 1 }} />
                      Optimization Potential
                    </Typography>
                    <Typography paragraph>
                      Based on similar companies in the {industry} sector, you could increase your ROI by up to 27% by:
                    </Typography>
                    <List dense>
                      <ListItem>
                        <ListItemIcon><CheckCircle color="success" /></ListItemIcon>
                        <ListItemText primary="Improving supplier collaboration" />
                      </ListItem>
                      <ListItem>
                        <ListItemIcon><CheckCircle color="success" /></ListItemIcon>
                        <ListItemText primary="Reducing engineering change cycles" />
                      </ListItem>
                      <ListItem>
                        <ListItemIcon><CheckCircle color="success" /></ListItemIcon>
                        <ListItemText primary="Implementing digital twin technology" />
                      </ListItem>
                    </List>
                    <Button 
                      variant="outlined" 
                      sx={{ mt: 2 }}
                      onClick={() => {
                        setSliderValues(prev => ({
                          ...prev,
                          supplier_collab: { current: prev.supplier_collab?.current || 0, target: 8 },
                          change_cycles: { current: prev.change_cycles?.current || 0, target: 7 }
                        }));
                        handleTabChange('analyze');
                      }}
                    >
                      Apply Recommendations
                    </Button>
                  </CardContent>
                </HolographicCard>
              </Grid>

              <Grid item xs={12} md={6}>
                <HolographicCard>
                  <CardContent>
                    <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                      <Functions sx={{ verticalAlign: 'middle', mr: 1 }} />
                      Benchmark Comparison
                    </Typography>
                    <Typography paragraph>
                      Your current configuration ranks in the top 35% of {tier} companies in {industry}:
                    </Typography>
                    <Box sx={{ 
                      height: 120,
                      background: 'linear-gradient(90deg, #1976d2, #4caf50)',
                      borderRadius: 2,
                      position: 'relative',
                      mb: 2
                    }}>
                      <Box sx={{
                        position: 'absolute',
                        left: '35%',
                        top: -20,
                        width: 40,
                        height: 40,
                        borderRadius: '50%',
                        bgcolor: 'white',
                        border: '3px solid',
                        borderColor: 'primary.main',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontWeight: 'bold',
                        color: 'primary.main'
                      }}>
                        You
                      </Box>
                    </Box>
                    <Typography variant="caption" color="text.secondary">
                      Compared to 127 similar companies in our database
                    </Typography>
                  </CardContent>
                </HolographicCard>
              </Grid>

              <Grid item xs={12}>
                <HolographicCard>
                  <CardContent>
                    <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                      <BarChart sx={{ verticalAlign: 'middle', mr: 1 }} />
                      Scenario Trends
                    </Typography>
                    <Typography paragraph>
                      Your saved scenarios show these common optimization patterns:
                    </Typography>
                    {savedScenarios.length > 0 ? (
                      <List dense>
                        <ListItem>
                          <ListItemIcon><CheckCircle color="info" /></ListItemIcon>
                          <ListItemText primary="83% focus on reducing time-to-market" />
                        </ListItem>
                        <ListItem>
                          <ListItemIcon><CheckCircle color="info" /></ListItemIcon>
                          <ListItemText primary="67% prioritize quality improvements" />
                        </ListItem>
                        <ListItem>
                          <ListItemIcon><CheckCircle color="info" /></ListItemIcon>
                          <ListItemText primary="42% explore digital transformation" />
                        </ListItem>
                      </List>
                    ) : (
                      <Typography color="text.secondary" sx={{ fontStyle: 'italic' }}>
                        Save more scenarios to unlock personalized trends
                      </Typography>
                    )}
                  </CardContent>
                </HolographicCard>
              </Grid>
            </Grid>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Scenario Save Dialog */}
      <ScenarioSaveDialog
        open={saveDialogOpen}
        onClose={() => setSaveDialogOpen(false)}
        onSave={handleSaveScenario}
        analysisData={{
          values: sliderValues,
          industry,
          tier,
          persona,
          turnover,
          projectionYear,
          totalImpact
        }}
        currentName={scenarioName}
      />

      {/* Parameter Tuning Dialog */}
      <TuningDialog
        open={tuneDialogOpen}
        onClose={() => setTuneDialogOpen(false)}
        factorKey={activeTuningFactor}
        parameters={parameters}
        onChange={handleParameterChange}
        industry={industry}
        tier={tier}
      />

      {/* Snackbar Notifications */}
<Snackbar
  open={scenarioNotification.open}
  autoHideDuration={4000}
  onClose={handleCloseNotification}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert 
    onClose={handleCloseNotification} 
    severity="success"
    sx={{ width: '100%' }}
  >
    {scenarioNotification.message}
  </Alert>
</Snackbar>


<Snackbar
  open={scenarioNotification.open}
  autoHideDuration={4000}
  onClose={handleCloseNotification}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert 
    onClose={handleCloseNotification} 
    severity="success"
    sx={{ width: '100%' }}
  >
    {scenarioNotification.message}
  </Alert>
</Snackbar>



      {/* Snackbar Notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        TransitionComponent={Fade}
      >
        <Alert
          severity={snackbar.severity}
          sx={{ 
            width: '100%',
            boxShadow: theme.shadows[6],
            alignItems: 'center'
          }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
	      {/* Quantum Purchase Modal */}
<QuantumPurchaseModal
  open={purchaseModalOpen}
  onClose={() => {
    setPurchaseModalOpen(false);
    setSelectedPackage(null); // Reset selection when modal closes
  }}
  onSuccess={handlePurchaseSuccess}
  selectedPackage={selectedPackage} // Pass the selected package
/>

    </Container>
	
  );
};

export default ROIAnalyzer;